/*! For license information please see script.js.LICENSE.txt */
(() => {
    var e = {
        69: function (e) {
            e.exports = function () {
                function e(e, t) {
                    for (var i = 0; i < t.length; i++) {
                        var r = t[i];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
                    }
                }

                function t(t, i, r) {
                    return i && e(t.prototype, i), r && e(t, r), t
                }

                function i() {
                    return (i = Object.assign || function (e) {
                        for (var t = 1; t < arguments.length; t++) {
                            var i = arguments[t];
                            for (var r in i) Object.prototype.hasOwnProperty.call(i, r) && (e[r] = i[r])
                        }
                        return e
                    }).apply(this, arguments)
                }

                function r(e, t) {
                    e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t
                }

                function n(e) {
                    return (n = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
                        return e.__proto__ || Object.getPrototypeOf(e)
                    })(e)
                }

                function s(e, t) {
                    return (s = Object.setPrototypeOf || function (e, t) {
                        return e.__proto__ = t, e
                    })(e, t)
                }

                function a(e, t, i) {
                    return (a = function () {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Date.prototype.toString.call(Reflect.construct(Date, [], (function () { }))), !0
                        } catch (e) {
                            return !1
                        }
                    }() ? Reflect.construct : function (e, t, i) {
                        var r = [null];
                        r.push.apply(r, t);
                        var n = new (Function.bind.apply(e, r));
                        return i && s(n, i.prototype), n
                    }).apply(null, arguments)
                }

                function o(e) {
                    var t = "function" == typeof Map ? new Map : void 0;
                    return (o = function (e) {
                        if (null === e || -1 === Function.toString.call(e).indexOf("[native code]")) return e;
                        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e)) return t.get(e);
                            t.set(e, i)
                        }

                        function i() {
                            return a(e, arguments, n(this).constructor)
                        }
                        return i.prototype = Object.create(e.prototype, {
                            constructor: {
                                value: i,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), s(i, e)
                    })(e)
                }

                function l(e, t) {
                    try {
                        var i = e()
                    } catch (e) {
                        return t(e)
                    }
                    return i && i.then ? i.then(void 0, t) : i
                }
                "undefined" != typeof Symbol && (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))), "undefined" != typeof Symbol && (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")));
                var c;
                ! function (e) {
                    e[e.off = 0] = "off", e[e.error = 1] = "error", e[e.warning = 2] = "warning", e[e.info = 3] = "info", e[e.debug = 4] = "debug"
                }(c || (c = {}));
                var d = c.off,
                    u = function () {
                        function e(e) {
                            this.t = e
                        }
                        e.getLevel = function () {
                            return d
                        }, e.setLevel = function (e) {
                            return d = c[e]
                        };
                        var t = e.prototype;
                        return t.error = function () {
                            for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
                            this.i(console.error, c.error, t)
                        }, t.warn = function () {
                            for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
                            this.i(console.warn, c.warning, t)
                        }, t.info = function () {
                            for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
                            this.i(console.info, c.info, t)
                        }, t.debug = function () {
                            for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
                            this.i(console.log, c.debug, t)
                        }, t.i = function (t, i, r) {
                            i <= e.getLevel() && t.apply(console, ["[" + this.t + "] "].concat(r))
                        }, e
                    }(),
                    h = M,
                    p = _,
                    f = w,
                    m = b,
                    g = S,
                    v = "/",
                    y = new RegExp(["(\\\\.)", "(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?"].join("|"), "g");

                function w(e, t) {
                    for (var i, r = [], n = 0, s = 0, a = "", o = t && t.delimiter || v, l = t && t.whitelist || void 0, c = !1; null !== (i = y.exec(e));) {
                        var d = i[0],
                            u = i[1],
                            h = i.index;
                        if (a += e.slice(s, h), s = h + d.length, u) a += u[1], c = !0;
                        else {
                            var p = "",
                                f = i[2],
                                m = i[3],
                                g = i[4],
                                w = i[5];
                            if (!c && a.length) {
                                var _ = a.length - 1,
                                    b = a[_];
                                (!l || l.indexOf(b) > -1) && (p = b, a = a.slice(0, _))
                            }
                            a && (r.push(a), a = "", c = !1);
                            var E = m || g,
                                S = p || o;
                            r.push({
                                name: f || n++,
                                prefix: p,
                                delimiter: S,
                                optional: "?" === w || "*" === w,
                                repeat: "+" === w || "*" === w,
                                pattern: E ? T(E) : "[^" + x(S === o ? S : S + o) + "]+?"
                            })
                        }
                    }
                    return (a || s < e.length) && r.push(a + e.substr(s)), r
                }

                function _(e, t) {
                    return function (i, r) {
                        var n = e.exec(i);
                        if (!n) return !1;
                        for (var s = n[0], a = n.index, o = {}, l = r && r.decode || decodeURIComponent, c = 1; c < n.length; c++)
                            if (void 0 !== n[c]) {
                                var d = t[c - 1];
                                o[d.name] = d.repeat ? n[c].split(d.delimiter).map((function (e) {
                                    return l(e, d)
                                })) : l(n[c], d)
                            } return {
                                path: s,
                                index: a,
                                params: o
                            }
                    }
                }

                function b(e, t) {
                    for (var i = new Array(e.length), r = 0; r < e.length; r++) "object" == typeof e[r] && (i[r] = new RegExp("^(?:" + e[r].pattern + ")$", E(t)));
                    return function (t, r) {
                        for (var n = "", s = r && r.encode || encodeURIComponent, a = !r || !1 !== r.validate, o = 0; o < e.length; o++) {
                            var l = e[o];
                            if ("string" != typeof l) {
                                var c, d = t ? t[l.name] : void 0;
                                if (Array.isArray(d)) {
                                    if (!l.repeat) throw new TypeError('Expected "' + l.name + '" to not repeat, but got array');
                                    if (0 === d.length) {
                                        if (l.optional) continue;
                                        throw new TypeError('Expected "' + l.name + '" to not be empty')
                                    }
                                    for (var u = 0; u < d.length; u++) {
                                        if (c = s(d[u], l), a && !i[o].test(c)) throw new TypeError('Expected all "' + l.name + '" to match "' + l.pattern + '"');
                                        n += (0 === u ? l.prefix : l.delimiter) + c
                                    }
                                } else if ("string" != typeof d && "number" != typeof d && "boolean" != typeof d) {
                                    if (!l.optional) throw new TypeError('Expected "' + l.name + '" to be ' + (l.repeat ? "an array" : "a string"))
                                } else {
                                    if (c = s(String(d), l), a && !i[o].test(c)) throw new TypeError('Expected "' + l.name + '" to match "' + l.pattern + '", but got "' + c + '"');
                                    n += l.prefix + c
                                }
                            } else n += l
                        }
                        return n
                    }
                }

                function x(e) {
                    return e.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1")
                }

                function T(e) {
                    return e.replace(/([=!:$/()])/g, "\\$1")
                }

                function E(e) {
                    return e && e.sensitive ? "" : "i"
                }

                function S(e, t, i) {
                    for (var r = (i = i || {}).strict, n = !1 !== i.start, s = !1 !== i.end, a = i.delimiter || v, o = [].concat(i.endsWith || []).map(x).concat("$").join("|"), l = n ? "^" : "", c = 0; c < e.length; c++) {
                        var d = e[c];
                        if ("string" == typeof d) l += x(d);
                        else {
                            var u = d.repeat ? "(?:" + d.pattern + ")(?:" + x(d.delimiter) + "(?:" + d.pattern + "))*" : d.pattern;
                            t && t.push(d), l += d.optional ? d.prefix ? "(?:" + x(d.prefix) + "(" + u + "))?" : "(" + u + ")?" : x(d.prefix) + "(" + u + ")"
                        }
                    }
                    if (s) r || (l += "(?:" + x(a) + ")?"), l += "$" === o ? "$" : "(?=" + o + ")";
                    else {
                        var h = e[e.length - 1],
                            p = "string" == typeof h ? h[h.length - 1] === a : void 0 === h;
                        r || (l += "(?:" + x(a) + "(?=" + o + "))?"), p || (l += "(?=" + x(a) + "|" + o + ")")
                    }
                    return new RegExp(l, E(i))
                }

                function M(e, t, i) {
                    return e instanceof RegExp ? function (e, t) {
                        if (!t) return e;
                        var i = e.source.match(/\((?!\?)/g);
                        if (i)
                            for (var r = 0; r < i.length; r++) t.push({
                                name: r,
                                prefix: null,
                                delimiter: null,
                                optional: !1,
                                repeat: !1,
                                pattern: null
                            });
                        return e
                    }(e, t) : Array.isArray(e) ? function (e, t, i) {
                        for (var r = [], n = 0; n < e.length; n++) r.push(M(e[n], t, i).source);
                        return new RegExp("(?:" + r.join("|") + ")", E(i))
                    }(e, t, i) : function (e, t, i) {
                        return S(w(e, i), t, i)
                    }(e, t, i)
                }
                h.match = function (e, t) {
                    var i = [];
                    return _(M(e, i, t), i)
                }, h.regexpToFunction = p, h.parse = f, h.compile = function (e, t) {
                    return b(w(e, t), t)
                }, h.tokensToFunction = m, h.tokensToRegExp = g;
                var P = {
                    container: "container",
                    history: "history",
                    namespace: "namespace",
                    prefix: "data-barba",
                    prevent: "prevent",
                    wrapper: "wrapper"
                },
                    k = new (function () {
                        function e() {
                            this.o = P, this.u = new DOMParser
                        }
                        var t = e.prototype;
                        return t.toString = function (e) {
                            return e.outerHTML
                        }, t.toDocument = function (e) {
                            return this.u.parseFromString(e, "text/html")
                        }, t.toElement = function (e) {
                            var t = document.createElement("div");
                            return t.innerHTML = e, t
                        }, t.getHtml = function (e) {
                            return void 0 === e && (e = document), this.toString(e.documentElement)
                        }, t.getWrapper = function (e) {
                            return void 0 === e && (e = document), e.querySelector("[" + this.o.prefix + '="' + this.o.wrapper + '"]')
                        }, t.getContainer = function (e) {
                            return void 0 === e && (e = document), e.querySelector("[" + this.o.prefix + '="' + this.o.container + '"]')
                        }, t.removeContainer = function (e) {
                            document.body.contains(e) && e.parentNode.removeChild(e)
                        }, t.addContainer = function (e, t) {
                            var i = this.getContainer();
                            i ? this.s(e, i) : t.appendChild(e)
                        }, t.getNamespace = function (e) {
                            void 0 === e && (e = document);
                            var t = e.querySelector("[" + this.o.prefix + "-" + this.o.namespace + "]");
                            return t ? t.getAttribute(this.o.prefix + "-" + this.o.namespace) : null
                        }, t.getHref = function (e) {
                            if (e.tagName && "a" === e.tagName.toLowerCase()) {
                                if ("string" == typeof e.href) return e.href;
                                var t = e.getAttribute("href") || e.getAttribute("xlink:href");
                                if (t) return this.resolveUrl(t.baseVal || t)
                            }
                            return null
                        }, t.resolveUrl = function () {
                            for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
                            var r = t.length;
                            if (0 === r) throw new Error("resolveUrl requires at least one argument; got none.");
                            var n = document.createElement("base");
                            if (n.href = arguments[0], 1 === r) return n.href;
                            var s = document.getElementsByTagName("head")[0];
                            s.insertBefore(n, s.firstChild);
                            for (var a, o = document.createElement("a"), l = 1; l < r; l++) o.href = arguments[l], n.href = a = o.href;
                            return s.removeChild(n), a
                        }, t.s = function (e, t) {
                            t.parentNode.insertBefore(e, t.nextSibling)
                        }, e
                    }()),
                    C = new (function () {
                        function e() {
                            this.h = [], this.v = -1
                        }
                        var r = e.prototype;
                        return r.init = function (e, t) {
                            this.l = "barba";
                            var i = {
                                ns: t,
                                scroll: {
                                    x: window.scrollX,
                                    y: window.scrollY
                                },
                                url: e
                            };
                            this.h.push(i), this.v = 0;
                            var r = {
                                from: this.l,
                                index: 0,
                                states: [].concat(this.h)
                            };
                            window.history && window.history.replaceState(r, "", e)
                        }, r.change = function (e, t, i) {
                            if (i && i.state) {
                                var r = i.state,
                                    n = r.index;
                                t = this.m(this.v - n), this.replace(r.states), this.v = n
                            } else this.add(e, t);
                            return t
                        }, r.add = function (e, t) {
                            var i = this.size,
                                r = this.p(t),
                                n = {
                                    ns: "tmp",
                                    scroll: {
                                        x: window.scrollX,
                                        y: window.scrollY
                                    },
                                    url: e
                                };
                            this.h.push(n), this.v = i;
                            var s = {
                                from: this.l,
                                index: i,
                                states: [].concat(this.h)
                            };
                            switch (r) {
                                case "push":
                                    window.history && window.history.pushState(s, "", e);
                                    break;
                                case "replace":
                                    window.history && window.history.replaceState(s, "", e)
                            }
                        }, r.update = function (e, t) {
                            var r = t || this.v,
                                n = i({}, this.get(r), {}, e);
                            this.set(r, n)
                        }, r.remove = function (e) {
                            e ? this.h.splice(e, 1) : this.h.pop(), this.v--
                        }, r.clear = function () {
                            this.h = [], this.v = -1
                        }, r.replace = function (e) {
                            this.h = e
                        }, r.get = function (e) {
                            return this.h[e]
                        }, r.set = function (e, t) {
                            return this.h[e] = t
                        }, r.p = function (e) {
                            var t = "push",
                                i = e,
                                r = P.prefix + "-" + P.history;
                            return i.hasAttribute && i.hasAttribute(r) && (t = i.getAttribute(r)), t
                        }, r.m = function (e) {
                            return Math.abs(e) > 1 ? e > 0 ? "forward" : "back" : 0 === e ? "popstate" : e > 0 ? "back" : "forward"
                        }, t(e, [{
                            key: "current",
                            get: function () {
                                return this.h[this.v]
                            }
                        }, {
                            key: "state",
                            get: function () {
                                return this.h[this.h.length - 1]
                            }
                        }, {
                            key: "previous",
                            get: function () {
                                return this.v < 1 ? null : this.h[this.v - 1]
                            }
                        }, {
                            key: "size",
                            get: function () {
                                return this.h.length
                            }
                        }]), e
                    }()),
                    L = function (e, t) {
                        try {
                            var i = function () {
                                if (!t.next.html) return Promise.resolve(e).then((function (e) {
                                    var i = t.next;
                                    if (e) {
                                        var r = k.toElement(e);
                                        i.namespace = k.getNamespace(r), i.container = k.getContainer(r), i.html = e, C.update({
                                            ns: i.namespace
                                        });
                                        var n = k.toDocument(e);
                                        document.title = n.title
                                    }
                                }))
                            }();
                            return Promise.resolve(i && i.then ? i.then((function () { })) : void 0)
                        } catch (e) {
                            return Promise.reject(e)
                        }
                    },
                    O = h,
                    A = {
                        __proto__: null,
                        update: L,
                        nextTick: function () {
                            return new Promise((function (e) {
                                window.requestAnimationFrame(e)
                            }))
                        },
                        pathToRegexp: O
                    },
                    D = function () {
                        return window.location.origin
                    },
                    I = function (e) {
                        return void 0 === e && (e = window.location.href), z(e).port
                    },
                    z = function (e) {
                        var t, i = e.match(/:\d+/);
                        if (null === i) /^http/.test(e) && (t = 80), /^https/.test(e) && (t = 443);
                        else {
                            var r = i[0].substring(1);
                            t = parseInt(r, 10)
                        }
                        var n, s = e.replace(D(), ""),
                            a = {},
                            o = s.indexOf("#");
                        o >= 0 && (n = s.slice(o + 1), s = s.slice(0, o));
                        var l = s.indexOf("?");
                        return l >= 0 && (a = R(s.slice(l + 1)), s = s.slice(0, l)), {
                            hash: n,
                            path: s,
                            port: t,
                            query: a
                        }
                    },
                    R = function (e) {
                        return e.split("&").reduce((function (e, t) {
                            var i = t.split("=");
                            return e[i[0]] = i[1], e
                        }), {})
                    },
                    B = function (e) {
                        return void 0 === e && (e = window.location.href), e.replace(/(\/#.*|\/|#.*)$/, "")
                    },
                    F = {
                        __proto__: null,
                        getHref: function () {
                            return window.location.href
                        },
                        getOrigin: D,
                        getPort: I,
                        getPath: function (e) {
                            return void 0 === e && (e = window.location.href), z(e).path
                        },
                        parse: z,
                        parseQuery: R,
                        clean: B
                    };

                function N(e, t, i) {
                    return void 0 === t && (t = 2e3), new Promise((function (r, n) {
                        var s = new XMLHttpRequest;
                        s.onreadystatechange = function () {
                            if (s.readyState === XMLHttpRequest.DONE)
                                if (200 === s.status) r(s.responseText);
                                else if (s.status) {
                                    var t = {
                                        status: s.status,
                                        statusText: s.statusText
                                    };
                                    i(e, t), n(t)
                                }
                        }, s.ontimeout = function () {
                            var r = new Error("Timeout error [" + t + "]");
                            i(e, r), n(r)
                        }, s.onerror = function () {
                            var t = new Error("Fetch error");
                            i(e, t), n(t)
                        }, s.open("GET", e), s.timeout = t, s.setRequestHeader("Accept", "text/html,application/xhtml+xml,application/xml"), s.setRequestHeader("x-barba", "yes"), s.send()
                    }))
                }

                function j(e, t) {
                    return void 0 === t && (t = {}),
                        function () {
                            for (var i = arguments.length, r = new Array(i), n = 0; n < i; n++) r[n] = arguments[n];
                            var s = !1,
                                a = new Promise((function (i, n) {
                                    t.async = function () {
                                        return s = !0,
                                            function (e, t) {
                                                e ? n(e) : i(t)
                                            }
                                    };
                                    var a = e.apply(t, r);
                                    s || (function (e) {
                                        return !!e && ("object" == typeof e || "function" == typeof e) && "function" == typeof e.then
                                    }(a) ? a.then(i, n) : i(a))
                                }));
                            return a
                        }
                }
                var H = new (function (e) {
                    function t() {
                        var t;
                        return (t = e.call(this) || this).logger = new u("@barba/core"), t.all = ["ready", "page", "reset", "currentAdded", "currentRemoved", "nextAdded", "nextRemoved", "beforeOnce", "once", "afterOnce", "before", "beforeLeave", "leave", "afterLeave", "beforeEnter", "enter", "afterEnter", "after"], t.registered = new Map, t.init(), t
                    }
                    r(t, e);
                    var i = t.prototype;
                    return i.init = function () {
                        var e = this;
                        this.registered.clear(), this.all.forEach((function (t) {
                            e[t] || (e[t] = function (i, r) {
                                e.registered.has(t) || e.registered.set(t, new Set), e.registered.get(t).add({
                                    ctx: r || {},
                                    fn: i
                                })
                            })
                        }))
                    }, i.do = function (e) {
                        for (var t = this, i = arguments.length, r = new Array(i > 1 ? i - 1 : 0), n = 1; n < i; n++) r[n - 1] = arguments[n];
                        if (this.registered.has(e)) {
                            var s = Promise.resolve();
                            return this.registered.get(e).forEach((function (e) {
                                s = s.then((function () {
                                    return j(e.fn, e.ctx).apply(void 0, r)
                                }))
                            })), s.catch((function (i) {
                                t.logger.debug("Hook error [" + e + "]"), t.logger.error(i)
                            }))
                        }
                        return Promise.resolve()
                    }, i.clear = function () {
                        var e = this;
                        this.all.forEach((function (t) {
                            delete e[t]
                        })), this.init()
                    }, i.help = function () {
                        this.logger.info("Available hooks: " + this.all.join(","));
                        var e = [];
                        this.registered.forEach((function (t, i) {
                            return e.push(i)
                        })), this.logger.info("Registered hooks: " + e.join(","))
                    }, t
                }((function () { }))),
                    G = function () {
                        function e(e) {
                            if (this.P = [], "boolean" == typeof e) this.g = e;
                            else {
                                var t = Array.isArray(e) ? e : [e];
                                this.P = t.map((function (e) {
                                    return O(e)
                                }))
                            }
                        }
                        return e.prototype.checkHref = function (e) {
                            if ("boolean" == typeof this.g) return this.g;
                            var t = z(e).path;
                            return this.P.some((function (e) {
                                return null !== e.exec(t)
                            }))
                        }, e
                    }(),
                    Y = function (e) {
                        function t(t) {
                            var i;
                            return (i = e.call(this, t) || this).k = new Map, i
                        }
                        r(t, e);
                        var n = t.prototype;
                        return n.set = function (e, t, i) {
                            return this.k.set(e, {
                                action: i,
                                request: t
                            }), {
                                action: i,
                                request: t
                            }
                        }, n.get = function (e) {
                            return this.k.get(e)
                        }, n.getRequest = function (e) {
                            return this.k.get(e).request
                        }, n.getAction = function (e) {
                            return this.k.get(e).action
                        }, n.has = function (e) {
                            return !this.checkHref(e) && this.k.has(e)
                        }, n.delete = function (e) {
                            return this.k.delete(e)
                        }, n.update = function (e, t) {
                            var r = i({}, this.k.get(e), {}, t);
                            return this.k.set(e, r), r
                        }, t
                    }(G),
                    X = function () {
                        return !window.history.pushState
                    },
                    V = function (e) {
                        return !e.el || !e.href
                    },
                    q = function (e) {
                        var t = e.event;
                        return t.which > 1 || t.metaKey || t.ctrlKey || t.shiftKey || t.altKey
                    },
                    $ = function (e) {
                        var t = e.el;
                        return t.hasAttribute("target") && "_blank" === t.target
                    },
                    W = function (e) {
                        var t = e.el;
                        return void 0 !== t.protocol && window.location.protocol !== t.protocol || void 0 !== t.hostname && window.location.hostname !== t.hostname
                    },
                    U = function (e) {
                        var t = e.el;
                        return void 0 !== t.port && I() !== I(t.href)
                    },
                    K = function (e) {
                        var t = e.el;
                        return t.getAttribute && "string" == typeof t.getAttribute("download")
                    },
                    Z = function (e) {
                        return e.el.hasAttribute(P.prefix + "-" + P.prevent)
                    },
                    Q = function (e) {
                        return Boolean(e.el.closest("[" + P.prefix + "-" + P.prevent + '="all"]'))
                    },
                    J = function (e) {
                        var t = e.href;
                        return B(t) === B() && I(t) === I()
                    },
                    ee = function (e) {
                        function t(t) {
                            var i;
                            return (i = e.call(this, t) || this).suite = [], i.tests = new Map, i.init(), i
                        }
                        r(t, e);
                        var i = t.prototype;
                        return i.init = function () {
                            this.add("pushState", X), this.add("exists", V), this.add("newTab", q), this.add("blank", $), this.add("corsDomain", W), this.add("corsPort", U), this.add("download", K), this.add("preventSelf", Z), this.add("preventAll", Q), this.add("sameUrl", J, !1)
                        }, i.add = function (e, t, i) {
                            void 0 === i && (i = !0), this.tests.set(e, t), i && this.suite.push(e)
                        }, i.run = function (e, t, i, r) {
                            return this.tests.get(e)({
                                el: t,
                                event: i,
                                href: r
                            })
                        }, i.checkLink = function (e, t, i) {
                            var r = this;
                            return this.suite.some((function (n) {
                                return r.run(n, e, t, i)
                            }))
                        }, t
                    }(G),
                    te = function (e) {
                        function t(i, r) {
                            var n;
                            void 0 === r && (r = "Barba error");
                            for (var s = arguments.length, a = new Array(s > 2 ? s - 2 : 0), o = 2; o < s; o++) a[o - 2] = arguments[o];
                            return (n = e.call.apply(e, [this].concat(a)) || this).error = i, n.label = r, Error.captureStackTrace && Error.captureStackTrace(function (e) {
                                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                return e
                            }(n), t), n.name = "BarbaError", n
                        }
                        return r(t, e), t
                    }(o(Error)),
                    ie = function () {
                        function e(e) {
                            void 0 === e && (e = []), this.logger = new u("@barba/core"), this.all = [], this.page = [], this.once = [], this.A = [{
                                name: "namespace",
                                type: "strings"
                            }, {
                                name: "custom",
                                type: "function"
                            }], e && (this.all = this.all.concat(e)), this.update()
                        }
                        var t = e.prototype;
                        return t.add = function (e, t) {
                            "rule" === e ? this.A.splice(t.position || 0, 0, t.value) : this.all.push(t), this.update()
                        }, t.resolve = function (e, t) {
                            var i = this;
                            void 0 === t && (t = {});
                            var r = t.once ? this.once : this.page;
                            r = r.filter(t.self ? function (e) {
                                return e.name && "self" === e.name
                            } : function (e) {
                                return !e.name || "self" !== e.name
                            });
                            var n = new Map,
                                s = r.find((function (r) {
                                    var s = !0,
                                        a = {};
                                    return !(!t.self || "self" !== r.name) || (i.A.reverse().forEach((function (t) {
                                        s && (s = i.R(r, t, e, a), r.from && r.to && (s = i.R(r, t, e, a, "from") && i.R(r, t, e, a, "to")), r.from && !r.to && (s = i.R(r, t, e, a, "from")), !r.from && r.to && (s = i.R(r, t, e, a, "to")))
                                    })), n.set(r, a), s)
                                })),
                                a = n.get(s),
                                o = [];
                            if (o.push(t.once ? "once" : "page"), t.self && o.push("self"), a) {
                                var l, c = [s];
                                Object.keys(a).length > 0 && c.push(a), (l = this.logger).info.apply(l, ["Transition found [" + o.join(",") + "]"].concat(c))
                            } else this.logger.info("No transition found [" + o.join(",") + "]");
                            return s
                        }, t.update = function () {
                            var e = this;
                            this.all = this.all.map((function (t) {
                                return e.T(t)
                            })).sort((function (e, t) {
                                return e.priority - t.priority
                            })).reverse().map((function (e) {
                                return delete e.priority, e
                            })), this.page = this.all.filter((function (e) {
                                return void 0 !== e.leave || void 0 !== e.enter
                            })), this.once = this.all.filter((function (e) {
                                return void 0 !== e.once
                            }))
                        }, t.R = function (e, t, i, r, n) {
                            var s = !0,
                                a = !1,
                                o = e,
                                l = t.name,
                                c = l,
                                d = l,
                                u = l,
                                h = n ? o[n] : o,
                                p = "to" === n ? i.next : i.current;
                            if (n ? h && h[l] : h[l]) {
                                switch (t.type) {
                                    case "strings":
                                    default:
                                        var f = Array.isArray(h[c]) ? h[c] : [h[c]];
                                        p[c] && -1 !== f.indexOf(p[c]) && (a = !0), -1 === f.indexOf(p[c]) && (s = !1);
                                        break;
                                    case "object":
                                        var m = Array.isArray(h[d]) ? h[d] : [h[d]];
                                        p[d] ? (p[d].name && -1 !== m.indexOf(p[d].name) && (a = !0), -1 === m.indexOf(p[d].name) && (s = !1)) : s = !1;
                                        break;
                                    case "function":
                                        h[u](i) ? a = !0 : s = !1
                                }
                                a && (n ? (r[n] = r[n] || {}, r[n][l] = o[n][l]) : r[l] = o[l])
                            }
                            return s
                        }, t.O = function (e, t, i) {
                            var r = 0;
                            return (e[t] || e.from && e.from[t] || e.to && e.to[t]) && (r += Math.pow(10, i), e.from && e.from[t] && (r += 1), e.to && e.to[t] && (r += 2)), r
                        }, t.T = function (e) {
                            var t = this;
                            e.priority = 0;
                            var i = 0;
                            return this.A.forEach((function (r, n) {
                                i += t.O(e, r.name, n + 1)
                            })), e.priority = i, e
                        }, e
                    }(),
                    re = function () {
                        function e(e) {
                            void 0 === e && (e = []), this.logger = new u("@barba/core"), this.S = !1, this.store = new ie(e)
                        }
                        var i = e.prototype;
                        return i.get = function (e, t) {
                            return this.store.resolve(e, t)
                        }, i.doOnce = function (e) {
                            var t = e.data,
                                i = e.transition;
                            try {
                                var r = function () {
                                    n.S = !1
                                },
                                    n = this,
                                    s = i || {};
                                n.S = !0;
                                var a = l((function () {
                                    return Promise.resolve(n.j("beforeOnce", t, s)).then((function () {
                                        return Promise.resolve(n.once(t, s)).then((function () {
                                            return Promise.resolve(n.j("afterOnce", t, s)).then((function () { }))
                                        }))
                                    }))
                                }), (function (e) {
                                    n.S = !1, n.logger.debug("Transition error [before/after/once]"), n.logger.error(e)
                                }));
                                return Promise.resolve(a && a.then ? a.then(r) : r())
                            } catch (e) {
                                return Promise.reject(e)
                            }
                        }, i.doPage = function (e) {
                            var t = e.data,
                                i = e.transition,
                                r = e.page,
                                n = e.wrapper;
                            try {
                                var s = function (e) {
                                    if (a) return e;
                                    o.S = !1
                                },
                                    a = !1,
                                    o = this,
                                    c = i || {},
                                    d = !0 === c.sync || !1;
                                o.S = !0;
                                var u = l((function () {
                                    function e() {
                                        return Promise.resolve(o.j("before", t, c)).then((function () {
                                            function e(e) {
                                                return Promise.resolve(o.remove(t)).then((function () {
                                                    return Promise.resolve(o.j("after", t, c)).then((function () { }))
                                                }))
                                            }
                                            var i = function () {
                                                if (d) return l((function () {
                                                    return Promise.resolve(o.add(t, n)).then((function () {
                                                        return Promise.resolve(o.j("beforeLeave", t, c)).then((function () {
                                                            return Promise.resolve(o.j("beforeEnter", t, c)).then((function () {
                                                                return Promise.resolve(Promise.all([o.leave(t, c), o.enter(t, c)])).then((function () {
                                                                    return Promise.resolve(o.j("afterLeave", t, c)).then((function () {
                                                                        return Promise.resolve(o.j("afterEnter", t, c)).then((function () { }))
                                                                    }))
                                                                }))
                                                            }))
                                                        }))
                                                    }))
                                                }), (function (e) {
                                                    if (o.M(e)) throw new te(e, "Transition error [sync]")
                                                }));
                                                var e = function (e) {
                                                    return l((function () {
                                                        var e = function () {
                                                            if (!1 !== i) return Promise.resolve(o.add(t, n)).then((function () {
                                                                return Promise.resolve(o.j("beforeEnter", t, c)).then((function () {
                                                                    return Promise.resolve(o.enter(t, c, i)).then((function () {
                                                                        return Promise.resolve(o.j("afterEnter", t, c)).then((function () { }))
                                                                    }))
                                                                }))
                                                            }))
                                                        }();
                                                        if (e && e.then) return e.then((function () { }))
                                                    }), (function (e) {
                                                        if (o.M(e)) throw new te(e, "Transition error [before/after/enter]")
                                                    }))
                                                },
                                                    i = !1,
                                                    s = l((function () {
                                                        return Promise.resolve(o.j("beforeLeave", t, c)).then((function () {
                                                            return Promise.resolve(Promise.all([o.leave(t, c), L(r, t)]).then((function (e) {
                                                                return e[0]
                                                            }))).then((function (e) {
                                                                return i = e, Promise.resolve(o.j("afterLeave", t, c)).then((function () { }))
                                                            }))
                                                        }))
                                                    }), (function (e) {
                                                        if (o.M(e)) throw new te(e, "Transition error [before/after/leave]")
                                                    }));
                                                return s && s.then ? s.then(e) : e()
                                            }();
                                            return i && i.then ? i.then(e) : e()
                                        }))
                                    }
                                    var i = function () {
                                        if (d) return Promise.resolve(L(r, t)).then((function () { }))
                                    }();
                                    return i && i.then ? i.then(e) : e()
                                }), (function (e) {
                                    if (o.S = !1, e.name && "BarbaError" === e.name) throw o.logger.debug(e.label), o.logger.error(e.error), e;
                                    throw o.logger.debug("Transition error [page]"), o.logger.error(e), e
                                }));
                                return Promise.resolve(u && u.then ? u.then(s) : s(u))
                            } catch (e) {
                                return Promise.reject(e)
                            }
                        }, i.once = function (e, t) {
                            try {
                                return Promise.resolve(H.do("once", e, t)).then((function () {
                                    return t.once ? j(t.once, t)(e) : Promise.resolve()
                                }))
                            } catch (e) {
                                return Promise.reject(e)
                            }
                        }, i.leave = function (e, t) {
                            try {
                                return Promise.resolve(H.do("leave", e, t)).then((function () {
                                    return t.leave ? j(t.leave, t)(e) : Promise.resolve()
                                }))
                            } catch (e) {
                                return Promise.reject(e)
                            }
                        }, i.enter = function (e, t, i) {
                            try {
                                return Promise.resolve(H.do("enter", e, t)).then((function () {
                                    return t.enter ? j(t.enter, t)(e, i) : Promise.resolve()
                                }))
                            } catch (e) {
                                return Promise.reject(e)
                            }
                        }, i.add = function (e, t) {
                            try {
                                return k.addContainer(e.next.container, t), H.do("nextAdded", e), Promise.resolve()
                            } catch (e) {
                                return Promise.reject(e)
                            }
                        }, i.remove = function (e) {
                            try {
                                return k.removeContainer(e.current.container), H.do("currentRemoved", e), Promise.resolve()
                            } catch (e) {
                                return Promise.reject(e)
                            }
                        }, i.M = function (e) {
                            return e.message ? !/Timeout error|Fetch error/.test(e.message) : !e.status
                        }, i.j = function (e, t, i) {
                            try {
                                return Promise.resolve(H.do(e, t, i)).then((function () {
                                    return i[e] ? j(i[e], i)(t) : Promise.resolve()
                                }))
                            } catch (e) {
                                return Promise.reject(e)
                            }
                        }, t(e, [{
                            key: "isRunning",
                            get: function () {
                                return this.S
                            },
                            set: function (e) {
                                this.S = e
                            }
                        }, {
                            key: "hasOnce",
                            get: function () {
                                return this.store.once.length > 0
                            }
                        }, {
                            key: "hasSelf",
                            get: function () {
                                return this.store.all.some((function (e) {
                                    return "self" === e.name
                                }))
                            }
                        }, {
                            key: "shouldWait",
                            get: function () {
                                return this.store.all.some((function (e) {
                                    return e.to && !e.to.route || e.sync
                                }))
                            }
                        }]), e
                    }(),
                    ne = function () {
                        function e(e) {
                            var t = this;
                            this.names = ["beforeLeave", "afterLeave", "beforeEnter", "afterEnter"], this.byNamespace = new Map, 0 !== e.length && (e.forEach((function (e) {
                                t.byNamespace.set(e.namespace, e)
                            })), this.names.forEach((function (e) {
                                H[e](t.L(e))
                            })))
                        }
                        return e.prototype.L = function (e) {
                            var t = this;
                            return function (i) {
                                var r = e.match(/enter/i) ? i.next : i.current,
                                    n = t.byNamespace.get(r.namespace);
                                return n && n[e] ? j(n[e], n)(i) : Promise.resolve()
                            }
                        }, e
                    }();
                Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), Element.prototype.closest || (Element.prototype.closest = function (e) {
                    var t = this;
                    do {
                        if (t.matches(e)) return t;
                        t = t.parentElement || t.parentNode
                    } while (null !== t && 1 === t.nodeType);
                    return null
                });
                var se = {
                    container: null,
                    html: "",
                    namespace: "",
                    url: {
                        hash: "",
                        href: "",
                        path: "",
                        port: null,
                        query: {}
                    }
                };
                return new (function () {
                    function e() {
                        this.version = "2.9.7", this.schemaPage = se, this.Logger = u, this.logger = new u("@barba/core"), this.plugins = [], this.hooks = H, this.dom = k, this.helpers = A, this.history = C, this.request = N, this.url = F
                    }
                    var r = e.prototype;
                    return r.use = function (e, t) {
                        var i = this.plugins;
                        i.indexOf(e) > -1 ? this.logger.warn("Plugin [" + e.name + "] already installed.") : "function" == typeof e.install ? (e.install(this, t), i.push(e)) : this.logger.warn("Plugin [" + e.name + '] has no "install" method.')
                    }, r.init = function (e) {
                        var t = void 0 === e ? {} : e,
                            r = t.transitions,
                            n = void 0 === r ? [] : r,
                            s = t.views,
                            a = void 0 === s ? [] : s,
                            o = t.schema,
                            l = void 0 === o ? P : o,
                            c = t.requestError,
                            d = t.timeout,
                            h = void 0 === d ? 2e3 : d,
                            p = t.cacheIgnore,
                            f = void 0 !== p && p,
                            m = t.prefetchIgnore,
                            g = void 0 !== m && m,
                            v = t.preventRunning,
                            y = void 0 !== v && v,
                            w = t.prevent,
                            _ = void 0 === w ? null : w,
                            b = t.debug,
                            x = t.logLevel;
                        if (u.setLevel(!0 === (void 0 !== b && b) ? "debug" : void 0 === x ? "off" : x), this.logger.info(this.version), Object.keys(l).forEach((function (e) {
                            P[e] && (P[e] = l[e])
                        })), this.$ = c, this.timeout = h, this.cacheIgnore = f, this.prefetchIgnore = g, this.preventRunning = y, this._ = this.dom.getWrapper(), !this._) throw new Error("[@barba/core] No Barba wrapper found");
                        this._.setAttribute("aria-live", "polite"), this.q();
                        var T = this.data.current;
                        if (!T.container) throw new Error("[@barba/core] No Barba container found");
                        if (this.cache = new Y(f), this.prevent = new ee(g), this.transitions = new re(n), this.views = new ne(a), null !== _) {
                            if ("function" != typeof _) throw new Error("[@barba/core] Prevent should be a function");
                            this.prevent.add("preventCustom", _)
                        }
                        this.history.init(T.url.href, T.namespace), this.B = this.B.bind(this), this.U = this.U.bind(this), this.D = this.D.bind(this), this.F(), this.plugins.forEach((function (e) {
                            return e.init()
                        }));
                        var E = this.data;
                        E.trigger = "barba", E.next = E.current, E.current = i({}, this.schemaPage), this.hooks.do("ready", E), this.once(E), this.q()
                    }, r.destroy = function () {
                        this.q(), this.H(), this.history.clear(), this.hooks.clear(), this.plugins = []
                    }, r.force = function (e) {
                        window.location.assign(e)
                    }, r.go = function (e, t, i) {
                        var r;
                        if (void 0 === t && (t = "barba"), this.transitions.isRunning) this.force(e);
                        else if (!(r = "popstate" === t ? this.history.current && this.url.getPath(this.history.current.url) === this.url.getPath(e) : this.prevent.run("sameUrl", null, null, e)) || this.transitions.hasSelf) return t = this.history.change(e, t, i), this.page(e, t, r)
                    }, r.once = function (e) {
                        try {
                            var t = this;
                            return Promise.resolve(t.hooks.do("beforeEnter", e)).then((function () {
                                function i() {
                                    return Promise.resolve(t.hooks.do("afterEnter", e)).then((function () { }))
                                }
                                var r = function () {
                                    if (t.transitions.hasOnce) {
                                        var i = t.transitions.get(e, {
                                            once: !0
                                        });
                                        return Promise.resolve(t.transitions.doOnce({
                                            transition: i,
                                            data: e
                                        })).then((function () { }))
                                    }
                                }();
                                return r && r.then ? r.then(i) : i()
                            }))
                        } catch (e) {
                            return Promise.reject(e)
                        }
                    }, r.page = function (e, t, r) {
                        try {
                            var n = function () {
                                var e = s.data;
                                return Promise.resolve(s.hooks.do("page", e)).then((function () {
                                    var t = l((function () {
                                        var t = s.transitions.get(e, {
                                            once: !1,
                                            self: r
                                        });
                                        return Promise.resolve(s.transitions.doPage({
                                            data: e,
                                            page: a,
                                            transition: t,
                                            wrapper: s._
                                        })).then((function () {
                                            s.q()
                                        }))
                                    }), (function () {
                                        0 === u.getLevel() && s.force(e.current.url.href)
                                    }));
                                    if (t && t.then) return t.then((function () { }))
                                }))
                            },
                                s = this;
                            s.data.next.url = i({
                                href: e
                            }, s.url.parse(e)), s.data.trigger = t;
                            var a = s.cache.has(e) ? s.cache.update(e, {
                                action: "click"
                            }).request : s.cache.set(e, s.request(e, s.timeout, s.onRequestError.bind(s, t)), "click").request,
                                o = function () {
                                    if (s.transitions.shouldWait) return Promise.resolve(L(a, s.data)).then((function () { }))
                                }();
                            return Promise.resolve(o && o.then ? o.then(n) : n())
                        } catch (e) {
                            return Promise.reject(e)
                        }
                    }, r.onRequestError = function (e) {
                        this.transitions.isRunning = !1;
                        for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) i[r - 1] = arguments[r];
                        var n = i[0],
                            s = i[1],
                            a = this.cache.getAction(n);
                        return this.cache.delete(n), !(this.$ && !1 === this.$(e, a, n, s) || ("click" === a && this.force(n), 1))
                    }, r.prefetch = function (e) {
                        var t = this;
                        this.cache.has(e) || this.cache.set(e, this.request(e, this.timeout, this.onRequestError.bind(this, "barba")).catch((function (e) {
                            t.logger.error(e)
                        })), "prefetch")
                    }, r.F = function () {
                        !0 !== this.prefetchIgnore && (document.addEventListener("mouseover", this.B), document.addEventListener("touchstart", this.B)), document.addEventListener("click", this.U), window.addEventListener("popstate", this.D)
                    }, r.H = function () {
                        !0 !== this.prefetchIgnore && (document.removeEventListener("mouseover", this.B), document.removeEventListener("touchstart", this.B)), document.removeEventListener("click", this.U), window.removeEventListener("popstate", this.D)
                    }, r.B = function (e) {
                        var t = this,
                            i = this.I(e);
                        if (i) {
                            var r = this.dom.getHref(i);
                            this.prevent.checkHref(r) || this.cache.has(r) || this.cache.set(r, this.request(r, this.timeout, this.onRequestError.bind(this, i)).catch((function (e) {
                                t.logger.error(e)
                            })), "enter")
                        }
                    }, r.U = function (e) {
                        var t = this.I(e);
                        // if (t) return this.transitions.isRunning && this.preventRunning ? (e.preventDefault(), void e.stopPropagation()) : void this.go(this.dom.getHref(t), t, e)
                    }, r.D = function (e) {
                        this.go(this.url.getHref(), "popstate", e)
                    }, r.I = function (e) {
                        for (var t = e.target; t && !this.dom.getHref(t);) t = t.parentNode;
                        if (t && !this.prevent.checkLink(t, e, this.dom.getHref(t))) return t
                    }, r.q = function () {
                        var e = this.url.getHref(),
                            t = {
                                container: this.dom.getContainer(),
                                html: this.dom.getHtml(),
                                namespace: this.dom.getNamespace(),
                                url: i({
                                    href: e
                                }, this.url.parse(e))
                            };
                        this.C = {
                            current: t,
                            next: i({}, this.schemaPage),
                            trigger: void 0
                        }, this.hooks.do("reset", this.data)
                    }, t(e, [{
                        key: "data",
                        get: function () {
                            return this.C
                        }
                    }, {
                        key: "wrapper",
                        get: function () {
                            return this._
                        }
                    }]), e
                }())
            }()
        }
    },
        t = {};

    function i(r) {
        var n = t[r];
        if (void 0 !== n) return n.exports;
        var s = t[r] = {
            exports: {}
        };
        return e[r].call(s.exports, s, s.exports, i), s.exports
    }
    i.n = e => {
        var t = e && e.__esModule ? () => e.default : () => e;
        return i.d(t, {
            a: t
        }), t
    }, i.d = (e, t) => {
        for (var r in t) i.o(t, r) && !i.o(e, r) && Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        })
    }, i.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), (() => {
        "use strict";
        var e = i(69),
            t = i.n(e);
        const r = (e, t = document) => t.querySelectorAll(e),
            n = (e, t = document) => t.querySelector(e),
            s = (/^((?!chrome|android).)*safari/i.test(navigator.userAgent), "ontouchstart" in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0),
            a = (e, t) => {
                let i = (new Date).getTime(),
                    r = {};
                const n = () => {
                    r.value = requestAnimationFrame(n), (new Date).getTime() - i >= t && (e.call(), i = (new Date).getTime())
                };
                return r.value = requestAnimationFrame(n), r
            };

        function o(e) {
            return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object
        }

        function l(e, t) {
            void 0 === e && (e = {}), void 0 === t && (t = {}), Object.keys(t).forEach((i => {
                void 0 === e[i] ? e[i] = t[i] : o(t[i]) && o(e[i]) && Object.keys(t[i]).length > 0 && l(e[i], t[i])
            }))
        }
        const c = {
            body: {},
            addEventListener() { },
            removeEventListener() { },
            activeElement: {
                blur() { },
                nodeName: ""
            },
            querySelector: () => null,
            querySelectorAll: () => [],
            getElementById: () => null,
            createEvent: () => ({
                initEvent() { }
            }),
            createElement: () => ({
                children: [],
                childNodes: [],
                style: {},
                setAttribute() { },
                getElementsByTagName: () => []
            }),
            createElementNS: () => ({}),
            importNode: () => null,
            location: {
                hash: "",
                host: "",
                hostname: "",
                href: "",
                origin: "",
                pathname: "",
                protocol: "",
                search: ""
            }
        };

        function d() {
            const e = "undefined" != typeof document ? document : {};
            return l(e, c), e
        }
        const u = {
            document: c,
            navigator: {
                userAgent: ""
            },
            location: {
                hash: "",
                host: "",
                hostname: "",
                href: "",
                origin: "",
                pathname: "",
                protocol: "",
                search: ""
            },
            history: {
                replaceState() { },
                pushState() { },
                go() { },
                back() { }
            },
            CustomEvent: function () {
                return this
            },
            addEventListener() { },
            removeEventListener() { },
            getComputedStyle: () => ({
                getPropertyValue: () => ""
            }),
            Image() { },
            Date() { },
            screen: {},
            setTimeout() { },
            clearTimeout() { },
            matchMedia: () => ({}),
            requestAnimationFrame: e => "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0),
            cancelAnimationFrame(e) {
                "undefined" != typeof setTimeout && clearTimeout(e)
            }
        };

        function h() {
            const e = "undefined" != typeof window ? window : {};
            return l(e, u), e
        }

        function p(e, t) {
            return void 0 === t && (t = 0), setTimeout(e, t)
        }

        function f() {
            return Date.now()
        }

        function m(e) {
            return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1)
        }

        function g() {
            const e = Object(arguments.length <= 0 ? void 0 : arguments[0]),
                t = ["__proto__", "constructor", "prototype"];
            for (let r = 1; r < arguments.length; r += 1) {
                const n = r < 0 || arguments.length <= r ? void 0 : arguments[r];
                if (null != n && (i = n, !("undefined" != typeof window && void 0 !== window.HTMLElement ? i instanceof HTMLElement : i && (1 === i.nodeType || 11 === i.nodeType)))) {
                    const i = Object.keys(Object(n)).filter((e => t.indexOf(e) < 0));
                    for (let t = 0, r = i.length; t < r; t += 1) {
                        const r = i[t],
                            s = Object.getOwnPropertyDescriptor(n, r);
                        void 0 !== s && s.enumerable && (m(e[r]) && m(n[r]) ? n[r].__swiper__ ? e[r] = n[r] : g(e[r], n[r]) : !m(e[r]) && m(n[r]) ? (e[r] = {}, n[r].__swiper__ ? e[r] = n[r] : g(e[r], n[r])) : e[r] = n[r])
                    }
                }
            }
            var i;
            return e
        }

        function v(e, t, i) {
            e.style.setProperty(t, i)
        }

        function y(e) {
            let {
                swiper: t,
                targetPosition: i,
                side: r
            } = e;
            const n = h(),
                s = -t.translate;
            let a, o = null;
            const l = t.params.speed;
            t.wrapperEl.style.scrollSnapType = "none", n.cancelAnimationFrame(t.cssModeFrameID);
            const c = i > s ? "next" : "prev",
                d = (e, t) => "next" === c && e >= t || "prev" === c && e <= t,
                u = () => {
                    a = (new Date).getTime(), null === o && (o = a);
                    const e = Math.max(Math.min((a - o) / l, 1), 0),
                        c = .5 - Math.cos(e * Math.PI) / 2;
                    let h = s + c * (i - s);
                    if (d(h, i) && (h = i), t.wrapperEl.scrollTo({
                        [r]: h
                    }), d(h, i)) return t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout((() => {
                        t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({
                            [r]: h
                        })
                    })), void n.cancelAnimationFrame(t.cssModeFrameID);
                    t.cssModeFrameID = n.requestAnimationFrame(u)
                };
            u()
        }

        function w(e) {
            return e.querySelector(".swiper-slide-transform") || e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform") || e
        }

        function _(e, t) {
            return void 0 === t && (t = ""), [...e.children].filter((e => e.matches(t)))
        }

        function b(e) {
            try {
                return void console.warn(e)
            } catch (e) { }
        }

        function x(e, t) {
            void 0 === t && (t = []);
            const i = document.createElement(e);
            return i.classList.add(...Array.isArray(t) ? t : function (e) {
                return void 0 === e && (e = ""), e.trim().split(" ").filter((e => !!e.trim()))
            }(t)), i
        }

        function T(e, t) {
            return h().getComputedStyle(e, null).getPropertyValue(t)
        }

        function E(e) {
            let t, i = e;
            if (i) {
                for (t = 0; null !== (i = i.previousSibling);) 1 === i.nodeType && (t += 1);
                return t
            }
        }

        function S(e, t) {
            t && e.addEventListener("transitionend", (function i(r) {
                r.target === e && (t.call(e, r), e.removeEventListener("transitionend", i))
            }))
        }

        function M(e, t, i) {
            const r = h();
            return i ? e["width" === t ? "offsetWidth" : "offsetHeight"] + parseFloat(r.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-right" : "margin-top")) + parseFloat(r.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-left" : "margin-bottom")) : e.offsetWidth
        }
        let P, k, C;

        function L() {
            return P || (P = function () {
                const e = h(),
                    t = d();
                return {
                    smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
                    touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch)
                }
            }()), P
        }
        var O = {
            on(e, t, i) {
                const r = this;
                if (!r.eventsListeners || r.destroyed) return r;
                if ("function" != typeof t) return r;
                const n = i ? "unshift" : "push";
                return e.split(" ").forEach((e => {
                    r.eventsListeners[e] || (r.eventsListeners[e] = []), r.eventsListeners[e][n](t)
                })), r
            },
            once(e, t, i) {
                const r = this;
                if (!r.eventsListeners || r.destroyed) return r;
                if ("function" != typeof t) return r;

                function n() {
                    r.off(e, n), n.__emitterProxy && delete n.__emitterProxy;
                    for (var i = arguments.length, s = new Array(i), a = 0; a < i; a++) s[a] = arguments[a];
                    t.apply(r, s)
                }
                return n.__emitterProxy = t, r.on(e, n, i)
            },
            onAny(e, t) {
                const i = this;
                if (!i.eventsListeners || i.destroyed) return i;
                if ("function" != typeof e) return i;
                const r = t ? "unshift" : "push";
                return i.eventsAnyListeners.indexOf(e) < 0 && i.eventsAnyListeners[r](e), i
            },
            offAny(e) {
                const t = this;
                if (!t.eventsListeners || t.destroyed) return t;
                if (!t.eventsAnyListeners) return t;
                const i = t.eventsAnyListeners.indexOf(e);
                return i >= 0 && t.eventsAnyListeners.splice(i, 1), t
            },
            off(e, t) {
                const i = this;
                return !i.eventsListeners || i.destroyed ? i : i.eventsListeners ? (e.split(" ").forEach((e => {
                    void 0 === t ? i.eventsListeners[e] = [] : i.eventsListeners[e] && i.eventsListeners[e].forEach(((r, n) => {
                        (r === t || r.__emitterProxy && r.__emitterProxy === t) && i.eventsListeners[e].splice(n, 1)
                    }))
                })), i) : i
            },
            emit() {
                const e = this;
                if (!e.eventsListeners || e.destroyed) return e;
                if (!e.eventsListeners) return e;
                let t, i, r;
                for (var n = arguments.length, s = new Array(n), a = 0; a < n; a++) s[a] = arguments[a];
                return "string" == typeof s[0] || Array.isArray(s[0]) ? (t = s[0], i = s.slice(1, s.length), r = e) : (t = s[0].events, i = s[0].data, r = s[0].context || e), i.unshift(r), (Array.isArray(t) ? t : t.split(" ")).forEach((t => {
                    e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((e => {
                        e.apply(r, [t, ...i])
                    })), e.eventsListeners && e.eventsListeners[t] && e.eventsListeners[t].forEach((e => {
                        e.apply(r, i)
                    }))
                })), e
            }
        };
        const A = (e, t) => {
            if (!e || e.destroyed || !e.params) return;
            const i = t.closest(e.isElement ? "swiper-slide" : `.${e.params.slideClass}`);
            if (i) {
                let t = i.querySelector(`.${e.params.lazyPreloaderClass}`);
                !t && e.isElement && (i.shadowRoot ? t = i.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame((() => {
                    i.shadowRoot && (t = i.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`), t && t.remove())
                }))), t && t.remove()
            }
        },
            D = (e, t) => {
                if (!e.slides[t]) return;
                const i = e.slides[t].querySelector('[loading="lazy"]');
                i && i.removeAttribute("loading")
            },
            I = e => {
                if (!e || e.destroyed || !e.params) return;
                let t = e.params.lazyPreloadPrevNext;
                const i = e.slides.length;
                if (!i || !t || t < 0) return;
                t = Math.min(t, i);
                const r = "auto" === e.params.slidesPerView ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView),
                    n = e.activeIndex;
                if (e.params.grid && e.params.grid.rows > 1) {
                    const i = n,
                        s = [i - t];
                    return s.push(...Array.from({
                        length: t
                    }).map(((e, t) => i + r + t))), void e.slides.forEach(((t, i) => {
                        s.includes(t.column) && D(e, i)
                    }))
                }
                const s = n + r - 1;
                if (e.params.rewind || e.params.loop)
                    for (let r = n - t; r <= s + t; r += 1) {
                        const t = (r % i + i) % i;
                        (t < n || t > s) && D(e, t)
                    } else
                    for (let r = Math.max(n - t, 0); r <= Math.min(s + t, i - 1); r += 1) r !== n && (r > s || r < n) && D(e, r)
            };
        var z = {
            updateSize: function () {
                const e = this;
                let t, i;
                const r = e.el;
                t = void 0 !== e.params.width && null !== e.params.width ? e.params.width : r.clientWidth, i = void 0 !== e.params.height && null !== e.params.height ? e.params.height : r.clientHeight, 0 === t && e.isHorizontal() || 0 === i && e.isVertical() || (t = t - parseInt(T(r, "padding-left") || 0, 10) - parseInt(T(r, "padding-right") || 0, 10), i = i - parseInt(T(r, "padding-top") || 0, 10) - parseInt(T(r, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(i) && (i = 0), Object.assign(e, {
                    width: t,
                    height: i,
                    size: e.isHorizontal() ? t : i
                }))
            },
            updateSlides: function () {
                const e = this;

                function t(t, i) {
                    return parseFloat(t.getPropertyValue(e.getDirectionLabel(i)) || 0)
                }
                const i = e.params,
                    {
                        wrapperEl: r,
                        slidesEl: n,
                        size: s,
                        rtlTranslate: a,
                        wrongRTL: o
                    } = e,
                    l = e.virtual && i.virtual.enabled,
                    c = l ? e.virtual.slides.length : e.slides.length,
                    d = _(n, `.${e.params.slideClass}, swiper-slide`),
                    u = l ? e.virtual.slides.length : d.length;
                let h = [];
                const p = [],
                    f = [];
                let m = i.slidesOffsetBefore;
                "function" == typeof m && (m = i.slidesOffsetBefore.call(e));
                let g = i.slidesOffsetAfter;
                "function" == typeof g && (g = i.slidesOffsetAfter.call(e));
                const y = e.snapGrid.length,
                    w = e.slidesGrid.length;
                let b = i.spaceBetween,
                    x = -m,
                    E = 0,
                    S = 0;
                if (void 0 === s) return;
                "string" == typeof b && b.indexOf("%") >= 0 ? b = parseFloat(b.replace("%", "")) / 100 * s : "string" == typeof b && (b = parseFloat(b)), e.virtualSize = -b, d.forEach((e => {
                    a ? e.style.marginLeft = "" : e.style.marginRight = "", e.style.marginBottom = "", e.style.marginTop = ""
                })), i.centeredSlides && i.cssMode && (v(r, "--swiper-centered-offset-before", ""), v(r, "--swiper-centered-offset-after", ""));
                const P = i.grid && i.grid.rows > 1 && e.grid;
                let k;
                P ? e.grid.initSlides(d) : e.grid && e.grid.unsetSlides();
                const C = "auto" === i.slidesPerView && i.breakpoints && Object.keys(i.breakpoints).filter((e => void 0 !== i.breakpoints[e].slidesPerView)).length > 0;
                for (let r = 0; r < u; r += 1) {
                    let n;
                    if (k = 0, d[r] && (n = d[r]), P && e.grid.updateSlide(r, n, d), !d[r] || "none" !== T(n, "display")) {
                        if ("auto" === i.slidesPerView) {
                            C && (d[r].style[e.getDirectionLabel("width")] = "");
                            const s = getComputedStyle(n),
                                a = n.style.transform,
                                o = n.style.webkitTransform;
                            if (a && (n.style.transform = "none"), o && (n.style.webkitTransform = "none"), i.roundLengths) k = e.isHorizontal() ? M(n, "width", !0) : M(n, "height", !0);
                            else {
                                const e = t(s, "width"),
                                    i = t(s, "padding-left"),
                                    r = t(s, "padding-right"),
                                    a = t(s, "margin-left"),
                                    o = t(s, "margin-right"),
                                    l = s.getPropertyValue("box-sizing");
                                if (l && "border-box" === l) k = e + a + o;
                                else {
                                    const {
                                        clientWidth: t,
                                        offsetWidth: s
                                    } = n;
                                    k = e + i + r + a + o + (s - t)
                                }
                            }
                            a && (n.style.transform = a), o && (n.style.webkitTransform = o), i.roundLengths && (k = Math.floor(k))
                        } else k = (s - (i.slidesPerView - 1) * b) / i.slidesPerView, i.roundLengths && (k = Math.floor(k)), d[r] && (d[r].style[e.getDirectionLabel("width")] = `${k}px`);
                        d[r] && (d[r].swiperSlideSize = k), f.push(k), i.centeredSlides ? (x = x + k / 2 + E / 2 + b, 0 === E && 0 !== r && (x = x - s / 2 - b), 0 === r && (x = x - s / 2 - b), Math.abs(x) < .001 && (x = 0), i.roundLengths && (x = Math.floor(x)), S % i.slidesPerGroup == 0 && h.push(x), p.push(x)) : (i.roundLengths && (x = Math.floor(x)), (S - Math.min(e.params.slidesPerGroupSkip, S)) % e.params.slidesPerGroup == 0 && h.push(x), p.push(x), x = x + k + b), e.virtualSize += k + b, E = k, S += 1
                    }
                }
                if (e.virtualSize = Math.max(e.virtualSize, s) + g, a && o && ("slide" === i.effect || "coverflow" === i.effect) && (r.style.width = `${e.virtualSize + b}px`), i.setWrapperSize && (r.style[e.getDirectionLabel("width")] = `${e.virtualSize + b}px`), P && e.grid.updateWrapperSize(k, h), !i.centeredSlides) {
                    const t = [];
                    for (let r = 0; r < h.length; r += 1) {
                        let n = h[r];
                        i.roundLengths && (n = Math.floor(n)), h[r] <= e.virtualSize - s && t.push(n)
                    }
                    h = t, Math.floor(e.virtualSize - s) - Math.floor(h[h.length - 1]) > 1 && h.push(e.virtualSize - s)
                }
                if (l && i.loop) {
                    const t = f[0] + b;
                    if (i.slidesPerGroup > 1) {
                        const r = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / i.slidesPerGroup),
                            n = t * i.slidesPerGroup;
                        for (let e = 0; e < r; e += 1) h.push(h[h.length - 1] + n)
                    }
                    for (let r = 0; r < e.virtual.slidesBefore + e.virtual.slidesAfter; r += 1) 1 === i.slidesPerGroup && h.push(h[h.length - 1] + t), p.push(p[p.length - 1] + t), e.virtualSize += t
                }
                if (0 === h.length && (h = [0]), 0 !== b) {
                    const t = e.isHorizontal() && a ? "marginLeft" : e.getDirectionLabel("marginRight");
                    d.filter(((e, t) => !(i.cssMode && !i.loop) || t !== d.length - 1)).forEach((e => {
                        e.style[t] = `${b}px`
                    }))
                }
                if (i.centeredSlides && i.centeredSlidesBounds) {
                    let e = 0;
                    f.forEach((t => {
                        e += t + (b || 0)
                    })), e -= b;
                    const t = e - s;
                    h = h.map((e => e <= 0 ? -m : e > t ? t + g : e))
                }
                if (i.centerInsufficientSlides) {
                    let e = 0;
                    if (f.forEach((t => {
                        e += t + (b || 0)
                    })), e -= b, e < s) {
                        const t = (s - e) / 2;
                        h.forEach(((e, i) => {
                            h[i] = e - t
                        })), p.forEach(((e, i) => {
                            p[i] = e + t
                        }))
                    }
                }
                if (Object.assign(e, {
                    slides: d,
                    snapGrid: h,
                    slidesGrid: p,
                    slidesSizesGrid: f
                }), i.centeredSlides && i.cssMode && !i.centeredSlidesBounds) {
                    v(r, "--swiper-centered-offset-before", -h[0] + "px"), v(r, "--swiper-centered-offset-after", e.size / 2 - f[f.length - 1] / 2 + "px");
                    const t = -e.snapGrid[0],
                        i = -e.slidesGrid[0];
                    e.snapGrid = e.snapGrid.map((e => e + t)), e.slidesGrid = e.slidesGrid.map((e => e + i))
                }
                if (u !== c && e.emit("slidesLengthChange"), h.length !== y && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), p.length !== w && e.emit("slidesGridLengthChange"), i.watchSlidesProgress && e.updateSlidesOffset(), e.emit("slidesUpdated"), !(l || i.cssMode || "slide" !== i.effect && "fade" !== i.effect)) {
                    const t = `${i.containerModifierClass}backface-hidden`,
                        r = e.el.classList.contains(t);
                    u <= i.maxBackfaceHiddenSlides ? r || e.el.classList.add(t) : r && e.el.classList.remove(t)
                }
            },
            updateAutoHeight: function (e) {
                const t = this,
                    i = [],
                    r = t.virtual && t.params.virtual.enabled;
                let n, s = 0;
                "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
                const a = e => r ? t.slides[t.getSlideIndexByData(e)] : t.slides[e];
                if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
                    if (t.params.centeredSlides) (t.visibleSlides || []).forEach((e => {
                        i.push(e)
                    }));
                    else
                        for (n = 0; n < Math.ceil(t.params.slidesPerView); n += 1) {
                            const e = t.activeIndex + n;
                            if (e > t.slides.length && !r) break;
                            i.push(a(e))
                        } else i.push(a(t.activeIndex));
                for (n = 0; n < i.length; n += 1)
                    if (void 0 !== i[n]) {
                        const e = i[n].offsetHeight;
                        s = e > s ? e : s
                    } (s || 0 === s) && (t.wrapperEl.style.height = `${s}px`)
            },
            updateSlidesOffset: function () {
                const e = this,
                    t = e.slides,
                    i = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
                for (let r = 0; r < t.length; r += 1) t[r].swiperSlideOffset = (e.isHorizontal() ? t[r].offsetLeft : t[r].offsetTop) - i - e.cssOverflowAdjustment()
            },
            updateSlidesProgress: function (e) {
                void 0 === e && (e = this && this.translate || 0);
                const t = this,
                    i = t.params,
                    {
                        slides: r,
                        rtlTranslate: n,
                        snapGrid: s
                    } = t;
                if (0 === r.length) return;
                void 0 === r[0].swiperSlideOffset && t.updateSlidesOffset();
                let a = -e;
                n && (a = e), r.forEach((e => {
                    e.classList.remove(i.slideVisibleClass, i.slideFullyVisibleClass)
                })), t.visibleSlidesIndexes = [], t.visibleSlides = [];
                let o = i.spaceBetween;
                "string" == typeof o && o.indexOf("%") >= 0 ? o = parseFloat(o.replace("%", "")) / 100 * t.size : "string" == typeof o && (o = parseFloat(o));
                for (let e = 0; e < r.length; e += 1) {
                    const l = r[e];
                    let c = l.swiperSlideOffset;
                    i.cssMode && i.centeredSlides && (c -= r[0].swiperSlideOffset);
                    const d = (a + (i.centeredSlides ? t.minTranslate() : 0) - c) / (l.swiperSlideSize + o),
                        u = (a - s[0] + (i.centeredSlides ? t.minTranslate() : 0) - c) / (l.swiperSlideSize + o),
                        h = -(a - c),
                        p = h + t.slidesSizesGrid[e],
                        f = h >= 0 && h <= t.size - t.slidesSizesGrid[e];
                    (h >= 0 && h < t.size - 1 || p > 1 && p <= t.size || h <= 0 && p >= t.size) && (t.visibleSlides.push(l), t.visibleSlidesIndexes.push(e), r[e].classList.add(i.slideVisibleClass)), f && r[e].classList.add(i.slideFullyVisibleClass), l.progress = n ? -d : d, l.originalProgress = n ? -u : u
                }
            },
            updateProgress: function (e) {
                const t = this;
                if (void 0 === e) {
                    const i = t.rtlTranslate ? -1 : 1;
                    e = t && t.translate && t.translate * i || 0
                }
                const i = t.params,
                    r = t.maxTranslate() - t.minTranslate();
                let {
                    progress: n,
                    isBeginning: s,
                    isEnd: a,
                    progressLoop: o
                } = t;
                const l = s,
                    c = a;
                if (0 === r) n = 0, s = !0, a = !0;
                else {
                    n = (e - t.minTranslate()) / r;
                    const i = Math.abs(e - t.minTranslate()) < 1,
                        o = Math.abs(e - t.maxTranslate()) < 1;
                    s = i || n <= 0, a = o || n >= 1, i && (n = 0), o && (n = 1)
                }
                if (i.loop) {
                    const i = t.getSlideIndexByData(0),
                        r = t.getSlideIndexByData(t.slides.length - 1),
                        n = t.slidesGrid[i],
                        s = t.slidesGrid[r],
                        a = t.slidesGrid[t.slidesGrid.length - 1],
                        l = Math.abs(e);
                    o = l >= n ? (l - n) / a : (l + a - s) / a, o > 1 && (o -= 1)
                }
                Object.assign(t, {
                    progress: n,
                    progressLoop: o,
                    isBeginning: s,
                    isEnd: a
                }), (i.watchSlidesProgress || i.centeredSlides && i.autoHeight) && t.updateSlidesProgress(e), s && !l && t.emit("reachBeginning toEdge"), a && !c && t.emit("reachEnd toEdge"), (l && !s || c && !a) && t.emit("fromEdge"), t.emit("progress", n)
            },
            updateSlidesClasses: function () {
                const e = this,
                    {
                        slides: t,
                        params: i,
                        slidesEl: r,
                        activeIndex: n
                    } = e,
                    s = e.virtual && i.virtual.enabled,
                    a = e.grid && i.grid && i.grid.rows > 1,
                    o = e => _(r, `.${i.slideClass}${e}, swiper-slide${e}`)[0];
                let l, c, d;
                if (t.forEach((e => {
                    e.classList.remove(i.slideActiveClass, i.slideNextClass, i.slidePrevClass)
                })), s)
                    if (i.loop) {
                        let t = n - e.virtual.slidesBefore;
                        t < 0 && (t = e.virtual.slides.length + t), t >= e.virtual.slides.length && (t -= e.virtual.slides.length), l = o(`[data-swiper-slide-index="${t}"]`)
                    } else l = o(`[data-swiper-slide-index="${n}"]`);
                else a ? (l = t.filter((e => e.column === n))[0], d = t.filter((e => e.column === n + 1))[0], c = t.filter((e => e.column === n - 1))[0]) : l = t[n];
                l && (l.classList.add(i.slideActiveClass), a ? (d && d.classList.add(i.slideNextClass), c && c.classList.add(i.slidePrevClass)) : (d = function (e, t) {
                    const i = [];
                    for (; e.nextElementSibling;) {
                        const r = e.nextElementSibling;
                        t ? r.matches(t) && i.push(r) : i.push(r), e = r
                    }
                    return i
                }(l, `.${i.slideClass}, swiper-slide`)[0], i.loop && !d && (d = t[0]), d && d.classList.add(i.slideNextClass), c = function (e, t) {
                    const i = [];
                    for (; e.previousElementSibling;) {
                        const r = e.previousElementSibling;
                        t ? r.matches(t) && i.push(r) : i.push(r), e = r
                    }
                    return i
                }(l, `.${i.slideClass}, swiper-slide`)[0], i.loop && 0 === !c && (c = t[t.length - 1]), c && c.classList.add(i.slidePrevClass))), e.emitSlidesClasses()
            },
            updateActiveIndex: function (e) {
                const t = this,
                    i = t.rtlTranslate ? t.translate : -t.translate,
                    {
                        snapGrid: r,
                        params: n,
                        activeIndex: s,
                        realIndex: a,
                        snapIndex: o
                    } = t;
                let l, c = e;
                const d = e => {
                    let i = e - t.virtual.slidesBefore;
                    return i < 0 && (i = t.virtual.slides.length + i), i >= t.virtual.slides.length && (i -= t.virtual.slides.length), i
                };
                if (void 0 === c && (c = function (e) {
                    const {
                        slidesGrid: t,
                        params: i
                    } = e, r = e.rtlTranslate ? e.translate : -e.translate;
                    let n;
                    for (let e = 0; e < t.length; e += 1) void 0 !== t[e + 1] ? r >= t[e] && r < t[e + 1] - (t[e + 1] - t[e]) / 2 ? n = e : r >= t[e] && r < t[e + 1] && (n = e + 1) : r >= t[e] && (n = e);
                    return i.normalizeSlideIndex && (n < 0 || void 0 === n) && (n = 0), n
                }(t)), r.indexOf(i) >= 0) l = r.indexOf(i);
                else {
                    const e = Math.min(n.slidesPerGroupSkip, c);
                    l = e + Math.floor((c - e) / n.slidesPerGroup)
                }
                if (l >= r.length && (l = r.length - 1), c === s && !t.params.loop) return void (l !== o && (t.snapIndex = l, t.emit("snapIndexChange")));
                if (c === s && t.params.loop && t.virtual && t.params.virtual.enabled) return void (t.realIndex = d(c));
                const u = t.grid && n.grid && n.grid.rows > 1;
                let h;
                if (t.virtual && n.virtual.enabled && n.loop) h = d(c);
                else if (u) {
                    const e = t.slides.filter((e => e.column === c))[0];
                    let i = parseInt(e.getAttribute("data-swiper-slide-index"), 10);
                    Number.isNaN(i) && (i = Math.max(t.slides.indexOf(e), 0)), h = Math.floor(i / n.grid.rows)
                } else if (t.slides[c]) {
                    const e = t.slides[c].getAttribute("data-swiper-slide-index");
                    h = e ? parseInt(e, 10) : c
                } else h = c;
                Object.assign(t, {
                    previousSnapIndex: o,
                    snapIndex: l,
                    previousRealIndex: a,
                    realIndex: h,
                    previousIndex: s,
                    activeIndex: c
                }), t.initialized && I(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && (a !== h && t.emit("realIndexChange"), t.emit("slideChange"))
            },
            updateClickedSlide: function (e, t) {
                const i = this,
                    r = i.params;
                let n = e.closest(`.${r.slideClass}, swiper-slide`);
                !n && i.isElement && t && t.length > 1 && t.includes(e) && [...t.slice(t.indexOf(e) + 1, t.length)].forEach((e => {
                    !n && e.matches && e.matches(`.${r.slideClass}, swiper-slide`) && (n = e)
                }));
                let s, a = !1;
                if (n)
                    for (let e = 0; e < i.slides.length; e += 1)
                        if (i.slides[e] === n) {
                            a = !0, s = e;
                            break
                        } if (!n || !a) return i.clickedSlide = void 0, void (i.clickedIndex = void 0);
                i.clickedSlide = n, i.virtual && i.params.virtual.enabled ? i.clickedIndex = parseInt(n.getAttribute("data-swiper-slide-index"), 10) : i.clickedIndex = s, r.slideToClickedSlide && void 0 !== i.clickedIndex && i.clickedIndex !== i.activeIndex && i.slideToClickedSlide()
            }
        },
            R = {
                getTranslate: function (e) {
                    void 0 === e && (e = this.isHorizontal() ? "x" : "y");
                    const {
                        params: t,
                        rtlTranslate: i,
                        translate: r,
                        wrapperEl: n
                    } = this;
                    if (t.virtualTranslate) return i ? -r : r;
                    if (t.cssMode) return r;
                    let s = function (e, t) {
                        void 0 === t && (t = "x");
                        const i = h();
                        let r, n, s;
                        const a = function (e) {
                            const t = h();
                            let i;
                            return t.getComputedStyle && (i = t.getComputedStyle(e, null)), !i && e.currentStyle && (i = e.currentStyle), i || (i = e.style), i
                        }(e);
                        return i.WebKitCSSMatrix ? (n = a.transform || a.webkitTransform, n.split(",").length > 6 && (n = n.split(", ").map((e => e.replace(",", "."))).join(", ")), s = new i.WebKitCSSMatrix("none" === n ? "" : n)) : (s = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), r = s.toString().split(",")), "x" === t && (n = i.WebKitCSSMatrix ? s.m41 : 16 === r.length ? parseFloat(r[12]) : parseFloat(r[4])), "y" === t && (n = i.WebKitCSSMatrix ? s.m42 : 16 === r.length ? parseFloat(r[13]) : parseFloat(r[5])), n || 0
                    }(n, e);
                    return s += this.cssOverflowAdjustment(), i && (s = -s), s || 0
                },
                setTranslate: function (e, t) {
                    const i = this,
                        {
                            rtlTranslate: r,
                            params: n,
                            wrapperEl: s,
                            progress: a
                        } = i;
                    let o, l = 0,
                        c = 0;
                    i.isHorizontal() ? l = r ? -e : e : c = e, n.roundLengths && (l = Math.floor(l), c = Math.floor(c)), i.previousTranslate = i.translate, i.translate = i.isHorizontal() ? l : c, n.cssMode ? s[i.isHorizontal() ? "scrollLeft" : "scrollTop"] = i.isHorizontal() ? -l : -c : n.virtualTranslate || (i.isHorizontal() ? l -= i.cssOverflowAdjustment() : c -= i.cssOverflowAdjustment(), s.style.transform = `translate3d(${l}px, ${c}px, 0px)`);
                    const d = i.maxTranslate() - i.minTranslate();
                    o = 0 === d ? 0 : (e - i.minTranslate()) / d, o !== a && i.updateProgress(e), i.emit("setTranslate", i.translate, t)
                },
                minTranslate: function () {
                    return -this.snapGrid[0]
                },
                maxTranslate: function () {
                    return -this.snapGrid[this.snapGrid.length - 1]
                },
                translateTo: function (e, t, i, r, n) {
                    void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0), void 0 === r && (r = !0);
                    const s = this,
                        {
                            params: a,
                            wrapperEl: o
                        } = s;
                    if (s.animating && a.preventInteractionOnTransition) return !1;
                    const l = s.minTranslate(),
                        c = s.maxTranslate();
                    let d;
                    if (d = r && e > l ? l : r && e < c ? c : e, s.updateProgress(d), a.cssMode) {
                        const e = s.isHorizontal();
                        if (0 === t) o[e ? "scrollLeft" : "scrollTop"] = -d;
                        else {
                            if (!s.support.smoothScroll) return y({
                                swiper: s,
                                targetPosition: -d,
                                side: e ? "left" : "top"
                            }), !0;
                            o.scrollTo({
                                [e ? "left" : "top"]: -d,
                                behavior: "smooth"
                            })
                        }
                        return !0
                    }
                    return 0 === t ? (s.setTransition(0), s.setTranslate(d), i && (s.emit("beforeTransitionStart", t, n), s.emit("transitionEnd"))) : (s.setTransition(t), s.setTranslate(d), i && (s.emit("beforeTransitionStart", t, n), s.emit("transitionStart")), s.animating || (s.animating = !0, s.onTranslateToWrapperTransitionEnd || (s.onTranslateToWrapperTransitionEnd = function (e) {
                        s && !s.destroyed && e.target === this && (s.wrapperEl.removeEventListener("transitionend", s.onTranslateToWrapperTransitionEnd), s.onTranslateToWrapperTransitionEnd = null, delete s.onTranslateToWrapperTransitionEnd, i && s.emit("transitionEnd"))
                    }), s.wrapperEl.addEventListener("transitionend", s.onTranslateToWrapperTransitionEnd))), !0
                }
            };

        function B(e) {
            let {
                swiper: t,
                runCallbacks: i,
                direction: r,
                step: n
            } = e;
            const {
                activeIndex: s,
                previousIndex: a
            } = t;
            let o = r;
            if (o || (o = s > a ? "next" : s < a ? "prev" : "reset"), t.emit(`transition${n}`), i && s !== a) {
                if ("reset" === o) return void t.emit(`slideResetTransition${n}`);
                t.emit(`slideChangeTransition${n}`), "next" === o ? t.emit(`slideNextTransition${n}`) : t.emit(`slidePrevTransition${n}`)
            }
        }
        var F = {
            slideTo: function (e, t, i, r, n) {
                void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0), "string" == typeof e && (e = parseInt(e, 10));
                const s = this;
                let a = e;
                a < 0 && (a = 0);
                const {
                    params: o,
                    snapGrid: l,
                    slidesGrid: c,
                    previousIndex: d,
                    activeIndex: u,
                    rtlTranslate: h,
                    wrapperEl: p,
                    enabled: f
                } = s;
                if (s.animating && o.preventInteractionOnTransition || !f && !r && !n) return !1;
                const m = Math.min(s.params.slidesPerGroupSkip, a);
                let g = m + Math.floor((a - m) / s.params.slidesPerGroup);
                g >= l.length && (g = l.length - 1);
                const v = -l[g];
                if (o.normalizeSlideIndex)
                    for (let e = 0; e < c.length; e += 1) {
                        const t = -Math.floor(100 * v),
                            i = Math.floor(100 * c[e]),
                            r = Math.floor(100 * c[e + 1]);
                        void 0 !== c[e + 1] ? t >= i && t < r - (r - i) / 2 ? a = e : t >= i && t < r && (a = e + 1) : t >= i && (a = e)
                    }
                if (s.initialized && a !== u) {
                    if (!s.allowSlideNext && (h ? v > s.translate && v > s.minTranslate() : v < s.translate && v < s.minTranslate())) return !1;
                    if (!s.allowSlidePrev && v > s.translate && v > s.maxTranslate() && (u || 0) !== a) return !1
                }
                let w;
                if (a !== (d || 0) && i && s.emit("beforeSlideChangeStart"), s.updateProgress(v), w = a > u ? "next" : a < u ? "prev" : "reset", h && -v === s.translate || !h && v === s.translate) return s.updateActiveIndex(a), o.autoHeight && s.updateAutoHeight(), s.updateSlidesClasses(), "slide" !== o.effect && s.setTranslate(v), "reset" !== w && (s.transitionStart(i, w), s.transitionEnd(i, w)), !1;
                if (o.cssMode) {
                    const e = s.isHorizontal(),
                        i = h ? v : -v;
                    if (0 === t) {
                        const t = s.virtual && s.params.virtual.enabled;
                        t && (s.wrapperEl.style.scrollSnapType = "none", s._immediateVirtual = !0), t && !s._cssModeVirtualInitialSet && s.params.initialSlide > 0 ? (s._cssModeVirtualInitialSet = !0, requestAnimationFrame((() => {
                            p[e ? "scrollLeft" : "scrollTop"] = i
                        }))) : p[e ? "scrollLeft" : "scrollTop"] = i, t && requestAnimationFrame((() => {
                            s.wrapperEl.style.scrollSnapType = "", s._immediateVirtual = !1
                        }))
                    } else {
                        if (!s.support.smoothScroll) return y({
                            swiper: s,
                            targetPosition: i,
                            side: e ? "left" : "top"
                        }), !0;
                        p.scrollTo({
                            [e ? "left" : "top"]: i,
                            behavior: "smooth"
                        })
                    }
                    return !0
                }
                return s.setTransition(t), s.setTranslate(v), s.updateActiveIndex(a), s.updateSlidesClasses(), s.emit("beforeTransitionStart", t, r), s.transitionStart(i, w), 0 === t ? s.transitionEnd(i, w) : s.animating || (s.animating = !0, s.onSlideToWrapperTransitionEnd || (s.onSlideToWrapperTransitionEnd = function (e) {
                    s && !s.destroyed && e.target === this && (s.wrapperEl.removeEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.onSlideToWrapperTransitionEnd = null, delete s.onSlideToWrapperTransitionEnd, s.transitionEnd(i, w))
                }), s.wrapperEl.addEventListener("transitionend", s.onSlideToWrapperTransitionEnd)), !0
            },
            slideToLoop: function (e, t, i, r) {
                void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0), "string" == typeof e && (e = parseInt(e, 10));
                const n = this,
                    s = n.grid && n.params.grid && n.params.grid.rows > 1;
                let a = e;
                if (n.params.loop)
                    if (n.virtual && n.params.virtual.enabled) a += n.virtual.slidesBefore;
                    else {
                        let e;
                        if (s) {
                            const t = a * n.params.grid.rows;
                            e = n.slides.filter((e => 1 * e.getAttribute("data-swiper-slide-index") === t))[0].column
                        } else e = n.getSlideIndexByData(a);
                        const t = s ? Math.ceil(n.slides.length / n.params.grid.rows) : n.slides.length,
                            {
                                centeredSlides: i
                            } = n.params;
                        let r = n.params.slidesPerView;
                        "auto" === r ? r = n.slidesPerViewDynamic() : (r = Math.ceil(parseFloat(n.params.slidesPerView, 10)), i && r % 2 == 0 && (r += 1));
                        let o = t - e < r;
                        if (i && (o = o || e < Math.ceil(r / 2)), o) {
                            const r = i ? e < n.activeIndex ? "prev" : "next" : e - n.activeIndex - 1 < n.params.slidesPerView ? "next" : "prev";
                            n.loopFix({
                                direction: r,
                                slideTo: !0,
                                activeSlideIndex: "next" === r ? e + 1 : e - t + 1,
                                slideRealIndex: "next" === r ? n.realIndex : void 0
                            })
                        }
                        if (s) {
                            const e = a * n.params.grid.rows;
                            a = n.slides.filter((t => 1 * t.getAttribute("data-swiper-slide-index") === e))[0].column
                        } else a = n.getSlideIndexByData(a)
                    } return requestAnimationFrame((() => {
                        n.slideTo(a, t, i, r)
                    })), n
            },
            slideNext: function (e, t, i) {
                void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
                const r = this,
                    {
                        enabled: n,
                        params: s,
                        animating: a
                    } = r;
                if (!n) return r;
                let o = s.slidesPerGroup;
                "auto" === s.slidesPerView && 1 === s.slidesPerGroup && s.slidesPerGroupAuto && (o = Math.max(r.slidesPerViewDynamic("current", !0), 1));
                const l = r.activeIndex < s.slidesPerGroupSkip ? 1 : o,
                    c = r.virtual && s.virtual.enabled;
                if (s.loop) {
                    if (a && !c && s.loopPreventsSliding) return !1;
                    if (r.loopFix({
                        direction: "next"
                    }), r._clientLeft = r.wrapperEl.clientLeft, r.activeIndex === r.slides.length - 1 && s.cssMode) return requestAnimationFrame((() => {
                        r.slideTo(r.activeIndex + l, e, t, i)
                    })), !0
                }
                return s.rewind && r.isEnd ? r.slideTo(0, e, t, i) : r.slideTo(r.activeIndex + l, e, t, i)
            },
            slidePrev: function (e, t, i) {
                void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
                const r = this,
                    {
                        params: n,
                        snapGrid: s,
                        slidesGrid: a,
                        rtlTranslate: o,
                        enabled: l,
                        animating: c
                    } = r;
                if (!l) return r;
                const d = r.virtual && n.virtual.enabled;
                if (n.loop) {
                    if (c && !d && n.loopPreventsSliding) return !1;
                    r.loopFix({
                        direction: "prev"
                    }), r._clientLeft = r.wrapperEl.clientLeft
                }

                function u(e) {
                    return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e)
                }
                const h = u(o ? r.translate : -r.translate),
                    p = s.map((e => u(e)));
                let f = s[p.indexOf(h) - 1];
                if (void 0 === f && n.cssMode) {
                    let e;
                    s.forEach(((t, i) => {
                        h >= t && (e = i)
                    })), void 0 !== e && (f = s[e > 0 ? e - 1 : e])
                }
                let m = 0;
                if (void 0 !== f && (m = a.indexOf(f), m < 0 && (m = r.activeIndex - 1), "auto" === n.slidesPerView && 1 === n.slidesPerGroup && n.slidesPerGroupAuto && (m = m - r.slidesPerViewDynamic("previous", !0) + 1, m = Math.max(m, 0))), n.rewind && r.isBeginning) {
                    const n = r.params.virtual && r.params.virtual.enabled && r.virtual ? r.virtual.slides.length - 1 : r.slides.length - 1;
                    return r.slideTo(n, e, t, i)
                }
                return n.loop && 0 === r.activeIndex && n.cssMode ? (requestAnimationFrame((() => {
                    r.slideTo(m, e, t, i)
                })), !0) : r.slideTo(m, e, t, i)
            },
            slideReset: function (e, t, i) {
                return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, i)
            },
            slideToClosest: function (e, t, i, r) {
                void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === r && (r = .5);
                const n = this;
                let s = n.activeIndex;
                const a = Math.min(n.params.slidesPerGroupSkip, s),
                    o = a + Math.floor((s - a) / n.params.slidesPerGroup),
                    l = n.rtlTranslate ? n.translate : -n.translate;
                if (l >= n.snapGrid[o]) {
                    const e = n.snapGrid[o];
                    l - e > (n.snapGrid[o + 1] - e) * r && (s += n.params.slidesPerGroup)
                } else {
                    const e = n.snapGrid[o - 1];
                    l - e <= (n.snapGrid[o] - e) * r && (s -= n.params.slidesPerGroup)
                }
                return s = Math.max(s, 0), s = Math.min(s, n.slidesGrid.length - 1), n.slideTo(s, e, t, i)
            },
            slideToClickedSlide: function () {
                const e = this,
                    {
                        params: t,
                        slidesEl: i
                    } = e,
                    r = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
                let n, s = e.clickedIndex;
                const a = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
                if (t.loop) {
                    if (e.animating) return;
                    n = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? s < e.loopedSlides - r / 2 || s > e.slides.length - e.loopedSlides + r / 2 ? (e.loopFix(), s = e.getSlideIndex(_(i, `${a}[data-swiper-slide-index="${n}"]`)[0]), p((() => {
                        e.slideTo(s)
                    }))) : e.slideTo(s) : s > e.slides.length - r ? (e.loopFix(), s = e.getSlideIndex(_(i, `${a}[data-swiper-slide-index="${n}"]`)[0]), p((() => {
                        e.slideTo(s)
                    }))) : e.slideTo(s)
                } else e.slideTo(s)
            }
        },
            N = {
                loopCreate: function (e) {
                    const t = this,
                        {
                            params: i,
                            slidesEl: r
                        } = t;
                    if (!i.loop || t.virtual && t.params.virtual.enabled) return;
                    const n = () => {
                        _(r, `.${i.slideClass}, swiper-slide`).forEach(((e, t) => {
                            e.setAttribute("data-swiper-slide-index", t)
                        }))
                    },
                        s = t.grid && i.grid && i.grid.rows > 1,
                        a = i.slidesPerGroup * (s ? i.grid.rows : 1),
                        o = t.slides.length % a != 0,
                        l = s && t.slides.length % i.grid.rows != 0,
                        c = e => {
                            for (let r = 0; r < e; r += 1) {
                                const e = t.isElement ? x("swiper-slide", [i.slideBlankClass]) : x("div", [i.slideClass, i.slideBlankClass]);
                                t.slidesEl.append(e)
                            }
                        };
                    o ? (i.loopAddBlankSlides ? (c(a - t.slides.length % a), t.recalcSlides(), t.updateSlides()) : b("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"), n()) : l ? (i.loopAddBlankSlides ? (c(i.grid.rows - t.slides.length % i.grid.rows), t.recalcSlides(), t.updateSlides()) : b("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"), n()) : n(), t.loopFix({
                        slideRealIndex: e,
                        direction: i.centeredSlides ? void 0 : "next"
                    })
                },
                loopFix: function (e) {
                    let {
                        slideRealIndex: t,
                        slideTo: i = !0,
                        direction: r,
                        setTranslate: n,
                        activeSlideIndex: s,
                        byController: a,
                        byMousewheel: o
                    } = void 0 === e ? {} : e;
                    const l = this;
                    if (!l.params.loop) return;
                    l.emit("beforeLoopFix");
                    const {
                        slides: c,
                        allowSlidePrev: d,
                        allowSlideNext: u,
                        slidesEl: h,
                        params: p
                    } = l, {
                        centeredSlides: f
                    } = p;
                    if (l.allowSlidePrev = !0, l.allowSlideNext = !0, l.virtual && p.virtual.enabled) return i && (p.centeredSlides || 0 !== l.snapIndex ? p.centeredSlides && l.snapIndex < p.slidesPerView ? l.slideTo(l.virtual.slides.length + l.snapIndex, 0, !1, !0) : l.snapIndex === l.snapGrid.length - 1 && l.slideTo(l.virtual.slidesBefore, 0, !1, !0) : l.slideTo(l.virtual.slides.length, 0, !1, !0)), l.allowSlidePrev = d, l.allowSlideNext = u, void l.emit("loopFix");
                    let m = p.slidesPerView;
                    "auto" === m ? m = l.slidesPerViewDynamic() : (m = Math.ceil(parseFloat(p.slidesPerView, 10)), f && m % 2 == 0 && (m += 1));
                    const g = p.slidesPerGroupAuto ? m : p.slidesPerGroup;
                    let v = g;
                    v % g != 0 && (v += g - v % g), v += p.loopAdditionalSlides, l.loopedSlides = v;
                    const y = l.grid && p.grid && p.grid.rows > 1;
                    c.length < m + v ? b("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : y && "row" === p.grid.fill && b("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
                    const w = [],
                        _ = [];
                    let x = l.activeIndex;
                    void 0 === s ? s = l.getSlideIndex(c.filter((e => e.classList.contains(p.slideActiveClass)))[0]) : x = s;
                    const T = "next" === r || !r,
                        E = "prev" === r || !r;
                    let S = 0,
                        M = 0;
                    const P = y ? Math.ceil(c.length / p.grid.rows) : c.length,
                        k = (y ? c[s].column : s) + (f && void 0 === n ? -m / 2 + .5 : 0);
                    if (k < v) {
                        S = Math.max(v - k, g);
                        for (let e = 0; e < v - k; e += 1) {
                            const t = e - Math.floor(e / P) * P;
                            if (y) {
                                const e = P - t - 1;
                                for (let t = c.length - 1; t >= 0; t -= 1) c[t].column === e && w.push(t)
                            } else w.push(P - t - 1)
                        }
                    } else if (k + m > P - v) {
                        M = Math.max(k - (P - 2 * v), g);
                        for (let e = 0; e < M; e += 1) {
                            const t = e - Math.floor(e / P) * P;
                            y ? c.forEach(((e, i) => {
                                e.column === t && _.push(i)
                            })) : _.push(t)
                        }
                    }
                    if (l.__preventObserver__ = !0, requestAnimationFrame((() => {
                        l.__preventObserver__ = !1
                    })), E && w.forEach((e => {
                        c[e].swiperLoopMoveDOM = !0, h.prepend(c[e]), c[e].swiperLoopMoveDOM = !1
                    })), T && _.forEach((e => {
                        c[e].swiperLoopMoveDOM = !0, h.append(c[e]), c[e].swiperLoopMoveDOM = !1
                    })), l.recalcSlides(), "auto" === p.slidesPerView ? l.updateSlides() : y && (w.length > 0 && E || _.length > 0 && T) && l.slides.forEach(((e, t) => {
                        l.grid.updateSlide(t, e, l.slides)
                    })), p.watchSlidesProgress && l.updateSlidesOffset(), i)
                        if (w.length > 0 && E) {
                            if (void 0 === t) {
                                const e = l.slidesGrid[x],
                                    t = l.slidesGrid[x + S] - e;
                                o ? l.setTranslate(l.translate - t) : (l.slideTo(x + S, 0, !1, !0), n && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - t, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - t))
                            } else if (n) {
                                const e = y ? w.length / p.grid.rows : w.length;
                                l.slideTo(l.activeIndex + e, 0, !1, !0), l.touchEventsData.currentTranslate = l.translate
                            }
                        } else if (_.length > 0 && T)
                            if (void 0 === t) {
                                const e = l.slidesGrid[x],
                                    t = l.slidesGrid[x - M] - e;
                                o ? l.setTranslate(l.translate - t) : (l.slideTo(x - M, 0, !1, !0), n && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - t, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - t))
                            } else {
                                const e = y ? _.length / p.grid.rows : _.length;
                                l.slideTo(l.activeIndex - e, 0, !1, !0)
                            } if (l.allowSlidePrev = d, l.allowSlideNext = u, l.controller && l.controller.control && !a) {
                                const e = {
                                    slideRealIndex: t,
                                    direction: r,
                                    setTranslate: n,
                                    activeSlideIndex: s,
                                    byController: !0
                                };
                                Array.isArray(l.controller.control) ? l.controller.control.forEach((t => {
                                    !t.destroyed && t.params.loop && t.loopFix({
                                        ...e,
                                        slideTo: t.params.slidesPerView === p.slidesPerView && i
                                    })
                                })) : l.controller.control instanceof l.constructor && l.controller.control.params.loop && l.controller.control.loopFix({
                                    ...e,
                                    slideTo: l.controller.control.params.slidesPerView === p.slidesPerView && i
                                })
                            }
                    l.emit("loopFix")
                },
                loopDestroy: function () {
                    const e = this,
                        {
                            params: t,
                            slidesEl: i
                        } = e;
                    if (!t.loop || e.virtual && e.params.virtual.enabled) return;
                    e.recalcSlides();
                    const r = [];
                    e.slides.forEach((e => {
                        const t = void 0 === e.swiperSlideIndex ? 1 * e.getAttribute("data-swiper-slide-index") : e.swiperSlideIndex;
                        r[t] = e
                    })), e.slides.forEach((e => {
                        e.removeAttribute("data-swiper-slide-index")
                    })), r.forEach((e => {
                        i.append(e)
                    })), e.recalcSlides(), e.slideTo(e.realIndex, 0)
                }
            };

        function j(e, t, i) {
            const r = h(),
                {
                    params: n
                } = e,
                s = n.edgeSwipeDetection,
                a = n.edgeSwipeThreshold;
            // return !s || !(i <= a || i >= r.innerWidth - a) || "prevent" === s && (t.preventDefault(), !0)
        }

        function H(e) {
            const t = this,
                i = d();
            let r = e;
            r.originalEvent && (r = r.originalEvent);
            const n = t.touchEventsData;
            if ("pointerdown" === r.type) {
                if (null !== n.pointerId && n.pointerId !== r.pointerId) return;
                n.pointerId = r.pointerId
            } else "touchstart" === r.type && 1 === r.targetTouches.length && (n.touchId = r.targetTouches[0].identifier);
            if ("touchstart" === r.type) return void j(t, r, r.targetTouches[0].pageX);
            const {
                params: s,
                touches: a,
                enabled: o
            } = t;
            if (!o) return;
            if (!s.simulateTouch && "mouse" === r.pointerType) return;
            if (t.animating && s.preventInteractionOnTransition) return;
            !t.animating && s.cssMode && s.loop && t.loopFix();
            let l = r.target;
            if ("wrapper" === s.touchEventsTarget && !t.wrapperEl.contains(l)) return;
            if ("which" in r && 3 === r.which) return;
            if ("button" in r && r.button > 0) return;
            if (n.isTouched && n.isMoved) return;
            const c = !!s.noSwipingClass && "" !== s.noSwipingClass,
                u = r.composedPath ? r.composedPath() : r.path;
            c && r.target && r.target.shadowRoot && u && (l = u[0]);
            const p = s.noSwipingSelector ? s.noSwipingSelector : `.${s.noSwipingClass}`,
                m = !(!r.target || !r.target.shadowRoot);
            if (s.noSwiping && (m ? function (e, t) {
                return void 0 === t && (t = this),
                    function t(i) {
                        if (!i || i === d() || i === h()) return null;
                        i.assignedSlot && (i = i.assignedSlot);
                        const r = i.closest(e);
                        return r || i.getRootNode ? r || t(i.getRootNode().host) : null
                    }(t)
            }(p, l) : l.closest(p))) return void (t.allowClick = !0);
            if (s.swipeHandler && !l.closest(s.swipeHandler)) return;
            a.currentX = r.pageX, a.currentY = r.pageY;
            const g = a.currentX,
                v = a.currentY;
            if (!j(t, r, g)) return;
            Object.assign(n, {
                isTouched: !0,
                isMoved: !1,
                allowTouchCallbacks: !0,
                isScrolling: void 0,
                startMoving: void 0
            }), a.startX = g, a.startY = v, n.touchStartTime = f(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, s.threshold > 0 && (n.allowThresholdMove = !1);
            let y = !0;
            l.matches(n.focusableElements) && (y = !1, "SELECT" === l.nodeName && (n.isTouched = !1)), i.activeElement && i.activeElement.matches(n.focusableElements) && i.activeElement !== l && i.activeElement.blur();
            const w = y && t.allowTouchMove && s.touchStartPreventDefault;
            !s.touchStartForcePreventDefault && !w || l.isContentEditable || r.preventDefault(), s.freeMode && s.freeMode.enabled && t.freeMode && t.animating && !s.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", r)
        }

        function G(e) {
            const t = d(),
                i = this,
                r = i.touchEventsData,
                {
                    params: n,
                    touches: s,
                    rtlTranslate: a,
                    enabled: o
                } = i;
            if (!o) return;
            if (!n.simulateTouch && "mouse" === e.pointerType) return;
            let l, c = e;
            if (c.originalEvent && (c = c.originalEvent), "pointermove" === c.type) {
                if (null !== r.touchId) return;
                if (c.pointerId !== r.pointerId) return
            }
            if ("touchmove" === c.type) {
                if (l = [...c.changedTouches].filter((e => e.identifier === r.touchId))[0], !l || l.identifier !== r.touchId) return
            } else l = c;
            if (!r.isTouched) return void (r.startMoving && r.isScrolling && i.emit("touchMoveOpposite", c));
            const u = l.pageX,
                h = l.pageY;
            if (c.preventedByNestedSwiper) return s.startX = u, void (s.startY = h);
            if (!i.allowTouchMove) return c.target.matches(r.focusableElements) || (i.allowClick = !1), void (r.isTouched && (Object.assign(s, {
                startX: u,
                startY: h,
                currentX: u,
                currentY: h
            }), r.touchStartTime = f()));
            if (n.touchReleaseOnEdges && !n.loop)
                if (i.isVertical()) {
                    if (h < s.startY && i.translate <= i.maxTranslate() || h > s.startY && i.translate >= i.minTranslate()) return r.isTouched = !1, void (r.isMoved = !1)
                } else if (u < s.startX && i.translate <= i.maxTranslate() || u > s.startX && i.translate >= i.minTranslate()) return;
            if (t.activeElement && c.target === t.activeElement && c.target.matches(r.focusableElements)) return r.isMoved = !0, void (i.allowClick = !1);
            r.allowTouchCallbacks && i.emit("touchMove", c), s.previousX = s.currentX, s.previousY = s.currentY, s.currentX = u, s.currentY = h;
            const p = s.currentX - s.startX,
                m = s.currentY - s.startY;
            if (i.params.threshold && Math.sqrt(p ** 2 + m ** 2) < i.params.threshold) return;
            if (void 0 === r.isScrolling) {
                let e;
                i.isHorizontal() && s.currentY === s.startY || i.isVertical() && s.currentX === s.startX ? r.isScrolling = !1 : p * p + m * m >= 25 && (e = 180 * Math.atan2(Math.abs(m), Math.abs(p)) / Math.PI, r.isScrolling = i.isHorizontal() ? e > n.touchAngle : 90 - e > n.touchAngle)
            }
            if (r.isScrolling && i.emit("touchMoveOpposite", c), void 0 === r.startMoving && (s.currentX === s.startX && s.currentY === s.startY || (r.startMoving = !0)), r.isScrolling) return void (r.isTouched = !1);
            if (!r.startMoving) return;
            i.allowClick = !1, !n.cssMode && c.cancelable && c.preventDefault(), n.touchMoveStopPropagation && !n.nested && c.stopPropagation();
            let g = i.isHorizontal() ? p : m,
                v = i.isHorizontal() ? s.currentX - s.previousX : s.currentY - s.previousY;
            n.oneWayMovement && (g = Math.abs(g) * (a ? 1 : -1), v = Math.abs(v) * (a ? 1 : -1)), s.diff = g, g *= n.touchRatio, a && (g = -g, v = -v);
            const y = i.touchesDirection;
            i.swipeDirection = g > 0 ? "prev" : "next", i.touchesDirection = v > 0 ? "prev" : "next";
            const w = i.params.loop && !n.cssMode,
                _ = "next" === i.touchesDirection && i.allowSlideNext || "prev" === i.touchesDirection && i.allowSlidePrev;
            if (!r.isMoved) {
                if (w && _ && i.loopFix({
                    direction: i.swipeDirection
                }), r.startTranslate = i.getTranslate(), i.setTransition(0), i.animating) {
                    const e = new window.CustomEvent("transitionend", {
                        bubbles: !0,
                        cancelable: !0
                    });
                    i.wrapperEl.dispatchEvent(e)
                }
                r.allowMomentumBounce = !1, !n.grabCursor || !0 !== i.allowSlideNext && !0 !== i.allowSlidePrev || i.setGrabCursor(!0), i.emit("sliderFirstMove", c)
            }
            if ((new Date).getTime(), r.isMoved && r.allowThresholdMove && y !== i.touchesDirection && w && _ && Math.abs(g) >= 1) return Object.assign(s, {
                startX: u,
                startY: h,
                currentX: u,
                currentY: h,
                startTranslate: r.currentTranslate
            }), r.loopSwapReset = !0, void (r.startTranslate = r.currentTranslate);
            i.emit("sliderMove", c), r.isMoved = !0, r.currentTranslate = g + r.startTranslate;
            let b = !0,
                x = n.resistanceRatio;
            if (n.touchReleaseOnEdges && (x = 0), g > 0 ? (w && _ && r.allowThresholdMove && r.currentTranslate > (n.centeredSlides ? i.minTranslate() - i.slidesSizesGrid[i.activeIndex + 1] : i.minTranslate()) && i.loopFix({
                direction: "prev",
                setTranslate: !0,
                activeSlideIndex: 0
            }), r.currentTranslate > i.minTranslate() && (b = !1, n.resistance && (r.currentTranslate = i.minTranslate() - 1 + (-i.minTranslate() + r.startTranslate + g) ** x))) : g < 0 && (w && _ && r.allowThresholdMove && r.currentTranslate < (n.centeredSlides ? i.maxTranslate() + i.slidesSizesGrid[i.slidesSizesGrid.length - 1] : i.maxTranslate()) && i.loopFix({
                direction: "next",
                setTranslate: !0,
                activeSlideIndex: i.slides.length - ("auto" === n.slidesPerView ? i.slidesPerViewDynamic() : Math.ceil(parseFloat(n.slidesPerView, 10)))
            }), r.currentTranslate < i.maxTranslate() && (b = !1, n.resistance && (r.currentTranslate = i.maxTranslate() + 1 - (i.maxTranslate() - r.startTranslate - g) ** x))), b && (c.preventedByNestedSwiper = !0), !i.allowSlideNext && "next" === i.swipeDirection && r.currentTranslate < r.startTranslate && (r.currentTranslate = r.startTranslate), !i.allowSlidePrev && "prev" === i.swipeDirection && r.currentTranslate > r.startTranslate && (r.currentTranslate = r.startTranslate), i.allowSlidePrev || i.allowSlideNext || (r.currentTranslate = r.startTranslate), n.threshold > 0) {
                if (!(Math.abs(g) > n.threshold || r.allowThresholdMove)) return void (r.currentTranslate = r.startTranslate);
                if (!r.allowThresholdMove) return r.allowThresholdMove = !0, s.startX = s.currentX, s.startY = s.currentY, r.currentTranslate = r.startTranslate, void (s.diff = i.isHorizontal() ? s.currentX - s.startX : s.currentY - s.startY)
            }
            n.followFinger && !n.cssMode && ((n.freeMode && n.freeMode.enabled && i.freeMode || n.watchSlidesProgress) && (i.updateActiveIndex(), i.updateSlidesClasses()), n.freeMode && n.freeMode.enabled && i.freeMode && i.freeMode.onTouchMove(), i.updateProgress(r.currentTranslate), i.setTranslate(r.currentTranslate))
        }

        function Y(e) {
            const t = this,
                i = t.touchEventsData;
            let r, n = e;
            if (n.originalEvent && (n = n.originalEvent), "touchend" === n.type || "touchcancel" === n.type) {
                if (r = [...n.changedTouches].filter((e => e.identifier === i.touchId))[0], !r || r.identifier !== i.touchId) return
            } else {
                if (null !== i.touchId) return;
                if (n.pointerId !== i.pointerId) return;
                r = n
            }
            if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(n.type) && (!["pointercancel", "contextmenu"].includes(n.type) || !t.browser.isSafari && !t.browser.isWebView)) return;
            i.pointerId = null, i.touchId = null;
            const {
                params: s,
                touches: a,
                rtlTranslate: o,
                slidesGrid: l,
                enabled: c
            } = t;
            if (!c) return;
            if (!s.simulateTouch && "mouse" === n.pointerType) return;
            if (i.allowTouchCallbacks && t.emit("touchEnd", n), i.allowTouchCallbacks = !1, !i.isTouched) return i.isMoved && s.grabCursor && t.setGrabCursor(!1), i.isMoved = !1, void (i.startMoving = !1);
            s.grabCursor && i.isMoved && i.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
            const d = f(),
                u = d - i.touchStartTime;
            if (t.allowClick) {
                const e = n.path || n.composedPath && n.composedPath();
                t.updateClickedSlide(e && e[0] || n.target, e), t.emit("tap click", n), u < 300 && d - i.lastClickTime < 300 && t.emit("doubleTap doubleClick", n)
            }
            if (i.lastClickTime = f(), p((() => {
                t.destroyed || (t.allowClick = !0)
            })), !i.isTouched || !i.isMoved || !t.swipeDirection || 0 === a.diff && !i.loopSwapReset || i.currentTranslate === i.startTranslate && !i.loopSwapReset) return i.isTouched = !1, i.isMoved = !1, void (i.startMoving = !1);
            let h;
            if (i.isTouched = !1, i.isMoved = !1, i.startMoving = !1, h = s.followFinger ? o ? t.translate : -t.translate : -i.currentTranslate, s.cssMode) return;
            if (s.freeMode && s.freeMode.enabled) return void t.freeMode.onTouchEnd({
                currentPos: h
            });
            const m = h >= -t.maxTranslate() && !t.params.loop;
            let g = 0,
                v = t.slidesSizesGrid[0];
            for (let e = 0; e < l.length; e += e < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup) {
                const t = e < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
                void 0 !== l[e + t] ? (m || h >= l[e] && h < l[e + t]) && (g = e, v = l[e + t] - l[e]) : (m || h >= l[e]) && (g = e, v = l[l.length - 1] - l[l.length - 2])
            }
            let y = null,
                w = null;
            s.rewind && (t.isBeginning ? w = s.virtual && s.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (y = 0));
            const _ = (h - l[g]) / v,
                b = g < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
            if (u > s.longSwipesMs) {
                if (!s.longSwipes) return void t.slideTo(t.activeIndex);
                "next" === t.swipeDirection && (_ >= s.longSwipesRatio ? t.slideTo(s.rewind && t.isEnd ? y : g + b) : t.slideTo(g)), "prev" === t.swipeDirection && (_ > 1 - s.longSwipesRatio ? t.slideTo(g + b) : null !== w && _ < 0 && Math.abs(_) > s.longSwipesRatio ? t.slideTo(w) : t.slideTo(g))
            } else {
                if (!s.shortSwipes) return void t.slideTo(t.activeIndex);
                !t.navigation || n.target !== t.navigation.nextEl && n.target !== t.navigation.prevEl ? ("next" === t.swipeDirection && t.slideTo(null !== y ? y : g + b), "prev" === t.swipeDirection && t.slideTo(null !== w ? w : g)) : n.target === t.navigation.nextEl ? t.slideTo(g + b) : t.slideTo(g)
            }
        }

        function X() {
            const e = this,
                {
                    params: t,
                    el: i
                } = e;
            if (i && 0 === i.offsetWidth) return;
            t.breakpoints && e.setBreakpoint();
            const {
                allowSlideNext: r,
                allowSlidePrev: n,
                snapGrid: s
            } = e, a = e.virtual && e.params.virtual.enabled;
            e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
            const o = a && t.loop;
            !("auto" === t.slidesPerView || t.slidesPerView > 1) || !e.isEnd || e.isBeginning || e.params.centeredSlides || o ? e.params.loop && !a ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0) : e.slideTo(e.slides.length - 1, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout((() => {
                e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume()
            }), 500)), e.allowSlidePrev = n, e.allowSlideNext = r, e.params.watchOverflow && s !== e.snapGrid && e.checkOverflow()
        }

        function V(e) {
            const t = this;
            t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())))
        }

        function q() {
            const e = this,
                {
                    wrapperEl: t,
                    rtlTranslate: i,
                    enabled: r
                } = e;
            if (!r) return;
            let n;
            e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, 0 === e.translate && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
            const s = e.maxTranslate() - e.minTranslate();
            n = 0 === s ? 0 : (e.translate - e.minTranslate()) / s, n !== e.progress && e.updateProgress(i ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1)
        }

        function $(e) {
            const t = this;
            A(t, e.target), t.params.cssMode || "auto" !== t.params.slidesPerView && !t.params.autoHeight || t.update()
        }

        function W() {
            const e = this;
            e.documentTouchHandlerProceeded || (e.documentTouchHandlerProceeded = !0, e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"))
        }
        const U = (e, t) => {
            const i = d(),
                {
                    params: r,
                    el: n,
                    wrapperEl: s,
                    device: a
                } = e,
                o = !!r.nested,
                l = "on" === t ? "addEventListener" : "removeEventListener",
                c = t;
            i[l]("touchstart", e.onDocumentTouchStart, {
                passive: !1,
                capture: o
            }), n[l]("touchstart", e.onTouchStart, {
                passive: !1
            }), n[l]("pointerdown", e.onTouchStart, {
                passive: !1
            }), i[l]("touchmove", e.onTouchMove, {
                passive: !1,
                capture: o
            }), i[l]("pointermove", e.onTouchMove, {
                passive: !1,
                capture: o
            }), i[l]("touchend", e.onTouchEnd, {
                passive: !0
            }), i[l]("pointerup", e.onTouchEnd, {
                passive: !0
            }), i[l]("pointercancel", e.onTouchEnd, {
                passive: !0
            }), i[l]("touchcancel", e.onTouchEnd, {
                passive: !0
            }), i[l]("pointerout", e.onTouchEnd, {
                passive: !0
            }), i[l]("pointerleave", e.onTouchEnd, {
                passive: !0
            }), i[l]("contextmenu", e.onTouchEnd, {
                passive: !0
            }), (r.preventClicks || r.preventClicksPropagation) && n[l]("click", e.onClick, !0), r.cssMode && s[l]("scroll", e.onScroll), r.updateOnWindowResize ? e[c](a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", X, !0) : e[c]("observerUpdate", X, !0), n[l]("load", e.onLoad, {
                capture: !0
            })
        },
            K = (e, t) => e.grid && t.grid && t.grid.rows > 1;
        var Z = {
            init: !0,
            direction: "horizontal",
            oneWayMovement: !1,
            touchEventsTarget: "wrapper",
            initialSlide: 0,
            speed: 300,
            cssMode: !1,
            updateOnWindowResize: !0,
            resizeObserver: !0,
            nested: !1,
            createElements: !1,
            eventsPrefix: "swiper",
            enabled: !0,
            focusableElements: "input, select, option, textarea, button, video, label",
            width: null,
            height: null,
            preventInteractionOnTransition: !1,
            userAgent: null,
            url: null,
            edgeSwipeDetection: !1,
            edgeSwipeThreshold: 20,
            autoHeight: !1,
            setWrapperSize: !1,
            virtualTranslate: !1,
            effect: "slide",
            breakpoints: void 0,
            breakpointsBase: "window",
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerGroup: 1,
            slidesPerGroupSkip: 0,
            slidesPerGroupAuto: !1,
            centeredSlides: !1,
            centeredSlidesBounds: !1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            normalizeSlideIndex: !0,
            centerInsufficientSlides: !1,
            watchOverflow: !0,
            roundLengths: !1,
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: !0,
            shortSwipes: !0,
            longSwipes: !0,
            longSwipesRatio: .5,
            longSwipesMs: 300,
            followFinger: !0,
            allowTouchMove: !0,
            threshold: 5,
            touchMoveStopPropagation: !1,
            touchStartPreventDefault: !0,
            touchStartForcePreventDefault: !1,
            touchReleaseOnEdges: !1,
            uniqueNavElements: !0,
            resistance: !0,
            resistanceRatio: .85,
            watchSlidesProgress: !1,
            grabCursor: !1,
            preventClicks: !0,
            preventClicksPropagation: !0,
            slideToClickedSlide: !1,
            loop: !1,
            loopAddBlankSlides: !0,
            loopAdditionalSlides: 0,
            loopPreventsSliding: !0,
            rewind: !1,
            allowSlidePrev: !0,
            allowSlideNext: !0,
            swipeHandler: null,
            noSwiping: !0,
            noSwipingClass: "swiper-no-swiping",
            noSwipingSelector: null,
            passiveListeners: !0,
            maxBackfaceHiddenSlides: 10,
            containerModifierClass: "swiper-",
            slideClass: "swiper-slide",
            slideBlankClass: "swiper-slide-blank",
            slideActiveClass: "swiper-slide-active",
            slideVisibleClass: "swiper-slide-visible",
            slideFullyVisibleClass: "swiper-slide-fully-visible",
            slideNextClass: "swiper-slide-next",
            slidePrevClass: "swiper-slide-prev",
            wrapperClass: "swiper-wrapper",
            lazyPreloaderClass: "swiper-lazy-preloader",
            lazyPreloadPrevNext: 0,
            runCallbacksOnInit: !0,
            _emitClasses: !1
        };

        function Q(e, t) {
            return function (i) {
                void 0 === i && (i = {});
                const r = Object.keys(i)[0],
                    n = i[r];
                "object" == typeof n && null !== n ? (!0 === e[r] && (e[r] = {
                    enabled: !0
                }), "navigation" === r && e[r] && e[r].enabled && !e[r].prevEl && !e[r].nextEl && (e[r].auto = !0), ["pagination", "scrollbar"].indexOf(r) >= 0 && e[r] && e[r].enabled && !e[r].el && (e[r].auto = !0), r in e && "enabled" in n ? ("object" != typeof e[r] || "enabled" in e[r] || (e[r].enabled = !0), e[r] || (e[r] = {
                    enabled: !1
                }), g(t, i)) : g(t, i)) : g(t, i)
            }
        }
        const J = {
            eventsEmitter: O,
            update: z,
            translate: R,
            transition: {
                setTransition: function (e, t) {
                    const i = this;
                    i.params.cssMode || (i.wrapperEl.style.transitionDuration = `${e}ms`, i.wrapperEl.style.transitionDelay = 0 === e ? "0ms" : ""), i.emit("setTransition", e, t)
                },
                transitionStart: function (e, t) {
                    void 0 === e && (e = !0);
                    const i = this,
                        {
                            params: r
                        } = i;
                    r.cssMode || (r.autoHeight && i.updateAutoHeight(), B({
                        swiper: i,
                        runCallbacks: e,
                        direction: t,
                        step: "Start"
                    }))
                },
                transitionEnd: function (e, t) {
                    void 0 === e && (e = !0);
                    const i = this,
                        {
                            params: r
                        } = i;
                    i.animating = !1, r.cssMode || (i.setTransition(0), B({
                        swiper: i,
                        runCallbacks: e,
                        direction: t,
                        step: "End"
                    }))
                }
            },
            slide: F,
            loop: N,
            grabCursor: {
                setGrabCursor: function (e) {
                    const t = this;
                    if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
                    const i = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
                    t.isElement && (t.__preventObserver__ = !0), i.style.cursor = "move", i.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame((() => {
                        t.__preventObserver__ = !1
                    }))
                },
                unsetGrabCursor: function () {
                    const e = this;
                    e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame((() => {
                        e.__preventObserver__ = !1
                    })))
                }
            },
            events: {
                attachEvents: function () {
                    const e = this,
                        {
                            params: t
                        } = e;
                    e.onTouchStart = H.bind(e), e.onTouchMove = G.bind(e), e.onTouchEnd = Y.bind(e), e.onDocumentTouchStart = W.bind(e), t.cssMode && (e.onScroll = q.bind(e)), e.onClick = V.bind(e), e.onLoad = $.bind(e), U(e, "on")
                },
                detachEvents: function () {
                    U(this, "off")
                }
            },
            breakpoints: {
                setBreakpoint: function () {
                    const e = this,
                        {
                            realIndex: t,
                            initialized: i,
                            params: r,
                            el: n
                        } = e,
                        s = r.breakpoints;
                    if (!s || s && 0 === Object.keys(s).length) return;
                    const a = e.getBreakpoint(s, e.params.breakpointsBase, e.el);
                    if (!a || e.currentBreakpoint === a) return;
                    const o = (a in s ? s[a] : void 0) || e.originalParams,
                        l = K(e, r),
                        c = K(e, o),
                        d = r.enabled;
                    l && !c ? (n.classList.remove(`${r.containerModifierClass}grid`, `${r.containerModifierClass}grid-column`), e.emitContainerClasses()) : !l && c && (n.classList.add(`${r.containerModifierClass}grid`), (o.grid.fill && "column" === o.grid.fill || !o.grid.fill && "column" === r.grid.fill) && n.classList.add(`${r.containerModifierClass}grid-column`), e.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach((t => {
                        if (void 0 === o[t]) return;
                        const i = r[t] && r[t].enabled,
                            n = o[t] && o[t].enabled;
                        i && !n && e[t].disable(), !i && n && e[t].enable()
                    }));
                    const u = o.direction && o.direction !== r.direction,
                        h = r.loop && (o.slidesPerView !== r.slidesPerView || u),
                        p = r.loop;
                    u && i && e.changeDirection(), g(e.params, o);
                    const f = e.params.enabled,
                        m = e.params.loop;
                    Object.assign(e, {
                        allowTouchMove: e.params.allowTouchMove,
                        allowSlideNext: e.params.allowSlideNext,
                        allowSlidePrev: e.params.allowSlidePrev
                    }), d && !f ? e.disable() : !d && f && e.enable(), e.currentBreakpoint = a, e.emit("_beforeBreakpoint", o), i && (h ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !p && m ? (e.loopCreate(t), e.updateSlides()) : p && !m && e.loopDestroy()), e.emit("breakpoint", o)
                },
                getBreakpoint: function (e, t, i) {
                    if (void 0 === t && (t = "window"), !e || "container" === t && !i) return;
                    let r = !1;
                    const n = h(),
                        s = "window" === t ? n.innerHeight : i.clientHeight,
                        a = Object.keys(e).map((e => {
                            if ("string" == typeof e && 0 === e.indexOf("@")) {
                                const t = parseFloat(e.substr(1));
                                return {
                                    value: s * t,
                                    point: e
                                }
                            }
                            return {
                                value: e,
                                point: e
                            }
                        }));
                    a.sort(((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10)));
                    for (let e = 0; e < a.length; e += 1) {
                        const {
                            point: s,
                            value: o
                        } = a[e];
                        "window" === t ? n.matchMedia(`(min-width: ${o}px)`).matches && (r = s) : o <= i.clientWidth && (r = s)
                    }
                    return r || "max"
                }
            },
            checkOverflow: {
                checkOverflow: function () {
                    const e = this,
                        {
                            isLocked: t,
                            params: i
                        } = e,
                        {
                            slidesOffsetBefore: r
                        } = i;
                    if (r) {
                        const t = e.slides.length - 1,
                            i = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * r;
                        e.isLocked = e.size > i
                    } else e.isLocked = 1 === e.snapGrid.length;
                    !0 === i.allowSlideNext && (e.allowSlideNext = !e.isLocked), !0 === i.allowSlidePrev && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock")
                }
            },
            classes: {
                addClasses: function () {
                    const e = this,
                        {
                            classNames: t,
                            params: i,
                            rtl: r,
                            el: n,
                            device: s
                        } = e,
                        a = function (e, t) {
                            const i = [];
                            return e.forEach((e => {
                                "object" == typeof e ? Object.keys(e).forEach((r => {
                                    e[r] && i.push(t + r)
                                })) : "string" == typeof e && i.push(t + e)
                            })), i
                        }(["initialized", i.direction, {
                            "free-mode": e.params.freeMode && i.freeMode.enabled
                        }, {
                                autoheight: i.autoHeight
                            }, {
                                rtl: r
                            }, {
                                grid: i.grid && i.grid.rows > 1
                            }, {
                                "grid-column": i.grid && i.grid.rows > 1 && "column" === i.grid.fill
                            }, {
                                android: s.android
                            }, {
                                ios: s.ios
                            }, {
                                "css-mode": i.cssMode
                            }, {
                                centered: i.cssMode && i.centeredSlides
                            }, {
                                "watch-progress": i.watchSlidesProgress
                            }], i.containerModifierClass);
                    t.push(...a), n.classList.add(...t), e.emitContainerClasses()
                },
                removeClasses: function () {
                    const {
                        el: e,
                        classNames: t
                    } = this;
                    e.classList.remove(...t), this.emitContainerClasses()
                }
            }
        },
            ee = {};
        class te {
            constructor() {
                let e, t;
                for (var i = arguments.length, r = new Array(i), n = 0; n < i; n++) r[n] = arguments[n];
                1 === r.length && r[0].constructor && "Object" === Object.prototype.toString.call(r[0]).slice(8, -1) ? t = r[0] : [e, t] = r, t || (t = {}), t = g({}, t), e && !t.el && (t.el = e);
                const s = d();
                if (t.el && "string" == typeof t.el && s.querySelectorAll(t.el).length > 1) {
                    const e = [];
                    return s.querySelectorAll(t.el).forEach((i => {
                        const r = g({}, t, {
                            el: i
                        });
                        e.push(new te(r))
                    })), e
                }
                const a = this;
                var o;
                a.__swiper__ = !0, a.support = L(), a.device = (void 0 === (o = {
                    userAgent: t.userAgent
                }) && (o = {}), k || (k = function (e) {
                    let {
                        userAgent: t
                    } = void 0 === e ? {} : e;
                    const i = L(),
                        r = h(),
                        n = r.navigator.platform,
                        s = t || r.navigator.userAgent,
                        a = {
                            ios: !1,
                            android: !1
                        },
                        o = r.screen.width,
                        l = r.screen.height,
                        c = s.match(/(Android);?[\s\/]+([\d.]+)?/);
                    let d = s.match(/(iPad).*OS\s([\d_]+)/);
                    const u = s.match(/(iPod)(.*OS\s([\d_]+))?/),
                        p = !d && s.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                        f = "Win32" === n;
                    let m = "MacIntel" === n;
                    return !d && m && i.touch && ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(`${o}x${l}`) >= 0 && (d = s.match(/(Version)\/([\d.]+)/), d || (d = [0, 1, "13_0_0"]), m = !1), c && !f && (a.os = "android", a.android = !0), (d || p || u) && (a.os = "ios", a.ios = !0), a
                }(o)), k), a.browser = (C || (C = function () {
                    const e = h();
                    let t = !1;

                    function i() {
                        const t = e.navigator.userAgent.toLowerCase();
                        return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0
                    }
                    if (i()) {
                        const i = String(e.navigator.userAgent);
                        if (i.includes("Version/")) {
                            const [e, r] = i.split("Version/")[1].split(" ")[0].split(".").map((e => Number(e)));
                            t = e < 16 || 16 === e && r < 2
                        }
                    }
                    return {
                        isSafari: t || i(),
                        needPerspectiveFix: t,
                        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
                    }
                }()), C), a.eventsListeners = {}, a.eventsAnyListeners = [], a.modules = [...a.__modules__], t.modules && Array.isArray(t.modules) && a.modules.push(...t.modules);
                const l = {};
                a.modules.forEach((e => {
                    e({
                        params: t,
                        swiper: a,
                        extendParams: Q(t, l),
                        on: a.on.bind(a),
                        once: a.once.bind(a),
                        off: a.off.bind(a),
                        emit: a.emit.bind(a)
                    })
                }));
                const c = g({}, Z, l);
                return a.params = g({}, c, ee, t), a.originalParams = g({}, a.params), a.passedParams = g({}, t), a.params && a.params.on && Object.keys(a.params.on).forEach((e => {
                    a.on(e, a.params.on[e])
                })), a.params && a.params.onAny && a.onAny(a.params.onAny), Object.assign(a, {
                    enabled: a.params.enabled,
                    el: e,
                    classNames: [],
                    slides: [],
                    slidesGrid: [],
                    snapGrid: [],
                    slidesSizesGrid: [],
                    isHorizontal: () => "horizontal" === a.params.direction,
                    isVertical: () => "vertical" === a.params.direction,
                    activeIndex: 0,
                    realIndex: 0,
                    isBeginning: !0,
                    isEnd: !1,
                    translate: 0,
                    previousTranslate: 0,
                    progress: 0,
                    velocity: 0,
                    animating: !1,
                    cssOverflowAdjustment() {
                        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23
                    },
                    allowSlideNext: a.params.allowSlideNext,
                    allowSlidePrev: a.params.allowSlidePrev,
                    touchEventsData: {
                        isTouched: void 0,
                        isMoved: void 0,
                        allowTouchCallbacks: void 0,
                        touchStartTime: void 0,
                        isScrolling: void 0,
                        currentTranslate: void 0,
                        startTranslate: void 0,
                        allowThresholdMove: void 0,
                        focusableElements: a.params.focusableElements,
                        lastClickTime: 0,
                        clickTimeout: void 0,
                        velocities: [],
                        allowMomentumBounce: void 0,
                        startMoving: void 0,
                        pointerId: null,
                        touchId: null
                    },
                    allowClick: !0,
                    allowTouchMove: a.params.allowTouchMove,
                    touches: {
                        startX: 0,
                        startY: 0,
                        currentX: 0,
                        currentY: 0,
                        diff: 0
                    },
                    imagesToLoad: [],
                    imagesLoaded: 0
                }), a.emit("_swiper"), a.params.init && a.init(), a
            }
            getDirectionLabel(e) {
                return this.isHorizontal() ? e : {
                    width: "height",
                    "margin-top": "margin-left",
                    "margin-bottom ": "margin-right",
                    "margin-left": "margin-top",
                    "margin-right": "margin-bottom",
                    "padding-left": "padding-top",
                    "padding-right": "padding-bottom",
                    marginRight: "marginBottom"
                }[e]
            }
            getSlideIndex(e) {
                const {
                    slidesEl: t,
                    params: i
                } = this, r = E(_(t, `.${i.slideClass}, swiper-slide`)[0]);
                return E(e) - r
            }
            getSlideIndexByData(e) {
                return this.getSlideIndex(this.slides.filter((t => 1 * t.getAttribute("data-swiper-slide-index") === e))[0])
            }
            recalcSlides() {
                const {
                    slidesEl: e,
                    params: t
                } = this;
                this.slides = _(e, `.${t.slideClass}, swiper-slide`)
            }
            enable() {
                const e = this;
                e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"))
            }
            disable() {
                const e = this;
                e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"))
            }
            setProgress(e, t) {
                const i = this;
                e = Math.min(Math.max(e, 0), 1);
                const r = i.minTranslate(),
                    n = (i.maxTranslate() - r) * e + r;
                i.translateTo(n, void 0 === t ? 0 : t), i.updateActiveIndex(), i.updateSlidesClasses()
            }
            emitContainerClasses() {
                const e = this;
                if (!e.params._emitClasses || !e.el) return;
                const t = e.el.className.split(" ").filter((t => 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass)));
                e.emit("_containerClasses", t.join(" "))
            }
            getSlideClasses(e) {
                const t = this;
                return t.destroyed ? "" : e.className.split(" ").filter((e => 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass))).join(" ")
            }
            emitSlidesClasses() {
                const e = this;
                if (!e.params._emitClasses || !e.el) return;
                const t = [];
                e.slides.forEach((i => {
                    const r = e.getSlideClasses(i);
                    t.push({
                        slideEl: i,
                        classNames: r
                    }), e.emit("_slideClass", i, r)
                })), e.emit("_slideClasses", t)
            }
            slidesPerViewDynamic(e, t) {
                void 0 === e && (e = "current"), void 0 === t && (t = !1);
                const {
                    params: i,
                    slides: r,
                    slidesGrid: n,
                    slidesSizesGrid: s,
                    size: a,
                    activeIndex: o
                } = this;
                let l = 1;
                if ("number" == typeof i.slidesPerView) return i.slidesPerView;
                if (i.centeredSlides) {
                    let e, t = r[o] ? r[o].swiperSlideSize : 0;
                    for (let i = o + 1; i < r.length; i += 1) r[i] && !e && (t += r[i].swiperSlideSize, l += 1, t > a && (e = !0));
                    for (let i = o - 1; i >= 0; i -= 1) r[i] && !e && (t += r[i].swiperSlideSize, l += 1, t > a && (e = !0))
                } else if ("current" === e)
                    for (let e = o + 1; e < r.length; e += 1)(t ? n[e] + s[e] - n[o] < a : n[e] - n[o] < a) && (l += 1);
                else
                    for (let e = o - 1; e >= 0; e -= 1) n[o] - n[e] < a && (l += 1);
                return l
            }
            update() {
                const e = this;
                if (!e || e.destroyed) return;
                const {
                    snapGrid: t,
                    params: i
                } = e;

                function r() {
                    const t = e.rtlTranslate ? -1 * e.translate : e.translate,
                        i = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                    e.setTranslate(i), e.updateActiveIndex(), e.updateSlidesClasses()
                }
                let n;
                if (i.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach((t => {
                    t.complete && A(e, t)
                })), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), i.freeMode && i.freeMode.enabled && !i.cssMode) r(), i.autoHeight && e.updateAutoHeight();
                else {
                    if (("auto" === i.slidesPerView || i.slidesPerView > 1) && e.isEnd && !i.centeredSlides) {
                        const t = e.virtual && i.virtual.enabled ? e.virtual.slides : e.slides;
                        n = e.slideTo(t.length - 1, 0, !1, !0)
                    } else n = e.slideTo(e.activeIndex, 0, !1, !0);
                    n || r()
                }
                i.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update")
            }
            changeDirection(e, t) {
                void 0 === t && (t = !0);
                const i = this,
                    r = i.params.direction;
                return e || (e = "horizontal" === r ? "vertical" : "horizontal"), e === r || "horizontal" !== e && "vertical" !== e || (i.el.classList.remove(`${i.params.containerModifierClass}${r}`), i.el.classList.add(`${i.params.containerModifierClass}${e}`), i.emitContainerClasses(), i.params.direction = e, i.slides.forEach((t => {
                    "vertical" === e ? t.style.width = "" : t.style.height = ""
                })), i.emit("changeDirection"), t && i.update()), i
            }
            changeLanguageDirection(e) {
                const t = this;
                t.rtl && "rtl" === e || !t.rtl && "ltr" === e || (t.rtl = "rtl" === e, t.rtlTranslate = "horizontal" === t.params.direction && t.rtl, t.rtl ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`), t.el.dir = "rtl") : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`), t.el.dir = "ltr"), t.update())
            }
            mount(e) {
                const t = this;
                if (t.mounted) return !0;
                let i = e || t.params.el;
                if ("string" == typeof i && (i = document.querySelector(i)), !i) return !1;
                i.swiper = t, i.parentNode && i.parentNode.host && "SWIPER-CONTAINER" === i.parentNode.host.nodeName && (t.isElement = !0);
                const r = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
                let n = i && i.shadowRoot && i.shadowRoot.querySelector ? i.shadowRoot.querySelector(r()) : _(i, r())[0];
                return !n && t.params.createElements && (n = x("div", t.params.wrapperClass), i.append(n), _(i, `.${t.params.slideClass}`).forEach((e => {
                    n.append(e)
                }))), Object.assign(t, {
                    el: i,
                    wrapperEl: n,
                    slidesEl: t.isElement && !i.parentNode.host.slideSlots ? i.parentNode.host : n,
                    hostEl: t.isElement ? i.parentNode.host : i,
                    mounted: !0,
                    rtl: "rtl" === i.dir.toLowerCase() || "rtl" === T(i, "direction"),
                    rtlTranslate: "horizontal" === t.params.direction && ("rtl" === i.dir.toLowerCase() || "rtl" === T(i, "direction")),
                    wrongRTL: "-webkit-box" === T(n, "display")
                }), !0
            }
            init(e) {
                const t = this;
                if (t.initialized) return t;
                if (!1 === t.mount(e)) return t;
                t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.loop && t.virtual && t.params.virtual.enabled ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.params.loop && t.loopCreate(), t.attachEvents();
                const i = [...t.el.querySelectorAll('[loading="lazy"]')];
                return t.isElement && i.push(...t.hostEl.querySelectorAll('[loading="lazy"]')), i.forEach((e => {
                    e.complete ? A(t, e) : e.addEventListener("load", (e => {
                        A(t, e.target)
                    }))
                })), I(t), t.initialized = !0, I(t), t.emit("init"), t.emit("afterInit"), t
            }
            destroy(e, t) {
                void 0 === e && (e = !0), void 0 === t && (t = !0);
                const i = this,
                    {
                        params: r,
                        el: n,
                        wrapperEl: s,
                        slides: a
                    } = i;
                return void 0 === i.params || i.destroyed || (i.emit("beforeDestroy"), i.initialized = !1, i.detachEvents(), r.loop && i.loopDestroy(), t && (i.removeClasses(), n.removeAttribute("style"), s.removeAttribute("style"), a && a.length && a.forEach((e => {
                    e.classList.remove(r.slideVisibleClass, r.slideFullyVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass), e.removeAttribute("style"), e.removeAttribute("data-swiper-slide-index")
                }))), i.emit("destroy"), Object.keys(i.eventsListeners).forEach((e => {
                    i.off(e)
                })), !1 !== e && (i.el.swiper = null, function (e) {
                    const t = e;
                    Object.keys(t).forEach((e => {
                        try {
                            t[e] = null
                        } catch (e) { }
                        try {
                            delete t[e]
                        } catch (e) { }
                    }))
                }(i)), i.destroyed = !0), null
            }
            static extendDefaults(e) {
                g(ee, e)
            }
            static get extendedDefaults() {
                return ee
            }
            static get defaults() {
                return Z
            }
            static installModule(e) {
                te.prototype.__modules__ || (te.prototype.__modules__ = []);
                const t = te.prototype.__modules__;
                "function" == typeof e && t.indexOf(e) < 0 && t.push(e)
            }
            static use(e) {
                return Array.isArray(e) ? (e.forEach((e => te.installModule(e))), te) : (te.installModule(e), te)
            }
        }

        function ie(e) {
            let {
                swiper: t,
                extendParams: i,
                on: r,
                emit: n
            } = e;
            const s = h();
            let a;
            i({
                mousewheel: {
                    enabled: !1,
                    releaseOnEdges: !1,
                    invert: !1,
                    forceToAxis: !1,
                    sensitivity: 1,
                    eventsTarget: "container",
                    thresholdDelta: null,
                    thresholdTime: null,
                    noMousewheelClass: "swiper-no-mousewheel"
                }
            }), t.mousewheel = {
                enabled: !1
            };
            let o, l = f();
            const c = [];

            function d() {
                t.enabled && (t.mouseEntered = !0)
            }

            function u() {
                t.enabled && (t.mouseEntered = !1)
            }

            function m(e) {
                return !(t.params.mousewheel.thresholdDelta && e.delta < t.params.mousewheel.thresholdDelta || t.params.mousewheel.thresholdTime && f() - l < t.params.mousewheel.thresholdTime || !(e.delta >= 6 && f() - l < 60) && (e.direction < 0 ? t.isEnd && !t.params.loop || t.animating || (t.slideNext(), n("scroll", e.raw)) : t.isBeginning && !t.params.loop || t.animating || (t.slidePrev(), n("scroll", e.raw)), l = (new s.Date).getTime(), 1))
            }

            function g(e) {
                let i = e,
                    r = !0;
                if (!t.enabled) return;
                if (e.target.closest(`.${t.params.mousewheel.noMousewheelClass}`)) return;
                const s = t.params.mousewheel;
                t.params.cssMode && i.preventDefault();
                let l = t.el;
                "container" !== t.params.mousewheel.eventsTarget && (l = document.querySelector(t.params.mousewheel.eventsTarget));
                const d = l && l.contains(i.target);
                if (!t.mouseEntered && !d && !s.releaseOnEdges) return !0;
                i.originalEvent && (i = i.originalEvent);
                let u = 0;
                const h = t.rtlTranslate ? -1 : 1,
                    g = function (e) {
                        let t = 0,
                            i = 0,
                            r = 0,
                            n = 0;
                        return "detail" in e && (i = e.detail), "wheelDelta" in e && (i = -e.wheelDelta / 120), "wheelDeltaY" in e && (i = -e.wheelDeltaY / 120), "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120), "axis" in e && e.axis === e.HORIZONTAL_AXIS && (t = i, i = 0), r = 10 * t, n = 10 * i, "deltaY" in e && (n = e.deltaY), "deltaX" in e && (r = e.deltaX), e.shiftKey && !r && (r = n, n = 0), (r || n) && e.deltaMode && (1 === e.deltaMode ? (r *= 40, n *= 40) : (r *= 800, n *= 800)), r && !t && (t = r < 1 ? -1 : 1), n && !i && (i = n < 1 ? -1 : 1), {
                            spinX: t,
                            spinY: i,
                            pixelX: r,
                            pixelY: n
                        }
                    }(i);
                if (s.forceToAxis)
                    if (t.isHorizontal()) {
                        if (!(Math.abs(g.pixelX) > Math.abs(g.pixelY))) return !0;
                        u = -g.pixelX * h
                    } else {
                        if (!(Math.abs(g.pixelY) > Math.abs(g.pixelX))) return !0;
                        u = -g.pixelY
                    }
                else u = Math.abs(g.pixelX) > Math.abs(g.pixelY) ? -g.pixelX * h : -g.pixelY;
                if (0 === u) return !0;
                s.invert && (u = -u);
                let v = t.getTranslate() + u * s.sensitivity;
                if (v >= t.minTranslate() && (v = t.minTranslate()), v <= t.maxTranslate() && (v = t.maxTranslate()), r = !!t.params.loop || !(v === t.minTranslate() || v === t.maxTranslate()), r && t.params.nested && i.stopPropagation(), t.params.freeMode && t.params.freeMode.enabled) {
                    const e = {
                        time: f(),
                        delta: Math.abs(u),
                        direction: Math.sign(u)
                    },
                        r = o && e.time < o.time + 500 && e.delta <= o.delta && e.direction === o.direction;
                    if (!r) {
                        o = void 0;
                        let l = t.getTranslate() + u * s.sensitivity;
                        const d = t.isBeginning,
                            h = t.isEnd;
                        if (l >= t.minTranslate() && (l = t.minTranslate()), l <= t.maxTranslate() && (l = t.maxTranslate()), t.setTransition(0), t.setTranslate(l), t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses(), (!d && t.isBeginning || !h && t.isEnd) && t.updateSlidesClasses(), t.params.loop && t.loopFix({
                            direction: e.direction < 0 ? "next" : "prev",
                            byMousewheel: !0
                        }), t.params.freeMode.sticky) {
                            clearTimeout(a), a = void 0, c.length >= 15 && c.shift();
                            const i = c.length ? c[c.length - 1] : void 0,
                                r = c[0];
                            if (c.push(e), i && (e.delta > i.delta || e.direction !== i.direction)) c.splice(0);
                            else if (c.length >= 15 && e.time - r.time < 500 && r.delta - e.delta >= 1 && e.delta <= 6) {
                                const i = u > 0 ? .8 : .2;
                                o = e, c.splice(0), a = p((() => {
                                    t.slideToClosest(t.params.speed, !0, void 0, i)
                                }), 0)
                            }
                            a || (a = p((() => {
                                o = e, c.splice(0), t.slideToClosest(t.params.speed, !0, void 0, .5)
                            }), 500))
                        }
                        if (r || n("scroll", i), t.params.autoplay && t.params.autoplayDisableOnInteraction && t.autoplay.stop(), s.releaseOnEdges && (l === t.minTranslate() || l === t.maxTranslate())) return !0
                    }
                } else {
                    const i = {
                        time: f(),
                        delta: Math.abs(u),
                        direction: Math.sign(u),
                        raw: e
                    };
                    c.length >= 2 && c.shift();
                    const r = c.length ? c[c.length - 1] : void 0;
                    if (c.push(i), r ? (i.direction !== r.direction || i.delta > r.delta || i.time > r.time + 150) && m(i) : m(i), function (e) {
                        const i = t.params.mousewheel;
                        if (e.direction < 0) {
                            if (t.isEnd && !t.params.loop && i.releaseOnEdges) return !0
                        } else if (t.isBeginning && !t.params.loop && i.releaseOnEdges) return !0;
                        return !1
                    }(i)) return !0
                }
                return i.preventDefault ? i.preventDefault() : i.returnValue = !1, !1
            }

            function v(e) {
                let i = t.el;
                "container" !== t.params.mousewheel.eventsTarget && (i = document.querySelector(t.params.mousewheel.eventsTarget)), i[e]("mouseenter", d), i[e]("mouseleave", u), i[e]("wheel", g)
            }

            function y() {
                return t.params.cssMode ? (t.wrapperEl.removeEventListener("wheel", g), !0) : !t.mousewheel.enabled && (v("addEventListener"), t.mousewheel.enabled = !0, !0)
            }

            function w() {
                return t.params.cssMode ? (t.wrapperEl.addEventListener(event, g), !0) : !!t.mousewheel.enabled && (v("removeEventListener"), t.mousewheel.enabled = !1, !0)
            }
            r("init", (() => {
                !t.params.mousewheel.enabled && t.params.cssMode && w(), t.params.mousewheel.enabled && y()
            })), r("destroy", (() => {
                t.params.cssMode && y(), t.mousewheel.enabled && w()
            })), Object.assign(t.mousewheel, {
                enable: y,
                disable: w
            })
        }

        function re(e) {
            let {
                swiper: t,
                extendParams: i,
                on: r,
                emit: n
            } = e;
            i({
                navigation: {
                    nextEl: null,
                    prevEl: null,
                    hideOnClick: !1,
                    disabledClass: "swiper-button-disabled",
                    hiddenClass: "swiper-button-hidden",
                    lockClass: "swiper-button-lock",
                    navigationDisabledClass: "swiper-navigation-disabled"
                }
            }), t.navigation = {
                nextEl: null,
                prevEl: null
            };
            const s = e => (Array.isArray(e) ? e : [e]).filter((e => !!e));

            function a(e) {
                let i;
                return e && "string" == typeof e && t.isElement && (i = t.el.querySelector(e), i) ? i : (e && ("string" == typeof e && (i = [...document.querySelectorAll(e)]), t.params.uniqueNavElements && "string" == typeof e && i.length > 1 && 1 === t.el.querySelectorAll(e).length && (i = t.el.querySelector(e))), e && !i ? e : i)
            }

            function o(e, i) {
                const r = t.params.navigation;
                (e = s(e)).forEach((e => {
                    e && (e.classList[i ? "add" : "remove"](...r.disabledClass.split(" ")), "BUTTON" === e.tagName && (e.disabled = i), t.params.watchOverflow && t.enabled && e.classList[t.isLocked ? "add" : "remove"](r.lockClass))
                }))
            }

            function l() {
                const {
                    nextEl: e,
                    prevEl: i
                } = t.navigation;
                if (t.params.loop) return o(i, !1), void o(e, !1);
                o(i, t.isBeginning && !t.params.rewind), o(e, t.isEnd && !t.params.rewind)
            }

            function c(e) {
                e.preventDefault(), (!t.isBeginning || t.params.loop || t.params.rewind) && (t.slidePrev(), n("navigationPrev"))
            }

            function d(e) {
                e.preventDefault(), (!t.isEnd || t.params.loop || t.params.rewind) && (t.slideNext(), n("navigationNext"))
            }

            function u() {
                const e = t.params.navigation;
                if (t.params.navigation = function (e, t, i, r) {
                    return e.params.createElements && Object.keys(r).forEach((n => {
                        if (!i[n] && !0 === i.auto) {
                            let s = _(e.el, `.${r[n]}`)[0];
                            s || (s = x("div", r[n]), s.className = r[n], e.el.append(s)), i[n] = s, t[n] = s
                        }
                    })), i
                }(t, t.originalParams.navigation, t.params.navigation, {
                    nextEl: "swiper-button-next",
                    prevEl: "swiper-button-prev"
                }), !e.nextEl && !e.prevEl) return;
                let i = a(e.nextEl),
                    r = a(e.prevEl);
                Object.assign(t.navigation, {
                    nextEl: i,
                    prevEl: r
                }), i = s(i), r = s(r);
                const n = (i, r) => {
                    i && i.addEventListener("click", "next" === r ? d : c), !t.enabled && i && i.classList.add(...e.lockClass.split(" "))
                };
                i.forEach((e => n(e, "next"))), r.forEach((e => n(e, "prev")))
            }

            function h() {
                let {
                    nextEl: e,
                    prevEl: i
                } = t.navigation;
                e = s(e), i = s(i);
                const r = (e, i) => {
                    e.removeEventListener("click", "next" === i ? d : c), e.classList.remove(...t.params.navigation.disabledClass.split(" "))
                };
                e.forEach((e => r(e, "next"))), i.forEach((e => r(e, "prev")))
            }
            r("init", (() => {
                !1 === t.params.navigation.enabled ? p() : (u(), l())
            })), r("toEdge fromEdge lock unlock", (() => {
                l()
            })), r("destroy", (() => {
                h()
            })), r("enable disable", (() => {
                let {
                    nextEl: e,
                    prevEl: i
                } = t.navigation;
                e = s(e), i = s(i), t.enabled ? l() : [...e, ...i].filter((e => !!e)).forEach((e => e.classList.add(t.params.navigation.lockClass)))
            })), r("click", ((e, i) => {
                let {
                    nextEl: r,
                    prevEl: a
                } = t.navigation;
                r = s(r), a = s(a);
                const o = i.target;
                if (t.params.navigation.hideOnClick && !a.includes(o) && !r.includes(o)) {
                    if (t.pagination && t.params.pagination && t.params.pagination.clickable && (t.pagination.el === o || t.pagination.el.contains(o))) return;
                    let e;
                    r.length ? e = r[0].classList.contains(t.params.navigation.hiddenClass) : a.length && (e = a[0].classList.contains(t.params.navigation.hiddenClass)), n(!0 === e ? "navigationShow" : "navigationHide"), [...r, ...a].filter((e => !!e)).forEach((e => e.classList.toggle(t.params.navigation.hiddenClass)))
                }
            }));
            const p = () => {
                t.el.classList.add(...t.params.navigation.navigationDisabledClass.split(" ")), h()
            };
            Object.assign(t.navigation, {
                enable: () => {
                    t.el.classList.remove(...t.params.navigation.navigationDisabledClass.split(" ")), u(), l()
                },
                disable: p,
                update: l,
                init: u,
                destroy: h
            })
        }

        function ne(e) {
            let t, i, {
                swiper: r,
                extendParams: n,
                on: s,
                emit: a,
                params: o
            } = e;
            r.autoplay = {
                running: !1,
                paused: !1,
                timeLeft: 0
            }, n({
                autoplay: {
                    enabled: !1,
                    delay: 3e3,
                    waitForTransition: !0,
                    disableOnInteraction: !1,
                    stopOnLastSlide: !1,
                    reverseDirection: !1,
                    pauseOnMouseEnter: !1
                }
            });
            let l, c, u, h, p, f, m, g, v = o && o.autoplay ? o.autoplay.delay : 3e3,
                y = o && o.autoplay ? o.autoplay.delay : 3e3,
                w = (new Date).getTime();

            function _(e) {
                r && !r.destroyed && r.wrapperEl && e.target === r.wrapperEl && (r.wrapperEl.removeEventListener("transitionend", _), g || M())
            }
            const b = () => {
                if (r.destroyed || !r.autoplay.running) return;
                r.autoplay.paused ? c = !0 : c && (y = l, c = !1);
                const e = r.autoplay.paused ? l : w + y - (new Date).getTime();
                r.autoplay.timeLeft = e, a("autoplayTimeLeft", e, e / v), i = requestAnimationFrame((() => {
                    b()
                }))
            },
                x = e => {
                    if (r.destroyed || !r.autoplay.running) return;
                    cancelAnimationFrame(i), b();
                    let n = void 0 === e ? r.params.autoplay.delay : e;
                    v = r.params.autoplay.delay, y = r.params.autoplay.delay;
                    const s = (() => {
                        let e;
                        if (e = r.virtual && r.params.virtual.enabled ? r.slides.filter((e => e.classList.contains("swiper-slide-active")))[0] : r.slides[r.activeIndex], e) return parseInt(e.getAttribute("data-swiper-autoplay"), 10)
                    })();
                    !Number.isNaN(s) && s > 0 && void 0 === e && (n = s, v = s, y = s), l = n;
                    const o = r.params.speed,
                        c = () => {
                            r && !r.destroyed && (r.params.autoplay.reverseDirection ? !r.isBeginning || r.params.loop || r.params.rewind ? (r.slidePrev(o, !0, !0), a("autoplay")) : r.params.autoplay.stopOnLastSlide || (r.slideTo(r.slides.length - 1, o, !0, !0), a("autoplay")) : !r.isEnd || r.params.loop || r.params.rewind ? (r.slideNext(o, !0, !0), a("autoplay")) : r.params.autoplay.stopOnLastSlide || (r.slideTo(0, o, !0, !0), a("autoplay")), r.params.cssMode && (w = (new Date).getTime(), requestAnimationFrame((() => {
                                x()
                            }))))
                        };
                    return n > 0 ? (clearTimeout(t), t = setTimeout((() => {
                        c()
                    }), n)) : requestAnimationFrame((() => {
                        c()
                    })), n
                },
                T = () => {
                    w = (new Date).getTime(), r.autoplay.running = !0, x(), a("autoplayStart")
                },
                E = () => {
                    r.autoplay.running = !1, clearTimeout(t), cancelAnimationFrame(i), a("autoplayStop")
                },
                S = (e, i) => {
                    if (r.destroyed || !r.autoplay.running) return;
                    clearTimeout(t), e || (m = !0);
                    const n = () => {
                        a("autoplayPause"), r.params.autoplay.waitForTransition ? r.wrapperEl.addEventListener("transitionend", _) : M()
                    };
                    if (r.autoplay.paused = !0, i) return f && (l = r.params.autoplay.delay), f = !1, void n();
                    const s = l || r.params.autoplay.delay;
                    l = s - ((new Date).getTime() - w), r.isEnd && l < 0 && !r.params.loop || (l < 0 && (l = 0), n())
                },
                M = () => {
                    r.isEnd && l < 0 && !r.params.loop || r.destroyed || !r.autoplay.running || (w = (new Date).getTime(), m ? (m = !1, x(l)) : x(), r.autoplay.paused = !1, a("autoplayResume"))
                },
                P = () => {
                    if (r.destroyed || !r.autoplay.running) return;
                    const e = d();
                    "hidden" === e.visibilityState && (m = !0, S(!0)), "visible" === e.visibilityState && M()
                },
                k = e => {
                    "mouse" === e.pointerType && (m = !0, g = !0, r.animating || r.autoplay.paused || S(!0))
                },
                C = e => {
                    "mouse" === e.pointerType && (g = !1, r.autoplay.paused && M())
                };
            s("init", (() => {
                r.params.autoplay.enabled && (r.params.autoplay.pauseOnMouseEnter && (r.el.addEventListener("pointerenter", k), r.el.addEventListener("pointerleave", C)), d().addEventListener("visibilitychange", P), T())
            })), s("destroy", (() => {
                r.el.removeEventListener("pointerenter", k), r.el.removeEventListener("pointerleave", C), d().removeEventListener("visibilitychange", P), r.autoplay.running && E()
            })), s("_freeModeStaticRelease", (() => {
                (h || m) && M()
            })), s("_freeModeNoMomentumRelease", (() => {
                r.params.autoplay.disableOnInteraction ? E() : S(!0, !0)
            })), s("beforeTransitionStart", ((e, t, i) => {
                !r.destroyed && r.autoplay.running && (i || !r.params.autoplay.disableOnInteraction ? S(!0, !0) : E())
            })), s("sliderFirstMove", (() => {
                !r.destroyed && r.autoplay.running && (r.params.autoplay.disableOnInteraction ? E() : (u = !0, h = !1, m = !1, p = setTimeout((() => {
                    m = !0, h = !0, S(!0)
                }), 200)))
            })), s("touchEnd", (() => {
                if (!r.destroyed && r.autoplay.running && u) {
                    if (clearTimeout(p), clearTimeout(t), r.params.autoplay.disableOnInteraction) return h = !1, void (u = !1);
                    h && r.params.cssMode && M(), h = !1, u = !1
                }
            })), s("slideChange", (() => {
                !r.destroyed && r.autoplay.running && (f = !0)
            })), Object.assign(r.autoplay, {
                start: T,
                stop: E,
                pause: S,
                resume: M
            })
        }

        function se(e) {
            let {
                swiper: t,
                extendParams: i,
                emit: r,
                once: n
            } = e;
            i({
                freeMode: {
                    enabled: !1,
                    momentum: !0,
                    momentumRatio: 1,
                    momentumBounce: !0,
                    momentumBounceRatio: 1,
                    momentumVelocityRatio: 1,
                    sticky: !1,
                    minimumVelocity: .02
                }
            }), Object.assign(t, {
                freeMode: {
                    onTouchStart: function () {
                        if (t.params.cssMode) return;
                        const e = t.getTranslate();
                        t.setTranslate(e), t.setTransition(0), t.touchEventsData.velocities.length = 0, t.freeMode.onTouchEnd({
                            currentPos: t.rtl ? t.translate : -t.translate
                        })
                    },
                    onTouchMove: function () {
                        if (t.params.cssMode) return;
                        const {
                            touchEventsData: e,
                            touches: i
                        } = t;
                        0 === e.velocities.length && e.velocities.push({
                            position: i[t.isHorizontal() ? "startX" : "startY"],
                            time: e.touchStartTime
                        }), e.velocities.push({
                            position: i[t.isHorizontal() ? "currentX" : "currentY"],
                            time: f()
                        })
                    },
                    onTouchEnd: function (e) {
                        let {
                            currentPos: i
                        } = e;
                        if (t.params.cssMode) return;
                        const {
                            params: s,
                            wrapperEl: a,
                            rtlTranslate: o,
                            snapGrid: l,
                            touchEventsData: c
                        } = t, d = f() - c.touchStartTime;
                        if (i < -t.minTranslate()) t.slideTo(t.activeIndex);
                        else if (i > -t.maxTranslate()) t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1);
                        else {
                            if (s.freeMode.momentum) {
                                if (c.velocities.length > 1) {
                                    const e = c.velocities.pop(),
                                        i = c.velocities.pop(),
                                        r = e.position - i.position,
                                        n = e.time - i.time;
                                    t.velocity = r / n, t.velocity /= 2, Math.abs(t.velocity) < s.freeMode.minimumVelocity && (t.velocity = 0), (n > 150 || f() - e.time > 300) && (t.velocity = 0)
                                } else t.velocity = 0;
                                t.velocity *= s.freeMode.momentumVelocityRatio, c.velocities.length = 0;
                                let e = 1e3 * s.freeMode.momentumRatio;
                                const i = t.velocity * e;
                                let d = t.translate + i;
                                o && (d = -d);
                                let u, h = !1;
                                const p = 20 * Math.abs(t.velocity) * s.freeMode.momentumBounceRatio;
                                let m;
                                if (d < t.maxTranslate()) s.freeMode.momentumBounce ? (d + t.maxTranslate() < -p && (d = t.maxTranslate() - p), u = t.maxTranslate(), h = !0, c.allowMomentumBounce = !0) : d = t.maxTranslate(), s.loop && s.centeredSlides && (m = !0);
                                else if (d > t.minTranslate()) s.freeMode.momentumBounce ? (d - t.minTranslate() > p && (d = t.minTranslate() + p), u = t.minTranslate(), h = !0, c.allowMomentumBounce = !0) : d = t.minTranslate(), s.loop && s.centeredSlides && (m = !0);
                                else if (s.freeMode.sticky) {
                                    let e;
                                    for (let t = 0; t < l.length; t += 1)
                                        if (l[t] > -d) {
                                            e = t;
                                            break
                                        } d = Math.abs(l[e] - d) < Math.abs(l[e - 1] - d) || "next" === t.swipeDirection ? l[e] : l[e - 1], d = -d
                                }
                                if (m && n("transitionEnd", (() => {
                                    t.loopFix()
                                })), 0 !== t.velocity) {
                                    if (e = o ? Math.abs((-d - t.translate) / t.velocity) : Math.abs((d - t.translate) / t.velocity), s.freeMode.sticky) {
                                        const i = Math.abs((o ? -d : d) - t.translate),
                                            r = t.slidesSizesGrid[t.activeIndex];
                                        e = i < r ? s.speed : i < 2 * r ? 1.5 * s.speed : 2.5 * s.speed
                                    }
                                } else if (s.freeMode.sticky) return void t.slideToClosest();
                                s.freeMode.momentumBounce && h ? (t.updateProgress(u), t.setTransition(e), t.setTranslate(d), t.transitionStart(!0, t.swipeDirection), t.animating = !0, S(a, (() => {
                                    t && !t.destroyed && c.allowMomentumBounce && (r("momentumBounce"), t.setTransition(s.speed), setTimeout((() => {
                                        t.setTranslate(u), S(a, (() => {
                                            t && !t.destroyed && t.transitionEnd()
                                        }))
                                    }), 0))
                                }))) : t.velocity ? (r("_freeModeNoMomentumRelease"), t.updateProgress(d), t.setTransition(e), t.setTranslate(d), t.transitionStart(!0, t.swipeDirection), t.animating || (t.animating = !0, S(a, (() => {
                                    t && !t.destroyed && t.transitionEnd()
                                })))) : t.updateProgress(d), t.updateActiveIndex(), t.updateSlidesClasses()
                            } else {
                                if (s.freeMode.sticky) return void t.slideToClosest();
                                s.freeMode && r("_freeModeNoMomentumRelease")
                            } (!s.freeMode.momentum || d >= s.longSwipesMs) && (r("_freeModeStaticRelease"), t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses())
                        }
                    }
                }
            })
        }

        function ae(e, t) {
            const i = w(t);
            return i !== t && (i.style.backfaceVisibility = "hidden", i.style["-webkit-backface-visibility"] = "hidden"), i
        }

        function oe(e, t, i) {
            const r = `swiper-slide-shadow${i ? `-${i}` : ""}${e ? ` swiper-slide-shadow-${e}` : ""}`,
                n = w(t);
            let s = n.querySelector(`.${r.split(" ").join(".")}`);
            return s || (s = x("div", r.split(" ")), n.append(s)), s
        }

        function le(e) {
            let {
                swiper: t,
                extendParams: i,
                on: r
            } = e;
            i({
                creativeEffect: {
                    limitProgress: 1,
                    shadowPerProgress: !1,
                    progressMultiplier: 1,
                    perspective: !0,
                    prev: {
                        translate: [0, 0, 0],
                        rotate: [0, 0, 0],
                        opacity: 1,
                        scale: 1
                    },
                    next: {
                        translate: [0, 0, 0],
                        rotate: [0, 0, 0],
                        opacity: 1,
                        scale: 1
                    }
                }
            });
            const n = e => "string" == typeof e ? e : `${e}px`;
            ! function (e) {
                const {
                    effect: t,
                    swiper: i,
                    on: r,
                    setTranslate: n,
                    setTransition: s,
                    overwriteParams: a,
                    perspective: o,
                    recreateShadows: l,
                    getEffectParams: c
                } = e;
                let d;
                r("beforeInit", (() => {
                    if (i.params.effect !== t) return;
                    i.classNames.push(`${i.params.containerModifierClass}${t}`), o && o() && i.classNames.push(`${i.params.containerModifierClass}3d`);
                    const e = a ? a() : {};
                    Object.assign(i.params, e), Object.assign(i.originalParams, e)
                })), r("setTranslate", (() => {
                    i.params.effect === t && n()
                })), r("setTransition", ((e, r) => {
                    i.params.effect === t && s(r)
                })), r("transitionEnd", (() => {
                    if (i.params.effect === t && l) {
                        if (!c || !c().slideShadows) return;
                        i.slides.forEach((e => {
                            e.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((e => e.remove()))
                        })), l()
                    }
                })), r("virtualUpdate", (() => {
                    i.params.effect === t && (i.slides.length || (d = !0), requestAnimationFrame((() => {
                        d && i.slides && i.slides.length && (n(), d = !1)
                    })))
                }))
            }({
                effect: "creative",
                swiper: t,
                on: r,
                setTranslate: () => {
                    const {
                        slides: e,
                        wrapperEl: i,
                        slidesSizesGrid: r
                    } = t, s = t.params.creativeEffect, {
                        progressMultiplier: a
                    } = s, o = t.params.centeredSlides;
                    if (o) {
                        const e = r[0] / 2 - t.params.slidesOffsetBefore || 0;
                        i.style.transform = `translateX(calc(50% - ${e}px))`
                    }
                    for (let i = 0; i < e.length; i += 1) {
                        const r = e[i],
                            l = r.progress,
                            c = Math.min(Math.max(r.progress, -s.limitProgress), s.limitProgress);
                        let d = c;
                        o || (d = Math.min(Math.max(r.originalProgress, -s.limitProgress), s.limitProgress));
                        const u = r.swiperSlideOffset,
                            h = [t.params.cssMode ? -u - t.translate : -u, 0, 0],
                            p = [0, 0, 0];
                        let f = !1;
                        t.isHorizontal() || (h[1] = h[0], h[0] = 0);
                        let m = {
                            translate: [0, 0, 0],
                            rotate: [0, 0, 0],
                            scale: 1,
                            opacity: 1
                        };
                        c < 0 ? (m = s.next, f = !0) : c > 0 && (m = s.prev, f = !0), h.forEach(((e, t) => {
                            h[t] = `calc(${e}px + (${n(m.translate[t])} * ${Math.abs(c * a)}))`
                        })), p.forEach(((e, i) => {
                            let r = m.rotate[i] * Math.abs(c * a);
                            t.browser && t.browser.isSafari && Math.abs(r) / 90 % 2 == 1 && (r += .001), p[i] = r
                        })), r.style.zIndex = -Math.abs(Math.round(l)) + e.length;
                        const g = h.join(", "),
                            v = `rotateX(${p[0]}deg) rotateY(${p[1]}deg) rotateZ(${p[2]}deg)`,
                            y = d < 0 ? `scale(${1 + (1 - m.scale) * d * a})` : `scale(${1 - (1 - m.scale) * d * a})`,
                            w = d < 0 ? 1 + (1 - m.opacity) * d * a : 1 - (1 - m.opacity) * d * a,
                            _ = `translate3d(${g}) ${v} ${y}`;
                        if (f && m.shadow || !f) {
                            let e = r.querySelector(".swiper-slide-shadow");
                            if (!e && m.shadow && (e = oe("creative", r)), e) {
                                const t = s.shadowPerProgress ? c * (1 / s.limitProgress) : c;
                                e.style.opacity = Math.min(Math.max(Math.abs(t), 0), 1)
                            }
                        }
                        const b = ae(0, r);
                        b.style.transform = _, b.style.opacity = w, m.origin && (b.style.transformOrigin = m.origin)
                    }
                },
                setTransition: e => {
                    const i = t.slides.map((e => w(e)));
                    i.forEach((t => {
                        t.style.transitionDuration = `${e}ms`, t.querySelectorAll(".swiper-slide-shadow").forEach((t => {
                            t.style.transitionDuration = `${e}ms`
                        }))
                    })),
                        function (e) {
                            let {
                                swiper: t,
                                duration: i,
                                transformElements: r,
                                allSlides: n
                            } = e;
                            const {
                                activeIndex: s
                            } = t;
                            if (t.params.virtualTranslate && 0 !== i) {
                                let e, i = !1;
                                e = n ? r : r.filter((e => {
                                    const i = e.classList.contains("swiper-slide-transform") ? (e => e.parentElement ? e.parentElement : t.slides.filter((t => t.shadowRoot && t.shadowRoot === e.parentNode))[0])(e) : e;
                                    return t.getSlideIndex(i) === s
                                })), e.forEach((e => {
                                    S(e, (() => {
                                        if (i) return;
                                        if (!t || t.destroyed) return;
                                        i = !0, t.animating = !1;
                                        const e = new window.CustomEvent("transitionend", {
                                            bubbles: !0,
                                            cancelable: !0
                                        });
                                        t.wrapperEl.dispatchEvent(e)
                                    }))
                                }))
                            }
                        }({
                            swiper: t,
                            duration: e,
                            transformElements: i,
                            allSlides: !0
                        })
                },
                perspective: () => t.params.creativeEffect.perspective,
                overwriteParams: () => ({
                    watchSlidesProgress: !0,
                    virtualTranslate: !t.params.cssMode
                })
            })
        }
        Object.keys(J).forEach((e => {
            Object.keys(J[e]).forEach((t => {
                te.prototype[t] = J[e][t]
            }))
        })), te.use([function (e) {
            let {
                swiper: t,
                on: i,
                emit: r
            } = e;
            const n = h();
            let s = null,
                a = null;
            const o = () => {
                t && !t.destroyed && t.initialized && (r("beforeResize"), r("resize"))
            },
                l = () => {
                    t && !t.destroyed && t.initialized && r("orientationchange")
                };
            i("init", (() => {
                t.params.resizeObserver && void 0 !== n.ResizeObserver ? t && !t.destroyed && t.initialized && (s = new ResizeObserver((e => {
                    a = n.requestAnimationFrame((() => {
                        const {
                            width: i,
                            height: r
                        } = t;
                        let n = i,
                            s = r;
                        e.forEach((e => {
                            let {
                                contentBoxSize: i,
                                contentRect: r,
                                target: a
                            } = e;
                            a && a !== t.el || (n = r ? r.width : (i[0] || i).inlineSize, s = r ? r.height : (i[0] || i).blockSize)
                        })), n === i && s === r || o()
                    }))
                })), s.observe(t.el)) : (n.addEventListener("resize", o), n.addEventListener("orientationchange", l))
            })), i("destroy", (() => {
                a && n.cancelAnimationFrame(a), s && s.unobserve && t.el && (s.unobserve(t.el), s = null), n.removeEventListener("resize", o), n.removeEventListener("orientationchange", l)
            }))
        }, function (e) {
            let {
                swiper: t,
                extendParams: i,
                on: r,
                emit: n
            } = e;
            const s = [],
                a = h(),
                o = function (e, i) {
                    void 0 === i && (i = {});
                    const r = new (a.MutationObserver || a.WebkitMutationObserver)((e => {
                        if (t.__preventObserver__) return;
                        if (1 === e.length) return void n("observerUpdate", e[0]);
                        const i = function () {
                            n("observerUpdate", e[0])
                        };
                        a.requestAnimationFrame ? a.requestAnimationFrame(i) : a.setTimeout(i, 0)
                    }));
                    r.observe(e, {
                        attributes: void 0 === i.attributes || i.attributes,
                        childList: void 0 === i.childList || i.childList,
                        characterData: void 0 === i.characterData || i.characterData
                    }), s.push(r)
                };
            i({
                observer: !1,
                observeParents: !1,
                observeSlideChildren: !1
            }), r("init", (() => {
                if (t.params.observer) {
                    if (t.params.observeParents) {
                        const e = function (e, t) {
                            const i = [];
                            let r = e.parentElement;
                            for (; r;) i.push(r), r = r.parentElement;
                            return i
                        }(t.hostEl);
                        for (let t = 0; t < e.length; t += 1) o(e[t])
                    }
                    o(t.hostEl, {
                        childList: t.params.observeSlideChildren
                    }), o(t.wrapperEl, {
                        attributes: !1
                    })
                }
            })), r("destroy", (() => {
                s.forEach((e => {
                    e.disconnect()
                })), s.splice(0, s.length)
            }))
        }]);
        class ce {
            constructor(e) {
                this.context = e, this.cursor = window.cursor, this.elements = r("[js-carousel]", e), this.elements.length > 0 && this.init()
            }
            createCarousels() {
                Array.from(this.elements).forEach((e => {
                    this.initSwiper(e)
                }))
            }
            getConfig(e, i) {
                return {
                    product: {
                        modules: [le, re],
                        navigation: {
                            nextEl: this.productNextBtn,
                            prevEl: this.productPrevBtn
                        },
                        loop: !1,
                        speed: 500,
                        centeredSlides: !0,
                        slidesPerView: 1,
                        loopedSlides: 2,
                        effect: "creative",
                        initialSlide: Array.from(r(".swiper-slide", e)).findIndex((e => e.hasAttribute("data-initial"))),
                        breakpoints: {
                            640: {
                                slidesPerView: 1.2,
                                creativeEffect: {
                                    limitProgress: 2,
                                    progressMultiplier: 1,
                                    prev: {
                                        translate: ["-60%", "0%", 0],
                                        scale: .8
                                    },
                                    next: {
                                        translate: ["60%", "0%", 0],
                                        scale: .8
                                    }
                                }
                            }
                        },
                        creativeEffect: {
                            limitProgress: 3,
                            progressMultiplier: 1,
                            prev: {
                                translate: ["-65%", "0%", 0],
                                scale: .8
                            },
                            next: {
                                translate: ["65%", "0%", 0],
                                scale: .8
                            }
                        }
                    },
                    gallery: {
                        modules: [se, ie],
                        loop: !0,
                        freeMode: !1,
                        loopAdditionalSlides: 4,
                        mousewheel: {
                            invert: !1
                        },
                        speed: 500,
                        slidesPerView: "auto",
                        direction: "vertical",
                        breakpoints: {
                            768: {
                                centeredSlides: !0,
                                direction: "horizontal",
                                freeMode: !1
                            }
                        }
                    },
                    cover_gallery: {
                        modules: [ne, re],
                        navigation: {
                            nextEl: n(".swiper-button-next", e),
                            prevEl: n(".swiper-button-prev", e)
                        },
                        speed: 500,
                        autoplay: {
                            delay: 5e3
                        }
                    },
                    cover_gallery_sidebar: {
                        speed: 500,
                        spaceBetween: Array.from(r(".swiper-slide", e)).length > 1 ? 10 : 0,
                        slidesPerView: Array.from(r(".swiper-slide", e)).length > 1 ? 1.1 : 1
                    },
                    product_thumbs: {
                        modules: [re],
                        navigation: {
                            nextEl: n(".swiper-button-next", e.parentNode),
                            prevEl: n(".swiper-button-prev", e.parentNode)
                        },
                        slidesPerView: 4.5,
                        centerInsufficientSlides: !0,
                        initialSlide: Array.from(r(".swiper-slide", e)).findIndex((e => {
                            e.classList.contains("-active")
                        })),
                        on: {
                            click: e => {
                                e.clickedSlide && t().go(e.clickedSlide.getAttribute("data-url"))
                            }
                        }
                    }
                }[i]
            }
            initSwiper(e) {
                const i = e.getAttribute("js-carousel");
                "product" == i && (this.productNextBtn = n(".g-pdp__nav-next", e), this.productPrevBtn = n(".g-pdp__nav-prev", e));
                const s = new te(e, this.getConfig(e, i));
                e.swiperInstance = s, "product" == i && (s.on("slideChangeTransitionStart", (() => {
                    this.cursor.hide(), n("body").classList.add("-transition"), window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth"
                    })
                })), s.on("slideChangeTransitionEnd", (() => {
                    this.cursor.hide();
                    const e = s.slides[s.activeIndex];
                    t().go(e.getAttribute("data-url"))
                })), this.productNextBtn.addEventListener("mousemove", (() => {
                    const e = s.slides[s.activeIndex + 1];
                    this.cursor.setData(e.getAttribute("data-title"), e.getAttribute("data-author")), this.cursor.show()
                })), this.productNextBtn.addEventListener("mouseleave", (() => {
                    this.cursor.hide()
                })), this.productPrevBtn.addEventListener("mousemove", (() => {
                    const e = s.slides[s.activeIndex - 1];
                    this.cursor.setData(e.getAttribute("data-title"), e.getAttribute("data-author")), this.cursor.show()
                })), this.productPrevBtn.addEventListener("mouseleave", (() => {
                    this.cursor.hide()
                })), r("[js-slide-to]").forEach((e => {
                    e.addEventListener("click", (() => {
                        s.slideTo(e.getAttribute("js-slide-to"))
                    }))
                })))
            }
            init() {
                this.createCarousels()
            }
        }

        function de(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e
        }

        function ue(e, t) {
            e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t
        }
        var he, pe, fe, me, ge, ve, ye, we, _e, be, xe, Te, Ee, Se, Me, Pe = {
            autoSleep: 120,
            force3D: "auto",
            nullTargetWarn: 1,
            units: {
                lineHeight: ""
            }
        },
            ke = {
                duration: .5,
                overwrite: !1,
                delay: 0
            },
            Ce = 1e8,
            Le = 1e-8,
            Oe = 2 * Math.PI,
            Ae = Oe / 4,
            De = 0,
            Ie = Math.sqrt,
            ze = Math.cos,
            Re = Math.sin,
            Be = function (e) {
                return "string" == typeof e
            },
            Fe = function (e) {
                return "function" == typeof e
            },
            Ne = function (e) {
                return "number" == typeof e
            },
            je = function (e) {
                return void 0 === e
            },
            He = function (e) {
                return "object" == typeof e
            },
            Ge = function (e) {
                return !1 !== e
            },
            Ye = function () {
                return "undefined" != typeof window
            },
            Xe = function (e) {
                return Fe(e) || Be(e)
            },
            Ve = "function" == typeof ArrayBuffer && ArrayBuffer.isView || function () { },
            qe = Array.isArray,
            $e = /(?:-?\.?\d|\.)+/gi,
            We = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
            Ue = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
            Ke = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
            Ze = /[+-]=-?[.\d]+/,
            Qe = /[^,'"\[\]\s]+/gi,
            Je = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
            et = {},
            tt = {},
            it = function (e) {
                return (tt = Ot(e, et)) && Or
            },
            rt = function (e, t) {
                return console.warn("Invalid property", e, "set to", t, "Missing plugin? gsap.registerPlugin()")
            },
            nt = function (e, t) {
                return !t && console.warn(e)
            },
            st = function (e, t) {
                return e && (et[e] = t) && tt && (tt[e] = t) || et
            },
            at = function () {
                return 0
            },
            ot = {
                suppressEvents: !0,
                isStart: !0,
                kill: !1
            },
            lt = {
                suppressEvents: !0,
                kill: !1
            },
            ct = {
                suppressEvents: !0
            },
            dt = {},
            ut = [],
            ht = {},
            pt = {},
            ft = {},
            mt = 30,
            gt = [],
            vt = "",
            yt = function (e) {
                var t, i, r = e[0];
                if (He(r) || Fe(r) || (e = [e]), !(t = (r._gsap || {}).harness)) {
                    for (i = gt.length; i-- && !gt[i].targetTest(r););
                    t = gt[i]
                }
                for (i = e.length; i--;) e[i] && (e[i]._gsap || (e[i]._gsap = new Vi(e[i], t))) || e.splice(i, 1);
                return e
            },
            wt = function (e) {
                return e._gsap || yt(li(e))[0]._gsap
            },
            _t = function (e, t, i) {
                return (i = e[t]) && Fe(i) ? e[t]() : je(i) && e.getAttribute && e.getAttribute(t) || i
            },
            bt = function (e, t) {
                return (e = e.split(",")).forEach(t) || e
            },
            xt = function (e) {
                return Math.round(1e5 * e) / 1e5 || 0
            },
            Tt = function (e) {
                return Math.round(1e7 * e) / 1e7 || 0
            },
            Et = function (e, t) {
                var i = t.charAt(0),
                    r = parseFloat(t.substr(2));
                return e = parseFloat(e), "+" === i ? e + r : "-" === i ? e - r : "*" === i ? e * r : e / r
            },
            St = function (e, t) {
                for (var i = t.length, r = 0; e.indexOf(t[r]) < 0 && ++r < i;);
                return r < i
            },
            Mt = function () {
                var e, t, i = ut.length,
                    r = ut.slice(0);
                for (ht = {}, ut.length = 0, e = 0; e < i; e++)(t = r[e]) && t._lazy && (t.render(t._lazy[0], t._lazy[1], !0)._lazy = 0)
            },
            Pt = function (e, t, i, r) {
                ut.length && !pe && Mt(), e.render(t, i, r || pe && t < 0 && (e._initted || e._startAt)), ut.length && !pe && Mt()
            },
            kt = function (e) {
                var t = parseFloat(e);
                return (t || 0 === t) && (e + "").match(Qe).length < 2 ? t : Be(e) ? e.trim() : e
            },
            Ct = function (e) {
                return e
            },
            Lt = function (e, t) {
                for (var i in t) i in e || (e[i] = t[i]);
                return e
            },
            Ot = function (e, t) {
                for (var i in t) e[i] = t[i];
                return e
            },
            At = function e(t, i) {
                for (var r in i) "__proto__" !== r && "constructor" !== r && "prototype" !== r && (t[r] = He(i[r]) ? e(t[r] || (t[r] = {}), i[r]) : i[r]);
                return t
            },
            Dt = function (e, t) {
                var i, r = {};
                for (i in e) i in t || (r[i] = e[i]);
                return r
            },
            It = function (e) {
                var t, i = e.parent || me,
                    r = e.keyframes ? (t = qe(e.keyframes), function (e, i) {
                        for (var r in i) r in e || "duration" === r && t || "ease" === r || (e[r] = i[r])
                    }) : Lt;
                if (Ge(e.inherit))
                    for (; i;) r(e, i.vars.defaults), i = i.parent || i._dp;
                return e
            },
            zt = function (e, t, i, r, n) {
                void 0 === i && (i = "_first"), void 0 === r && (r = "_last");
                var s, a = e[r];
                if (n)
                    for (s = t[n]; a && a[n] > s;) a = a._prev;
                return a ? (t._next = a._next, a._next = t) : (t._next = e[i], e[i] = t), t._next ? t._next._prev = t : e[r] = t, t._prev = a, t.parent = t._dp = e, t
            },
            Rt = function (e, t, i, r) {
                void 0 === i && (i = "_first"), void 0 === r && (r = "_last");
                var n = t._prev,
                    s = t._next;
                n ? n._next = s : e[i] === t && (e[i] = s), s ? s._prev = n : e[r] === t && (e[r] = n), t._next = t._prev = t.parent = null
            },
            Bt = function (e, t) {
                e.parent && (!t || e.parent.autoRemoveChildren) && e.parent.remove && e.parent.remove(e), e._act = 0
            },
            Ft = function (e, t) {
                if (e && (!t || t._end > e._dur || t._start < 0))
                    for (var i = e; i;) i._dirty = 1, i = i.parent;
                return e
            },
            Nt = function (e, t, i, r) {
                return e._startAt && (pe ? e._startAt.revert(lt) : e.vars.immediateRender && !e.vars.autoRevert || e._startAt.render(t, !0, r))
            },
            jt = function e(t) {
                return !t || t._ts && e(t.parent)
            },
            Ht = function (e) {
                return e._repeat ? Gt(e._tTime, e = e.duration() + e._rDelay) * e : 0
            },
            Gt = function (e, t) {
                var i = Math.floor(e /= t);
                return e && i === e ? i - 1 : i
            },
            Yt = function (e, t) {
                return (e - t._start) * t._ts + (t._ts >= 0 ? 0 : t._dirty ? t.totalDuration() : t._tDur)
            },
            Xt = function (e) {
                return e._end = Tt(e._start + (e._tDur / Math.abs(e._ts || e._rts || Le) || 0))
            },
            Vt = function (e, t) {
                var i = e._dp;
                return i && i.smoothChildTiming && e._ts && (e._start = Tt(i._time - (e._ts > 0 ? t / e._ts : ((e._dirty ? e.totalDuration() : e._tDur) - t) / -e._ts)), Xt(e), i._dirty || Ft(i, e)), e
            },
            qt = function (e, t) {
                var i;
                if ((t._time || !t._dur && t._initted || t._start < e._time && (t._dur || !t.add)) && (i = Yt(e.rawTime(), t), (!t._dur || ni(0, t.totalDuration(), i) - t._tTime > Le) && t.render(i, !0)), Ft(e, t)._dp && e._initted && e._time >= e._dur && e._ts) {
                    if (e._dur < e.duration())
                        for (i = e; i._dp;) i.rawTime() >= 0 && i.totalTime(i._tTime), i = i._dp;
                    e._zTime = -1e-8
                }
            },
            $t = function (e, t, i, r) {
                return t.parent && Bt(t), t._start = Tt((Ne(i) ? i : i || e !== me ? ti(e, i, t) : e._time) + t._delay), t._end = Tt(t._start + (t.totalDuration() / Math.abs(t.timeScale()) || 0)), zt(e, t, "_first", "_last", e._sort ? "_start" : 0), Zt(t) || (e._recent = t), r || qt(e, t), e._ts < 0 && Vt(e, e._tTime), e
            },
            Wt = function (e, t) {
                return (et.ScrollTrigger || rt("scrollTrigger", t)) && et.ScrollTrigger.create(t, e)
            },
            Ut = function (e, t, i, r, n) {
                return Ji(e, t, n), e._initted ? !i && e._pt && !pe && (e._dur && !1 !== e.vars.lazy || !e._dur && e.vars.lazy) && _e !== Ai.frame ? (ut.push(e), e._lazy = [n, r], 1) : void 0 : 1
            },
            Kt = function e(t) {
                var i = t.parent;
                return i && i._ts && i._initted && !i._lock && (i.rawTime() < 0 || e(i))
            },
            Zt = function (e) {
                var t = e.data;
                return "isFromStart" === t || "isStart" === t
            },
            Qt = function (e, t, i, r) {
                var n = e._repeat,
                    s = Tt(t) || 0,
                    a = e._tTime / e._tDur;
                return a && !r && (e._time *= s / e._dur), e._dur = s, e._tDur = n ? n < 0 ? 1e10 : Tt(s * (n + 1) + e._rDelay * n) : s, a > 0 && !r && Vt(e, e._tTime = e._tDur * a), e.parent && Xt(e), i || Ft(e.parent, e), e
            },
            Jt = function (e) {
                return e instanceof $i ? Ft(e) : Qt(e, e._dur)
            },
            ei = {
                _start: 0,
                endTime: at,
                totalDuration: at
            },
            ti = function e(t, i, r) {
                var n, s, a, o = t.labels,
                    l = t._recent || ei,
                    c = t.duration() >= Ce ? l.endTime(!1) : t._dur;
                return Be(i) && (isNaN(i) || i in o) ? (s = i.charAt(0), a = "%" === i.substr(-1), n = i.indexOf("="), "<" === s || ">" === s ? (n >= 0 && (i = i.replace(/=/, "")), ("<" === s ? l._start : l.endTime(l._repeat >= 0)) + (parseFloat(i.substr(1)) || 0) * (a ? (n < 0 ? l : r).totalDuration() / 100 : 1)) : n < 0 ? (i in o || (o[i] = c), o[i]) : (s = parseFloat(i.charAt(n - 1) + i.substr(n + 1)), a && r && (s = s / 100 * (qe(r) ? r[0] : r).totalDuration()), n > 1 ? e(t, i.substr(0, n - 1), r) + s : c + s)) : null == i ? c : +i
            },
            ii = function (e, t, i) {
                var r, n, s = Ne(t[1]),
                    a = (s ? 2 : 1) + (e < 2 ? 0 : 1),
                    o = t[a];
                if (s && (o.duration = t[1]), o.parent = i, e) {
                    for (r = o, n = i; n && !("immediateRender" in r);) r = n.vars.defaults || {}, n = Ge(n.vars.inherit) && n.parent;
                    o.immediateRender = Ge(r.immediateRender), e < 2 ? o.runBackwards = 1 : o.startAt = t[a - 1]
                }
                return new nr(t[0], o, t[a + 1])
            },
            ri = function (e, t) {
                return e || 0 === e ? t(e) : t
            },
            ni = function (e, t, i) {
                return i < e ? e : i > t ? t : i
            },
            si = function (e, t) {
                return Be(e) && (t = Je.exec(e)) ? t[1] : ""
            },
            ai = [].slice,
            oi = function (e, t) {
                return e && He(e) && "length" in e && (!t && !e.length || e.length - 1 in e && He(e[0])) && !e.nodeType && e !== ge
            },
            li = function (e, t, i) {
                return fe && !t && fe.selector ? fe.selector(e) : !Be(e) || i || !ve && Di() ? qe(e) ? function (e, t, i) {
                    return void 0 === i && (i = []), e.forEach((function (e) {
                        var r;
                        return Be(e) && !t || oi(e, 1) ? (r = i).push.apply(r, li(e)) : i.push(e)
                    })) || i
                }(e, i) : oi(e) ? ai.call(e, 0) : e ? [e] : [] : ai.call((t || ye).querySelectorAll(e), 0)
            },
            ci = function (e) {
                return e = li(e)[0] || nt("Invalid scope") || {},
                    function (t) {
                        var i = e.current || e.nativeElement || e;
                        return li(t, i.querySelectorAll ? i : i === e ? nt("Invalid scope") || ye.createElement("div") : e)
                    }
            },
            di = function (e) {
                return e.sort((function () {
                    return .5 - Math.random()
                }))
            },
            ui = function (e) {
                if (Fe(e)) return e;
                var t = He(e) ? e : {
                    each: e
                },
                    i = ji(t.ease),
                    r = t.from || 0,
                    n = parseFloat(t.base) || 0,
                    s = {},
                    a = r > 0 && r < 1,
                    o = isNaN(r) || a,
                    l = t.axis,
                    c = r,
                    d = r;
                return Be(r) ? c = d = {
                    center: .5,
                    edges: .5,
                    end: 1
                }[r] || 0 : !a && o && (c = r[0], d = r[1]),
                    function (e, a, u) {
                        var h, p, f, m, g, v, y, w, _, b = (u || t).length,
                            x = s[b];
                        if (!x) {
                            if (!(_ = "auto" === t.grid ? 0 : (t.grid || [1, Ce])[1])) {
                                for (y = -Ce; y < (y = u[_++].getBoundingClientRect().left) && _ < b;);
                                _ < b && _--
                            }
                            for (x = s[b] = [], h = o ? Math.min(_, b) * c - .5 : r % _, p = _ === Ce ? 0 : o ? b * d / _ - .5 : r / _ | 0, y = 0, w = Ce, v = 0; v < b; v++) f = v % _ - h, m = p - (v / _ | 0), x[v] = g = l ? Math.abs("y" === l ? m : f) : Ie(f * f + m * m), g > y && (y = g), g < w && (w = g);
                            "random" === r && di(x), x.max = y - w, x.min = w, x.v = b = (parseFloat(t.amount) || parseFloat(t.each) * (_ > b ? b - 1 : l ? "y" === l ? b / _ : _ : Math.max(_, b / _)) || 0) * ("edges" === r ? -1 : 1), x.b = b < 0 ? n - b : n, x.u = si(t.amount || t.each) || 0, i = i && b < 0 ? Fi(i) : i
                        }
                        return b = (x[e] - x.min) / x.max || 0, Tt(x.b + (i ? i(b) : b) * x.v) + x.u
                    }
            },
            hi = function (e) {
                var t = Math.pow(10, ((e + "").split(".")[1] || "").length);
                return function (i) {
                    var r = Tt(Math.round(parseFloat(i) / e) * e * t);
                    return (r - r % 1) / t + (Ne(i) ? 0 : si(i))
                }
            },
            pi = function (e, t) {
                var i, r, n = qe(e);
                return !n && He(e) && (i = n = e.radius || Ce, e.values ? (e = li(e.values), (r = !Ne(e[0])) && (i *= i)) : e = hi(e.increment)), ri(t, n ? Fe(e) ? function (t) {
                    return r = e(t), Math.abs(r - t) <= i ? r : t
                } : function (t) {
                    for (var n, s, a = parseFloat(r ? t.x : t), o = parseFloat(r ? t.y : 0), l = Ce, c = 0, d = e.length; d--;)(n = r ? (n = e[d].x - a) * n + (s = e[d].y - o) * s : Math.abs(e[d] - a)) < l && (l = n, c = d);
                    return c = !i || l <= i ? e[c] : t, r || c === t || Ne(t) ? c : c + si(t)
                } : hi(e))
            },
            fi = function (e, t, i, r) {
                return ri(qe(e) ? !t : !0 === i ? !!(i = 0) : !r, (function () {
                    return qe(e) ? e[~~(Math.random() * e.length)] : (i = i || 1e-5) && (r = i < 1 ? Math.pow(10, (i + "").length - 2) : 1) && Math.floor(Math.round((e - i / 2 + Math.random() * (t - e + .99 * i)) / i) * i * r) / r
                }))
            },
            mi = function (e, t, i) {
                return ri(i, (function (i) {
                    return e[~~t(i)]
                }))
            },
            gi = function (e) {
                for (var t, i, r, n, s = 0, a = ""; ~(t = e.indexOf("random(", s));) r = e.indexOf(")", t), n = "[" === e.charAt(t + 7), i = e.substr(t + 7, r - t - 7).match(n ? Qe : $e), a += e.substr(s, t - s) + fi(n ? i : +i[0], n ? 0 : +i[1], +i[2] || 1e-5), s = r + 1;
                return a + e.substr(s, e.length - s)
            },
            vi = function (e, t, i, r, n) {
                var s = t - e,
                    a = r - i;
                return ri(n, (function (t) {
                    return i + ((t - e) / s * a || 0)
                }))
            },
            yi = function (e, t, i) {
                var r, n, s, a = e.labels,
                    o = Ce;
                for (r in a) (n = a[r] - t) < 0 == !!i && n && o > (n = Math.abs(n)) && (s = r, o = n);
                return s
            },
            wi = function (e, t, i) {
                var r, n, s, a = e.vars,
                    o = a[t],
                    l = fe,
                    c = e._ctx;
                if (o) return r = a[t + "Params"], n = a.callbackScope || e, i && ut.length && Mt(), c && (fe = c), s = r ? o.apply(n, r) : o.call(n), fe = l, s
            },
            _i = function (e) {
                return Bt(e), e.scrollTrigger && e.scrollTrigger.kill(!!pe), e.progress() < 1 && wi(e, "onInterrupt"), e
            },
            bi = [],
            xi = function (e) {
                if (Ye() && e) {
                    var t = (e = !e.name && e.default || e).name,
                        i = Fe(e),
                        r = t && !i && e.init ? function () {
                            this._props = []
                        } : e,
                        n = {
                            init: at,
                            render: pr,
                            add: Zi,
                            kill: mr,
                            modifier: fr,
                            rawVars: 0
                        },
                        s = {
                            targetTest: 0,
                            get: 0,
                            getSetter: cr,
                            aliases: {},
                            register: 0
                        };
                    if (Di(), e !== r) {
                        if (pt[t]) return;
                        Lt(r, Lt(Dt(e, n), s)), Ot(r.prototype, Ot(n, Dt(e, s))), pt[r.prop = t] = r, e.targetTest && (gt.push(r), dt[t] = 1), t = ("css" === t ? "CSS" : t.charAt(0).toUpperCase() + t.substr(1)) + "Plugin"
                    }
                    st(t, r), e.register && e.register(Or, r, yr)
                } else e && bi.push(e)
            },
            Ti = 255,
            Ei = {
                aqua: [0, Ti, Ti],
                lime: [0, Ti, 0],
                silver: [192, 192, 192],
                black: [0, 0, 0],
                maroon: [128, 0, 0],
                teal: [0, 128, 128],
                blue: [0, 0, Ti],
                navy: [0, 0, 128],
                white: [Ti, Ti, Ti],
                olive: [128, 128, 0],
                yellow: [Ti, Ti, 0],
                orange: [Ti, 165, 0],
                gray: [128, 128, 128],
                purple: [128, 0, 128],
                green: [0, 128, 0],
                red: [Ti, 0, 0],
                pink: [Ti, 192, 203],
                cyan: [0, Ti, Ti],
                transparent: [Ti, Ti, Ti, 0]
            },
            Si = function (e, t, i) {
                return (6 * (e += e < 0 ? 1 : e > 1 ? -1 : 0) < 1 ? t + (i - t) * e * 6 : e < .5 ? i : 3 * e < 2 ? t + (i - t) * (2 / 3 - e) * 6 : t) * Ti + .5 | 0
            },
            Mi = function (e, t, i) {
                var r, n, s, a, o, l, c, d, u, h, p = e ? Ne(e) ? [e >> 16, e >> 8 & Ti, e & Ti] : 0 : Ei.black;
                if (!p) {
                    if ("," === e.substr(-1) && (e = e.substr(0, e.length - 1)), Ei[e]) p = Ei[e];
                    else if ("#" === e.charAt(0)) {
                        if (e.length < 6 && (r = e.charAt(1), n = e.charAt(2), s = e.charAt(3), e = "#" + r + r + n + n + s + s + (5 === e.length ? e.charAt(4) + e.charAt(4) : "")), 9 === e.length) return [(p = parseInt(e.substr(1, 6), 16)) >> 16, p >> 8 & Ti, p & Ti, parseInt(e.substr(7), 16) / 255];
                        p = [(e = parseInt(e.substr(1), 16)) >> 16, e >> 8 & Ti, e & Ti]
                    } else if ("hsl" === e.substr(0, 3))
                        if (p = h = e.match($e), t) {
                            if (~e.indexOf("=")) return p = e.match(We), i && p.length < 4 && (p[3] = 1), p
                        } else a = +p[0] % 360 / 360, o = +p[1] / 100, r = 2 * (l = +p[2] / 100) - (n = l <= .5 ? l * (o + 1) : l + o - l * o), p.length > 3 && (p[3] *= 1), p[0] = Si(a + 1 / 3, r, n), p[1] = Si(a, r, n), p[2] = Si(a - 1 / 3, r, n);
                    else p = e.match($e) || Ei.transparent;
                    p = p.map(Number)
                }
                return t && !h && (r = p[0] / Ti, n = p[1] / Ti, s = p[2] / Ti, l = ((c = Math.max(r, n, s)) + (d = Math.min(r, n, s))) / 2, c === d ? a = o = 0 : (u = c - d, o = l > .5 ? u / (2 - c - d) : u / (c + d), a = c === r ? (n - s) / u + (n < s ? 6 : 0) : c === n ? (s - r) / u + 2 : (r - n) / u + 4, a *= 60), p[0] = ~~(a + .5), p[1] = ~~(100 * o + .5), p[2] = ~~(100 * l + .5)), i && p.length < 4 && (p[3] = 1), p
            },
            Pi = function (e) {
                var t = [],
                    i = [],
                    r = -1;
                return e.split(Ci).forEach((function (e) {
                    var n = e.match(Ue) || [];
                    t.push.apply(t, n), i.push(r += n.length + 1)
                })), t.c = i, t
            },
            ki = function (e, t, i) {
                var r, n, s, a, o = "",
                    l = (e + o).match(Ci),
                    c = t ? "hsla(" : "rgba(",
                    d = 0;
                if (!l) return e;
                if (l = l.map((function (e) {
                    return (e = Mi(e, t, 1)) && c + (t ? e[0] + "," + e[1] + "%," + e[2] + "%," + e[3] : e.join(",")) + ")"
                })), i && (s = Pi(e), (r = i.c).join(o) !== s.c.join(o)))
                    for (a = (n = e.replace(Ci, "1").split(Ue)).length - 1; d < a; d++) o += n[d] + (~r.indexOf(d) ? l.shift() || c + "0,0,0,0)" : (s.length ? s : l.length ? l : i).shift());
                if (!n)
                    for (a = (n = e.split(Ci)).length - 1; d < a; d++) o += n[d] + l[d];
                return o + n[a]
            },
            Ci = function () {
                var e, t = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
                for (e in Ei) t += "|" + e + "\\b";
                return new RegExp(t + ")", "gi")
            }(),
            Li = /hsl[a]?\(/,
            Oi = function (e) {
                var t, i = e.join(" ");
                if (Ci.lastIndex = 0, Ci.test(i)) return t = Li.test(i), e[1] = ki(e[1], t), e[0] = ki(e[0], t, Pi(e[1])), !0
            },
            Ai = function () {
                var e, t, i, r, n, s, a = Date.now,
                    o = 500,
                    l = 33,
                    c = a(),
                    d = c,
                    u = 1e3 / 240,
                    h = u,
                    p = [],
                    f = function i(f) {
                        var m, g, v, y, w = a() - d,
                            _ = !0 === f;
                        if (w > o && (c += w - l), ((m = (v = (d += w) - c) - h) > 0 || _) && (y = ++r.frame, n = v - 1e3 * r.time, r.time = v /= 1e3, h += m + (m >= u ? 4 : u - m), g = 1), _ || (e = t(i)), g)
                            for (s = 0; s < p.length; s++) p[s](v, n, y, f)
                    };
                return r = {
                    time: 0,
                    frame: 0,
                    tick: function () {
                        f(!0)
                    },
                    deltaRatio: function (e) {
                        return n / (1e3 / (e || 60))
                    },
                    wake: function () {
                        we && (!ve && Ye() && (ge = ve = window, ye = ge.document || {}, et.gsap = Or, (ge.gsapVersions || (ge.gsapVersions = [])).push(Or.version), it(tt || ge.GreenSockGlobals || !ge.gsap && ge || {}), i = ge.requestAnimationFrame, bi.forEach(xi)), e && r.sleep(), t = i || function (e) {
                            return setTimeout(e, h - 1e3 * r.time + 1 | 0)
                        }, xe = 1, f(2))
                    },
                    sleep: function () {
                        (i ? ge.cancelAnimationFrame : clearTimeout)(e), xe = 0, t = at
                    },
                    lagSmoothing: function (e, t) {
                        o = e || 1 / 0, l = Math.min(t || 33, o)
                    },
                    fps: function (e) {
                        u = 1e3 / (e || 240), h = 1e3 * r.time + u
                    },
                    add: function (e, t, i) {
                        var n = t ? function (t, i, s, a) {
                            e(t, i, s, a), r.remove(n)
                        } : e;
                        return r.remove(e), p[i ? "unshift" : "push"](n), Di(), n
                    },
                    remove: function (e, t) {
                        ~(t = p.indexOf(e)) && p.splice(t, 1) && s >= t && s--
                    },
                    _listeners: p
                }
            }(),
            Di = function () {
                return !xe && Ai.wake()
            },
            Ii = {},
            zi = /^[\d.\-M][\d.\-,\s]/,
            Ri = /["']/g,
            Bi = function (e) {
                for (var t, i, r, n = {}, s = e.substr(1, e.length - 3).split(":"), a = s[0], o = 1, l = s.length; o < l; o++) i = s[o], t = o !== l - 1 ? i.lastIndexOf(",") : i.length, r = i.substr(0, t), n[a] = isNaN(r) ? r.replace(Ri, "").trim() : +r, a = i.substr(t + 1).trim();
                return n
            },
            Fi = function (e) {
                return function (t) {
                    return 1 - e(1 - t)
                }
            },
            Ni = function e(t, i) {
                for (var r, n = t._first; n;) n instanceof $i ? e(n, i) : !n.vars.yoyoEase || n._yoyo && n._repeat || n._yoyo === i || (n.timeline ? e(n.timeline, i) : (r = n._ease, n._ease = n._yEase, n._yEase = r, n._yoyo = i)), n = n._next
            },
            ji = function (e, t) {
                return e && (Fe(e) ? e : Ii[e] || function (e) {
                    var t, i, r, n, s = (e + "").split("("),
                        a = Ii[s[0]];
                    return a && s.length > 1 && a.config ? a.config.apply(null, ~e.indexOf("{") ? [Bi(s[1])] : (t = e, i = t.indexOf("(") + 1, r = t.indexOf(")"), n = t.indexOf("(", i), t.substring(i, ~n && n < r ? t.indexOf(")", r + 1) : r)).split(",").map(kt)) : Ii._CE && zi.test(e) ? Ii._CE("", e) : a
                }(e)) || t
            },
            Hi = function (e, t, i, r) {
                void 0 === i && (i = function (e) {
                    return 1 - t(1 - e)
                }), void 0 === r && (r = function (e) {
                    return e < .5 ? t(2 * e) / 2 : 1 - t(2 * (1 - e)) / 2
                });
                var n, s = {
                    easeIn: t,
                    easeOut: i,
                    easeInOut: r
                };
                return bt(e, (function (e) {
                    for (var t in Ii[e] = et[e] = s, Ii[n = e.toLowerCase()] = i, s) Ii[n + ("easeIn" === t ? ".in" : "easeOut" === t ? ".out" : ".inOut")] = Ii[e + "." + t] = s[t]
                })), s
            },
            Gi = function (e) {
                return function (t) {
                    return t < .5 ? (1 - e(1 - 2 * t)) / 2 : .5 + e(2 * (t - .5)) / 2
                }
            },
            Yi = function e(t, i, r) {
                var n = i >= 1 ? i : 1,
                    s = (r || (t ? .3 : .45)) / (i < 1 ? i : 1),
                    a = s / Oe * (Math.asin(1 / n) || 0),
                    o = function (e) {
                        return 1 === e ? 1 : n * Math.pow(2, -10 * e) * Re((e - a) * s) + 1
                    },
                    l = "out" === t ? o : "in" === t ? function (e) {
                        return 1 - o(1 - e)
                    } : Gi(o);
                return s = Oe / s, l.config = function (i, r) {
                    return e(t, i, r)
                }, l
            },
            Xi = function e(t, i) {
                void 0 === i && (i = 1.70158);
                var r = function (e) {
                    return e ? --e * e * ((i + 1) * e + i) + 1 : 0
                },
                    n = "out" === t ? r : "in" === t ? function (e) {
                        return 1 - r(1 - e)
                    } : Gi(r);
                return n.config = function (i) {
                    return e(t, i)
                }, n
            };
        bt("Linear,Quad,Cubic,Quart,Quint,Strong", (function (e, t) {
            var i = t < 5 ? t + 1 : t;
            Hi(e + ",Power" + (i - 1), t ? function (e) {
                return Math.pow(e, i)
            } : function (e) {
                return e
            }, (function (e) {
                return 1 - Math.pow(1 - e, i)
            }), (function (e) {
                return e < .5 ? Math.pow(2 * e, i) / 2 : 1 - Math.pow(2 * (1 - e), i) / 2
            }))
        })), Ii.Linear.easeNone = Ii.none = Ii.Linear.easeIn, Hi("Elastic", Yi("in"), Yi("out"), Yi()), Te = 7.5625, Se = 1 / (Ee = 2.75), Hi("Bounce", (function (e) {
            return 1 - Me(1 - e)
        }), Me = function (e) {
            return e < Se ? Te * e * e : e < .7272727272727273 ? Te * Math.pow(e - 1.5 / Ee, 2) + .75 : e < .9090909090909092 ? Te * (e -= 2.25 / Ee) * e + .9375 : Te * Math.pow(e - 2.625 / Ee, 2) + .984375
        }), Hi("Expo", (function (e) {
            return e ? Math.pow(2, 10 * (e - 1)) : 0
        })), Hi("Circ", (function (e) {
            return -(Ie(1 - e * e) - 1)
        })), Hi("Sine", (function (e) {
            return 1 === e ? 1 : 1 - ze(e * Ae)
        })), Hi("Back", Xi("in"), Xi("out"), Xi()), Ii.SteppedEase = Ii.steps = et.SteppedEase = {
            config: function (e, t) {
                void 0 === e && (e = 1);
                var i = 1 / e,
                    r = e + (t ? 0 : 1),
                    n = t ? 1 : 0;
                return function (e) {
                    return ((r * ni(0, .99999999, e) | 0) + n) * i
                }
            }
        }, ke.ease = Ii["quad.out"], bt("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", (function (e) {
            return vt += e + "," + e + "Params,"
        }));
        var Vi = function (e, t) {
            this.id = De++, e._gsap = this, this.target = e, this.harness = t, this.get = t ? t.get : _t, this.set = t ? t.getSetter : cr
        },
            qi = function () {
                function e(e) {
                    this.vars = e, this._delay = +e.delay || 0, (this._repeat = e.repeat === 1 / 0 ? -2 : e.repeat || 0) && (this._rDelay = e.repeatDelay || 0, this._yoyo = !!e.yoyo || !!e.yoyoEase), this._ts = 1, Qt(this, +e.duration, 1, 1), this.data = e.data, fe && (this._ctx = fe, fe.data.push(this)), xe || Ai.wake()
                }
                var t = e.prototype;
                return t.delay = function (e) {
                    return e || 0 === e ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + e - this._delay), this._delay = e, this) : this._delay
                }, t.duration = function (e) {
                    return arguments.length ? this.totalDuration(this._repeat > 0 ? e + (e + this._rDelay) * this._repeat : e) : this.totalDuration() && this._dur
                }, t.totalDuration = function (e) {
                    return arguments.length ? (this._dirty = 0, Qt(this, this._repeat < 0 ? e : (e - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur
                }, t.totalTime = function (e, t) {
                    if (Di(), !arguments.length) return this._tTime;
                    var i = this._dp;
                    if (i && i.smoothChildTiming && this._ts) {
                        for (Vt(this, e), !i._dp || i.parent || qt(i, this); i && i.parent;) i.parent._time !== i._start + (i._ts >= 0 ? i._tTime / i._ts : (i.totalDuration() - i._tTime) / -i._ts) && i.totalTime(i._tTime, !0), i = i.parent;
                        !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && e < this._tDur || this._ts < 0 && e > 0 || !this._tDur && !e) && $t(this._dp, this, this._start - this._delay)
                    }
                    return (this._tTime !== e || !this._dur && !t || this._initted && Math.abs(this._zTime) === Le || !e && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = e), Pt(this, e, t)), this
                }, t.time = function (e, t) {
                    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), e + Ht(this)) % (this._dur + this._rDelay) || (e ? this._dur : 0), t) : this._time
                }, t.totalProgress = function (e, t) {
                    return arguments.length ? this.totalTime(this.totalDuration() * e, t) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0
                }, t.progress = function (e, t) {
                    return arguments.length ? this.totalTime(this.duration() * (!this._yoyo || 1 & this.iteration() ? e : 1 - e) + Ht(this), t) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0
                }, t.iteration = function (e, t) {
                    var i = this.duration() + this._rDelay;
                    return arguments.length ? this.totalTime(this._time + (e - 1) * i, t) : this._repeat ? Gt(this._tTime, i) + 1 : 1
                }, t.timeScale = function (e, t) {
                    if (!arguments.length) return -1e-8 === this._rts ? 0 : this._rts;
                    if (this._rts === e) return this;
                    var i = this.parent && this._ts ? Yt(this.parent._time, this) : this._tTime;
                    return this._rts = +e || 0, this._ts = this._ps || -1e-8 === e ? 0 : this._rts, this.totalTime(ni(-Math.abs(this._delay), this._tDur, i), !1 !== t), Xt(this),
                        function (e) {
                            for (var t = e.parent; t && t.parent;) t._dirty = 1, t.totalDuration(), t = t.parent;
                            return e
                        }(this)
                }, t.paused = function (e) {
                    return arguments.length ? (this._ps !== e && (this._ps = e, e ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (Di(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, 1 === this.progress() && Math.abs(this._zTime) !== Le && (this._tTime -= Le)))), this) : this._ps
                }, t.startTime = function (e) {
                    if (arguments.length) {
                        this._start = e;
                        var t = this.parent || this._dp;
                        return t && (t._sort || !this.parent) && $t(t, this, e - this._delay), this
                    }
                    return this._start
                }, t.endTime = function (e) {
                    return this._start + (Ge(e) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1)
                }, t.rawTime = function (e) {
                    var t = this.parent || this._dp;
                    return t ? e && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? Yt(t.rawTime(e), this) : this._tTime : this._tTime
                }, t.revert = function (e) {
                    void 0 === e && (e = ct);
                    var t = pe;
                    return pe = e, (this._initted || this._startAt) && (this.timeline && this.timeline.revert(e), this.totalTime(-.01, e.suppressEvents)), "nested" !== this.data && !1 !== e.kill && this.kill(), pe = t, this
                }, t.globalTime = function (e) {
                    for (var t = this, i = arguments.length ? e : t.rawTime(); t;) i = t._start + i / (Math.abs(t._ts) || 1), t = t._dp;
                    return !this.parent && this._sat ? this._sat.globalTime(e) : i
                }, t.repeat = function (e) {
                    return arguments.length ? (this._repeat = e === 1 / 0 ? -2 : e, Jt(this)) : -2 === this._repeat ? 1 / 0 : this._repeat
                }, t.repeatDelay = function (e) {
                    if (arguments.length) {
                        var t = this._time;
                        return this._rDelay = e, Jt(this), t ? this.time(t) : this
                    }
                    return this._rDelay
                }, t.yoyo = function (e) {
                    return arguments.length ? (this._yoyo = e, this) : this._yoyo
                }, t.seek = function (e, t) {
                    return this.totalTime(ti(this, e), Ge(t))
                }, t.restart = function (e, t) {
                    return this.play().totalTime(e ? -this._delay : 0, Ge(t))
                }, t.play = function (e, t) {
                    return null != e && this.seek(e, t), this.reversed(!1).paused(!1)
                }, t.reverse = function (e, t) {
                    return null != e && this.seek(e || this.totalDuration(), t), this.reversed(!0).paused(!1)
                }, t.pause = function (e, t) {
                    return null != e && this.seek(e, t), this.paused(!0)
                }, t.resume = function () {
                    return this.paused(!1)
                }, t.reversed = function (e) {
                    return arguments.length ? (!!e !== this.reversed() && this.timeScale(-this._rts || (e ? -1e-8 : 0)), this) : this._rts < 0
                }, t.invalidate = function () {
                    return this._initted = this._act = 0, this._zTime = -1e-8, this
                }, t.isActive = function () {
                    var e, t = this.parent || this._dp,
                        i = this._start;
                    return !(t && !(this._ts && this._initted && t.isActive() && (e = t.rawTime(!0)) >= i && e < this.endTime(!0) - Le))
                }, t.eventCallback = function (e, t, i) {
                    var r = this.vars;
                    return arguments.length > 1 ? (t ? (r[e] = t, i && (r[e + "Params"] = i), "onUpdate" === e && (this._onUpdate = t)) : delete r[e], this) : r[e]
                }, t.then = function (e) {
                    var t = this;
                    return new Promise((function (i) {
                        var r = Fe(e) ? e : Ct,
                            n = function () {
                                var e = t.then;
                                t.then = null, Fe(r) && (r = r(t)) && (r.then || r === t) && (t.then = e), i(r), t.then = e
                            };
                        t._initted && 1 === t.totalProgress() && t._ts >= 0 || !t._tTime && t._ts < 0 ? n() : t._prom = n
                    }))
                }, t.kill = function () {
                    _i(this)
                }, e
            }();
        Lt(qi.prototype, {
            _time: 0,
            _start: 0,
            _end: 0,
            _tTime: 0,
            _tDur: 0,
            _dirty: 0,
            _repeat: 0,
            _yoyo: !1,
            parent: null,
            _initted: !1,
            _rDelay: 0,
            _ts: 1,
            _dp: 0,
            ratio: 0,
            _zTime: -1e-8,
            _prom: 0,
            _ps: !1,
            _rts: 1
        });
        var $i = function (e) {
            function t(t, i) {
                var r;
                return void 0 === t && (t = {}), (r = e.call(this, t) || this).labels = {}, r.smoothChildTiming = !!t.smoothChildTiming, r.autoRemoveChildren = !!t.autoRemoveChildren, r._sort = Ge(t.sortChildren), me && $t(t.parent || me, de(r), i), t.reversed && r.reverse(), t.paused && r.paused(!0), t.scrollTrigger && Wt(de(r), t.scrollTrigger), r
            }
            ue(t, e);
            var i = t.prototype;
            return i.to = function (e, t, i) {
                return ii(0, arguments, this), this
            }, i.from = function (e, t, i) {
                return ii(1, arguments, this), this
            }, i.fromTo = function (e, t, i, r) {
                return ii(2, arguments, this), this
            }, i.set = function (e, t, i) {
                return t.duration = 0, t.parent = this, It(t).repeatDelay || (t.repeat = 0), t.immediateRender = !!t.immediateRender, new nr(e, t, ti(this, i), 1), this
            }, i.call = function (e, t, i) {
                return $t(this, nr.delayedCall(0, e, t), i)
            }, i.staggerTo = function (e, t, i, r, n, s, a) {
                return i.duration = t, i.stagger = i.stagger || r, i.onComplete = s, i.onCompleteParams = a, i.parent = this, new nr(e, i, ti(this, n)), this
            }, i.staggerFrom = function (e, t, i, r, n, s, a) {
                return i.runBackwards = 1, It(i).immediateRender = Ge(i.immediateRender), this.staggerTo(e, t, i, r, n, s, a)
            }, i.staggerFromTo = function (e, t, i, r, n, s, a, o) {
                return r.startAt = i, It(r).immediateRender = Ge(r.immediateRender), this.staggerTo(e, t, r, n, s, a, o)
            }, i.render = function (e, t, i) {
                var r, n, s, a, o, l, c, d, u, h, p, f, m = this._time,
                    g = this._dirty ? this.totalDuration() : this._tDur,
                    v = this._dur,
                    y = e <= 0 ? 0 : Tt(e),
                    w = this._zTime < 0 != e < 0 && (this._initted || !v);
                if (this !== me && y > g && e >= 0 && (y = g), y !== this._tTime || i || w) {
                    if (m !== this._time && v && (y += this._time - m, e += this._time - m), r = y, u = this._start, l = !(d = this._ts), w && (v || (m = this._zTime), (e || !t) && (this._zTime = e)), this._repeat) {
                        if (p = this._yoyo, o = v + this._rDelay, this._repeat < -1 && e < 0) return this.totalTime(100 * o + e, t, i);
                        if (r = Tt(y % o), y === g ? (a = this._repeat, r = v) : ((a = ~~(y / o)) && a === y / o && (r = v, a--), r > v && (r = v)), h = Gt(this._tTime, o), !m && this._tTime && h !== a && this._tTime - h * o - this._dur <= 0 && (h = a), p && 1 & a && (r = v - r, f = 1), a !== h && !this._lock) {
                            var _ = p && 1 & h,
                                b = _ === (p && 1 & a);
                            if (a < h && (_ = !_), m = _ ? 0 : y % v ? v : y, this._lock = 1, this.render(m || (f ? 0 : Tt(a * o)), t, !v)._lock = 0, this._tTime = y, !t && this.parent && wi(this, "onRepeat"), this.vars.repeatRefresh && !f && (this.invalidate()._lock = 1), m && m !== this._time || l !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) return this;
                            if (v = this._dur, g = this._tDur, b && (this._lock = 2, m = _ ? v : -1e-4, this.render(m, !0), this.vars.repeatRefresh && !f && this.invalidate()), this._lock = 0, !this._ts && !l) return this;
                            Ni(this, f)
                        }
                    }
                    if (this._hasPause && !this._forcing && this._lock < 2 && (c = function (e, t, i) {
                        var r;
                        if (i > t)
                            for (r = e._first; r && r._start <= i;) {
                                if ("isPause" === r.data && r._start > t) return r;
                                r = r._next
                            } else
                            for (r = e._last; r && r._start >= i;) {
                                if ("isPause" === r.data && r._start < t) return r;
                                r = r._prev
                            }
                    }(this, Tt(m), Tt(r)), c && (y -= r - (r = c._start))), this._tTime = y, this._time = r, this._act = !d, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = e, m = 0), !m && r && !t && !a && (wi(this, "onStart"), this._tTime !== y)) return this;
                    if (r >= m && e >= 0)
                        for (n = this._first; n;) {
                            if (s = n._next, (n._act || r >= n._start) && n._ts && c !== n) {
                                if (n.parent !== this) return this.render(e, t, i);
                                if (n.render(n._ts > 0 ? (r - n._start) * n._ts : (n._dirty ? n.totalDuration() : n._tDur) + (r - n._start) * n._ts, t, i), r !== this._time || !this._ts && !l) {
                                    c = 0, s && (y += this._zTime = -1e-8);
                                    break
                                }
                            }
                            n = s
                        } else {
                        n = this._last;
                        for (var x = e < 0 ? e : r; n;) {
                            if (s = n._prev, (n._act || x <= n._end) && n._ts && c !== n) {
                                if (n.parent !== this) return this.render(e, t, i);
                                if (n.render(n._ts > 0 ? (x - n._start) * n._ts : (n._dirty ? n.totalDuration() : n._tDur) + (x - n._start) * n._ts, t, i || pe && (n._initted || n._startAt)), r !== this._time || !this._ts && !l) {
                                    c = 0, s && (y += this._zTime = x ? -1e-8 : Le);
                                    break
                                }
                            }
                            n = s
                        }
                    }
                    if (c && !t && (this.pause(), c.render(r >= m ? 0 : -1e-8)._zTime = r >= m ? 1 : -1, this._ts)) return this._start = u, Xt(this), this.render(e, t, i);
                    this._onUpdate && !t && wi(this, "onUpdate", !0), (y === g && this._tTime >= this.totalDuration() || !y && m) && (u !== this._start && Math.abs(d) === Math.abs(this._ts) || this._lock || ((e || !v) && (y === g && this._ts > 0 || !y && this._ts < 0) && Bt(this, 1), t || e < 0 && !m || !y && !m && g || (wi(this, y === g && e >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(y < g && this.timeScale() > 0) && this._prom())))
                }
                return this
            }, i.add = function (e, t) {
                var i = this;
                if (Ne(t) || (t = ti(this, t, e)), !(e instanceof qi)) {
                    if (qe(e)) return e.forEach((function (e) {
                        return i.add(e, t)
                    })), this;
                    if (Be(e)) return this.addLabel(e, t);
                    if (!Fe(e)) return this;
                    e = nr.delayedCall(0, e)
                }
                return this !== e ? $t(this, e, t) : this
            }, i.getChildren = function (e, t, i, r) {
                void 0 === e && (e = !0), void 0 === t && (t = !0), void 0 === i && (i = !0), void 0 === r && (r = -Ce);
                for (var n = [], s = this._first; s;) s._start >= r && (s instanceof nr ? t && n.push(s) : (i && n.push(s), e && n.push.apply(n, s.getChildren(!0, t, i)))), s = s._next;
                return n
            }, i.getById = function (e) {
                for (var t = this.getChildren(1, 1, 1), i = t.length; i--;)
                    if (t[i].vars.id === e) return t[i]
            }, i.remove = function (e) {
                return Be(e) ? this.removeLabel(e) : Fe(e) ? this.killTweensOf(e) : (Rt(this, e), e === this._recent && (this._recent = this._last), Ft(this))
            }, i.totalTime = function (t, i) {
                return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = Tt(Ai.time - (this._ts > 0 ? t / this._ts : (this.totalDuration() - t) / -this._ts))), e.prototype.totalTime.call(this, t, i), this._forcing = 0, this) : this._tTime
            }, i.addLabel = function (e, t) {
                return this.labels[e] = ti(this, t), this
            }, i.removeLabel = function (e) {
                return delete this.labels[e], this
            }, i.addPause = function (e, t, i) {
                var r = nr.delayedCall(0, t || at, i);
                return r.data = "isPause", this._hasPause = 1, $t(this, r, ti(this, e))
            }, i.removePause = function (e) {
                var t = this._first;
                for (e = ti(this, e); t;) t._start === e && "isPause" === t.data && Bt(t), t = t._next
            }, i.killTweensOf = function (e, t, i) {
                for (var r = this.getTweensOf(e, i), n = r.length; n--;) Wi !== r[n] && r[n].kill(e, t);
                return this
            }, i.getTweensOf = function (e, t) {
                for (var i, r = [], n = li(e), s = this._first, a = Ne(t); s;) s instanceof nr ? St(s._targets, n) && (a ? (!Wi || s._initted && s._ts) && s.globalTime(0) <= t && s.globalTime(s.totalDuration()) > t : !t || s.isActive()) && r.push(s) : (i = s.getTweensOf(n, t)).length && r.push.apply(r, i), s = s._next;
                return r
            }, i.tweenTo = function (e, t) {
                t = t || {};
                var i, r = this,
                    n = ti(r, e),
                    s = t,
                    a = s.startAt,
                    o = s.onStart,
                    l = s.onStartParams,
                    c = s.immediateRender,
                    d = nr.to(r, Lt({
                        ease: t.ease || "none",
                        lazy: !1,
                        immediateRender: !1,
                        time: n,
                        overwrite: "auto",
                        duration: t.duration || Math.abs((n - (a && "time" in a ? a.time : r._time)) / r.timeScale()) || Le,
                        onStart: function () {
                            if (r.pause(), !i) {
                                var e = t.duration || Math.abs((n - (a && "time" in a ? a.time : r._time)) / r.timeScale());
                                d._dur !== e && Qt(d, e, 0, 1).render(d._time, !0, !0), i = 1
                            }
                            o && o.apply(d, l || [])
                        }
                    }, t));
                return c ? d.render(0) : d
            }, i.tweenFromTo = function (e, t, i) {
                return this.tweenTo(t, Lt({
                    startAt: {
                        time: ti(this, e)
                    }
                }, i))
            }, i.recent = function () {
                return this._recent
            }, i.nextLabel = function (e) {
                return void 0 === e && (e = this._time), yi(this, ti(this, e))
            }, i.previousLabel = function (e) {
                return void 0 === e && (e = this._time), yi(this, ti(this, e), 1)
            }, i.currentLabel = function (e) {
                return arguments.length ? this.seek(e, !0) : this.previousLabel(this._time + Le)
            }, i.shiftChildren = function (e, t, i) {
                void 0 === i && (i = 0);
                for (var r, n = this._first, s = this.labels; n;) n._start >= i && (n._start += e, n._end += e), n = n._next;
                if (t)
                    for (r in s) s[r] >= i && (s[r] += e);
                return Ft(this)
            }, i.invalidate = function (t) {
                var i = this._first;
                for (this._lock = 0; i;) i.invalidate(t), i = i._next;
                return e.prototype.invalidate.call(this, t)
            }, i.clear = function (e) {
                void 0 === e && (e = !0);
                for (var t, i = this._first; i;) t = i._next, this.remove(i), i = t;
                return this._dp && (this._time = this._tTime = this._pTime = 0), e && (this.labels = {}), Ft(this)
            }, i.totalDuration = function (e) {
                var t, i, r, n = 0,
                    s = this,
                    a = s._last,
                    o = Ce;
                if (arguments.length) return s.timeScale((s._repeat < 0 ? s.duration() : s.totalDuration()) / (s.reversed() ? -e : e));
                if (s._dirty) {
                    for (r = s.parent; a;) t = a._prev, a._dirty && a.totalDuration(), (i = a._start) > o && s._sort && a._ts && !s._lock ? (s._lock = 1, $t(s, a, i - a._delay, 1)._lock = 0) : o = i, i < 0 && a._ts && (n -= i, (!r && !s._dp || r && r.smoothChildTiming) && (s._start += i / s._ts, s._time -= i, s._tTime -= i), s.shiftChildren(-i, !1, -Infinity), o = 0), a._end > n && a._ts && (n = a._end), a = t;
                    Qt(s, s === me && s._time > n ? s._time : n, 1, 1), s._dirty = 0
                }
                return s._tDur
            }, t.updateRoot = function (e) {
                if (me._ts && (Pt(me, Yt(e, me)), _e = Ai.frame), Ai.frame >= mt) {
                    mt += Pe.autoSleep || 120;
                    var t = me._first;
                    if ((!t || !t._ts) && Pe.autoSleep && Ai._listeners.length < 2) {
                        for (; t && !t._ts;) t = t._next;
                        t || Ai.sleep()
                    }
                }
            }, t
        }(qi);
        Lt($i.prototype, {
            _lock: 0,
            _hasPause: 0,
            _forcing: 0
        });
        var Wi, Ui, Ki = function (e, t, i, r, n, s, a) {
            var o, l, c, d, u, h, p, f, m = new yr(this._pt, e, t, 0, 1, hr, null, n),
                g = 0,
                v = 0;
            for (m.b = i, m.e = r, i += "", (p = ~(r += "").indexOf("random(")) && (r = gi(r)), s && (s(f = [i, r], e, t), i = f[0], r = f[1]), l = i.match(Ke) || []; o = Ke.exec(r);) d = o[0], u = r.substring(g, o.index), c ? c = (c + 1) % 5 : "rgba(" === u.substr(-5) && (c = 1), d !== l[v++] && (h = parseFloat(l[v - 1]) || 0, m._pt = {
                _next: m._pt,
                p: u || 1 === v ? u : ",",
                s: h,
                c: "=" === d.charAt(1) ? Et(h, d) - h : parseFloat(d) - h,
                m: c && c < 4 ? Math.round : 0
            }, g = Ke.lastIndex);
            return m.c = g < r.length ? r.substring(g, r.length) : "", m.fp = a, (Ze.test(r) || p) && (m.e = 0), this._pt = m, m
        },
            Zi = function (e, t, i, r, n, s, a, o, l, c) {
                Fe(r) && (r = r(n || 0, e, s));
                var d, u = e[t],
                    h = "get" !== i ? i : Fe(u) ? l ? e[t.indexOf("set") || !Fe(e["get" + t.substr(3)]) ? t : "get" + t.substr(3)](l) : e[t]() : u,
                    p = Fe(u) ? l ? or : ar : sr;
                if (Be(r) && (~r.indexOf("random(") && (r = gi(r)), "=" === r.charAt(1) && ((d = Et(h, r) + (si(h) || 0)) || 0 === d) && (r = d)), !c || h !== r || Ui) return isNaN(h * r) || "" === r ? (!u && !(t in e) && rt(t, r), Ki.call(this, e, t, h, r, p, o || Pe.stringFilter, l)) : (d = new yr(this._pt, e, t, +h || 0, r - (h || 0), "boolean" == typeof u ? ur : dr, 0, p), l && (d.fp = l), a && d.modifier(a, this, e), this._pt = d)
            },
            Qi = function (e, t, i, r, n, s) {
                var a, o, l, c;
                if (pt[e] && !1 !== (a = new pt[e]).init(n, a.rawVars ? t[e] : function (e, t, i, r, n) {
                    if (Fe(e) && (e = tr(e, n, t, i, r)), !He(e) || e.style && e.nodeType || qe(e) || Ve(e)) return Be(e) ? tr(e, n, t, i, r) : e;
                    var s, a = {};
                    for (s in e) a[s] = tr(e[s], n, t, i, r);
                    return a
                }(t[e], r, n, s, i), i, r, s) && (i._pt = o = new yr(i._pt, n, e, 0, 1, a.render, a, 0, a.priority), i !== be))
                    for (l = i._ptLookup[i._targets.indexOf(n)], c = a._props.length; c--;) l[a._props[c]] = o;
                return a
            },
            Ji = function e(t, i, r) {
                var n, s, a, o, l, c, d, u, h, p, f, m, g, v = t.vars,
                    y = v.ease,
                    w = v.startAt,
                    _ = v.immediateRender,
                    b = v.lazy,
                    x = v.onUpdate,
                    T = v.runBackwards,
                    E = v.yoyoEase,
                    S = v.keyframes,
                    M = v.autoRevert,
                    P = t._dur,
                    k = t._startAt,
                    C = t._targets,
                    L = t.parent,
                    O = L && "nested" === L.data ? L.vars.targets : C,
                    A = "auto" === t._overwrite && !he,
                    D = t.timeline;
                if (D && (!S || !y) && (y = "none"), t._ease = ji(y, ke.ease), t._yEase = E ? Fi(ji(!0 === E ? y : E, ke.ease)) : 0, E && t._yoyo && !t._repeat && (E = t._yEase, t._yEase = t._ease, t._ease = E), t._from = !D && !!v.runBackwards, !D || S && !v.stagger) {
                    if (m = (u = C[0] ? wt(C[0]).harness : 0) && v[u.prop], n = Dt(v, dt), k && (k._zTime < 0 && k.progress(1), i < 0 && T && _ && !M ? k.render(-1, !0) : k.revert(T && P ? lt : ot), k._lazy = 0), w) {
                        if (Bt(t._startAt = nr.set(C, Lt({
                            data: "isStart",
                            overwrite: !1,
                            parent: L,
                            immediateRender: !0,
                            lazy: !k && Ge(b),
                            startAt: null,
                            delay: 0,
                            onUpdate: x && function () {
                                return wi(t, "onUpdate")
                            },
                            stagger: 0
                        }, w))), t._startAt._dp = 0, t._startAt._sat = t, i < 0 && (pe || !_ && !M) && t._startAt.revert(lt), _ && P && i <= 0 && r <= 0) return void (i && (t._zTime = i))
                    } else if (T && P && !k)
                        if (i && (_ = !1), a = Lt({
                            overwrite: !1,
                            data: "isFromStart",
                            lazy: _ && !k && Ge(b),
                            immediateRender: _,
                            stagger: 0,
                            parent: L
                        }, n), m && (a[u.prop] = m), Bt(t._startAt = nr.set(C, a)), t._startAt._dp = 0, t._startAt._sat = t, i < 0 && (pe ? t._startAt.revert(lt) : t._startAt.render(-1, !0)), t._zTime = i, _) {
                            if (!i) return
                        } else e(t._startAt, Le, Le);
                    for (t._pt = t._ptCache = 0, b = P && Ge(b) || b && !P, s = 0; s < C.length; s++) {
                        if (d = (l = C[s])._gsap || yt(C)[s]._gsap, t._ptLookup[s] = p = {}, ht[d.id] && ut.length && Mt(), f = O === C ? s : O.indexOf(l), u && !1 !== (h = new u).init(l, m || n, t, f, O) && (t._pt = o = new yr(t._pt, l, h.name, 0, 1, h.render, h, 0, h.priority), h._props.forEach((function (e) {
                            p[e] = o
                        })), h.priority && (c = 1)), !u || m)
                            for (a in n) pt[a] && (h = Qi(a, n, t, f, l, O)) ? h.priority && (c = 1) : p[a] = o = Zi.call(t, l, a, "get", n[a], f, O, 0, v.stringFilter);
                        t._op && t._op[s] && t.kill(l, t._op[s]), A && t._pt && (Wi = t, me.killTweensOf(l, p, t.globalTime(i)), g = !t.parent, Wi = 0), t._pt && b && (ht[d.id] = 1)
                    }
                    c && vr(t), t._onInit && t._onInit(t)
                }
                t._onUpdate = x, t._initted = (!t._op || t._pt) && !g, S && i <= 0 && D.render(Ce, !0, !0)
            },
            er = function (e, t, i, r) {
                var n, s, a = t.ease || r || "power1.inOut";
                if (qe(t)) s = i[e] || (i[e] = []), t.forEach((function (e, i) {
                    return s.push({
                        t: i / (t.length - 1) * 100,
                        v: e,
                        e: a
                    })
                }));
                else
                    for (n in t) s = i[n] || (i[n] = []), "ease" === n || s.push({
                        t: parseFloat(e),
                        v: t[n],
                        e: a
                    })
            },
            tr = function (e, t, i, r, n) {
                return Fe(e) ? e.call(t, i, r, n) : Be(e) && ~e.indexOf("random(") ? gi(e) : e
            },
            ir = vt + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
            rr = {};
        bt(ir + ",id,stagger,delay,duration,paused,scrollTrigger", (function (e) {
            return rr[e] = 1
        }));
        var nr = function (e) {
            function t(t, i, r, n) {
                var s;
                "number" == typeof i && (r.duration = i, i = r, r = null);
                var a, o, l, c, d, u, h, p, f = (s = e.call(this, n ? i : It(i)) || this).vars,
                    m = f.duration,
                    g = f.delay,
                    v = f.immediateRender,
                    y = f.stagger,
                    w = f.overwrite,
                    _ = f.keyframes,
                    b = f.defaults,
                    x = f.scrollTrigger,
                    T = f.yoyoEase,
                    E = i.parent || me,
                    S = (qe(t) || Ve(t) ? Ne(t[0]) : "length" in i) ? [t] : li(t);
                if (s._targets = S.length ? yt(S) : nt("GSAP target " + t + " not found. https://gsap.com", !Pe.nullTargetWarn) || [], s._ptLookup = [], s._overwrite = w, _ || y || Xe(m) || Xe(g)) {
                    if (i = s.vars, (a = s.timeline = new $i({
                        data: "nested",
                        defaults: b || {},
                        targets: E && "nested" === E.data ? E.vars.targets : S
                    })).kill(), a.parent = a._dp = de(s), a._start = 0, y || Xe(m) || Xe(g)) {
                        if (c = S.length, h = y && ui(y), He(y))
                            for (d in y) ~ir.indexOf(d) && (p || (p = {}), p[d] = y[d]);
                        for (o = 0; o < c; o++)(l = Dt(i, rr)).stagger = 0, T && (l.yoyoEase = T), p && Ot(l, p), u = S[o], l.duration = +tr(m, de(s), o, u, S), l.delay = (+tr(g, de(s), o, u, S) || 0) - s._delay, !y && 1 === c && l.delay && (s._delay = g = l.delay, s._start += g, l.delay = 0), a.to(u, l, h ? h(o, u, S) : 0), a._ease = Ii.none;
                        a.duration() ? m = g = 0 : s.timeline = 0
                    } else if (_) {
                        It(Lt(a.vars.defaults, {
                            ease: "none"
                        })), a._ease = ji(_.ease || i.ease || "none");
                        var M, P, k, C = 0;
                        if (qe(_)) _.forEach((function (e) {
                            return a.to(S, e, ">")
                        })), a.duration();
                        else {
                            for (d in l = {}, _) "ease" === d || "easeEach" === d || er(d, _[d], l, _.easeEach);
                            for (d in l)
                                for (M = l[d].sort((function (e, t) {
                                    return e.t - t.t
                                })), C = 0, o = 0; o < M.length; o++)(k = {
                                    ease: (P = M[o]).e,
                                    duration: (P.t - (o ? M[o - 1].t : 0)) / 100 * m
                                })[d] = P.v, a.to(S, k, C), C += k.duration;
                            a.duration() < m && a.to({}, {
                                duration: m - a.duration()
                            })
                        }
                    }
                    m || s.duration(m = a.duration())
                } else s.timeline = 0;
                return !0 !== w || he || (Wi = de(s), me.killTweensOf(S), Wi = 0), $t(E, de(s), r), i.reversed && s.reverse(), i.paused && s.paused(!0), (v || !m && !_ && s._start === Tt(E._time) && Ge(v) && jt(de(s)) && "nested" !== E.data) && (s._tTime = -1e-8, s.render(Math.max(0, -g) || 0)), x && Wt(de(s), x), s
            }
            ue(t, e);
            var i = t.prototype;
            return i.render = function (e, t, i) {
                var r, n, s, a, o, l, c, d, u, h = this._time,
                    p = this._tDur,
                    f = this._dur,
                    m = e < 0,
                    g = e > p - Le && !m ? p : e < Le ? 0 : e;
                if (f) {
                    if (g !== this._tTime || !e || i || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== m) {
                        if (r = g, d = this.timeline, this._repeat) {
                            if (a = f + this._rDelay, this._repeat < -1 && m) return this.totalTime(100 * a + e, t, i);
                            if (r = Tt(g % a), g === p ? (s = this._repeat, r = f) : ((s = ~~(g / a)) && s === Tt(g / a) && (r = f, s--), r > f && (r = f)), (l = this._yoyo && 1 & s) && (u = this._yEase, r = f - r), o = Gt(this._tTime, a), r === h && !i && this._initted && s === o) return this._tTime = g, this;
                            s !== o && (d && this._yEase && Ni(d, l), this.vars.repeatRefresh && !l && !this._lock && this._time !== f && this._initted && (this._lock = i = 1, this.render(Tt(a * s), !0).invalidate()._lock = 0))
                        }
                        if (!this._initted) {
                            if (Ut(this, m ? e : r, i, t, g)) return this._tTime = 0, this;
                            if (!(h === this._time || i && this.vars.repeatRefresh && s !== o)) return this;
                            if (f !== this._dur) return this.render(e, t, i)
                        }
                        if (this._tTime = g, this._time = r, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = c = (u || this._ease)(r / f), this._from && (this.ratio = c = 1 - c), r && !h && !t && !s && (wi(this, "onStart"), this._tTime !== g)) return this;
                        for (n = this._pt; n;) n.r(c, n.d), n = n._next;
                        d && d.render(e < 0 ? e : !r && l ? -1e-8 : d._dur * d._ease(r / this._dur), t, i) || this._startAt && (this._zTime = e), this._onUpdate && !t && (m && Nt(this, e, 0, i), wi(this, "onUpdate")), this._repeat && s !== o && this.vars.onRepeat && !t && this.parent && wi(this, "onRepeat"), g !== this._tDur && g || this._tTime !== g || (m && !this._onUpdate && Nt(this, e, 0, !0), (e || !f) && (g === this._tDur && this._ts > 0 || !g && this._ts < 0) && Bt(this, 1), t || m && !h || !(g || h || l) || (wi(this, g === p ? "onComplete" : "onReverseComplete", !0), this._prom && !(g < p && this.timeScale() > 0) && this._prom()))
                    }
                } else ! function (e, t, i, r) {
                    var n, s, a, o = e.ratio,
                        l = t < 0 || !t && (!e._start && Kt(e) && (e._initted || !Zt(e)) || (e._ts < 0 || e._dp._ts < 0) && !Zt(e)) ? 0 : 1,
                        c = e._rDelay,
                        d = 0;
                    if (c && e._repeat && (d = ni(0, e._tDur, t), s = Gt(d, c), e._yoyo && 1 & s && (l = 1 - l), s !== Gt(e._tTime, c) && (o = 1 - l, e.vars.repeatRefresh && e._initted && e.invalidate())), l !== o || pe || r || e._zTime === Le || !t && e._zTime) {
                        if (!e._initted && Ut(e, t, r, i, d)) return;
                        for (a = e._zTime, e._zTime = t || (i ? Le : 0), i || (i = t && !a), e.ratio = l, e._from && (l = 1 - l), e._time = 0, e._tTime = d, n = e._pt; n;) n.r(l, n.d), n = n._next;
                        t < 0 && Nt(e, t, 0, !0), e._onUpdate && !i && wi(e, "onUpdate"), d && e._repeat && !i && e.parent && wi(e, "onRepeat"), (t >= e._tDur || t < 0) && e.ratio === l && (l && Bt(e, 1), i || pe || (wi(e, l ? "onComplete" : "onReverseComplete", !0), e._prom && e._prom()))
                    } else e._zTime || (e._zTime = t)
                }(this, e, t, i);
                return this
            }, i.targets = function () {
                return this._targets
            }, i.invalidate = function (t) {
                return (!t || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(t), e.prototype.invalidate.call(this, t)
            }, i.resetTo = function (e, t, i, r, n) {
                xe || Ai.wake(), this._ts || this.play();
                var s = Math.min(this._dur, (this._dp._time - this._start) * this._ts);
                return this._initted || Ji(this, s),
                    function (e, t, i, r, n, s, a, o) {
                        var l, c, d, u, h = (e._pt && e._ptCache || (e._ptCache = {}))[t];
                        if (!h)
                            for (h = e._ptCache[t] = [], d = e._ptLookup, u = e._targets.length; u--;) {
                                if ((l = d[u][t]) && l.d && l.d._pt)
                                    for (l = l.d._pt; l && l.p !== t && l.fp !== t;) l = l._next;
                                if (!l) return Ui = 1, e.vars[t] = "+=0", Ji(e, a), Ui = 0, o ? nt(t + " not eligible for reset") : 1;
                                h.push(l)
                            }
                        for (u = h.length; u--;)(l = (c = h[u])._pt || c).s = !r && 0 !== r || n ? l.s + (r || 0) + s * l.c : r, l.c = i - l.s, c.e && (c.e = xt(i) + si(c.e)), c.b && (c.b = l.s + si(c.b))
                    }(this, e, t, i, r, this._ease(s / this._dur), s, n) ? this.resetTo(e, t, i, r, 1) : (Vt(this, 0), this.parent || zt(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0))
            }, i.kill = function (e, t) {
                if (void 0 === t && (t = "all"), !(e || t && "all" !== t)) return this._lazy = this._pt = 0, this.parent ? _i(this) : this;
                if (this.timeline) {
                    var i = this.timeline.totalDuration();
                    return this.timeline.killTweensOf(e, t, Wi && !0 !== Wi.vars.overwrite)._first || _i(this), this.parent && i !== this.timeline.totalDuration() && Qt(this, this._dur * this.timeline._tDur / i, 0, 1), this
                }
                var r, n, s, a, o, l, c, d = this._targets,
                    u = e ? li(e) : d,
                    h = this._ptLookup,
                    p = this._pt;
                if ((!t || "all" === t) && function (e, t) {
                    for (var i = e.length, r = i === t.length; r && i-- && e[i] === t[i];);
                    return i < 0
                }(d, u)) return "all" === t && (this._pt = 0), _i(this);
                for (r = this._op = this._op || [], "all" !== t && (Be(t) && (o = {}, bt(t, (function (e) {
                    return o[e] = 1
                })), t = o), t = function (e, t) {
                    var i, r, n, s, a = e[0] ? wt(e[0]).harness : 0,
                        o = a && a.aliases;
                    if (!o) return t;
                    for (r in i = Ot({}, t), o)
                        if (r in i)
                            for (n = (s = o[r].split(",")).length; n--;) i[s[n]] = i[r];
                    return i
                }(d, t)), c = d.length; c--;)
                    if (~u.indexOf(d[c]))
                        for (o in n = h[c], "all" === t ? (r[c] = t, a = n, s = {}) : (s = r[c] = r[c] || {}, a = t), a) (l = n && n[o]) && ("kill" in l.d && !0 !== l.d.kill(o) || Rt(this, l, "_pt"), delete n[o]), "all" !== s && (s[o] = 1);
                return this._initted && !this._pt && p && _i(this), this
            }, t.to = function (e, i) {
                return new t(e, i, arguments[2])
            }, t.from = function (e, t) {
                return ii(1, arguments)
            }, t.delayedCall = function (e, i, r, n) {
                return new t(i, 0, {
                    immediateRender: !1,
                    lazy: !1,
                    overwrite: !1,
                    delay: e,
                    onComplete: i,
                    onReverseComplete: i,
                    onCompleteParams: r,
                    onReverseCompleteParams: r,
                    callbackScope: n
                })
            }, t.fromTo = function (e, t, i) {
                return ii(2, arguments)
            }, t.set = function (e, i) {
                return i.duration = 0, i.repeatDelay || (i.repeat = 0), new t(e, i)
            }, t.killTweensOf = function (e, t, i) {
                return me.killTweensOf(e, t, i)
            }, t
        }(qi);
        Lt(nr.prototype, {
            _targets: [],
            _lazy: 0,
            _startAt: 0,
            _op: 0,
            _onInit: 0
        }), bt("staggerTo,staggerFrom,staggerFromTo", (function (e) {
            nr[e] = function () {
                var t = new $i,
                    i = ai.call(arguments, 0);
                return i.splice("staggerFromTo" === e ? 5 : 4, 0, 0), t[e].apply(t, i)
            }
        }));
        var sr = function (e, t, i) {
            return e[t] = i
        },
            ar = function (e, t, i) {
                return e[t](i)
            },
            or = function (e, t, i, r) {
                return e[t](r.fp, i)
            },
            lr = function (e, t, i) {
                return e.setAttribute(t, i)
            },
            cr = function (e, t) {
                return Fe(e[t]) ? ar : je(e[t]) && e.setAttribute ? lr : sr
            },
            dr = function (e, t) {
                return t.set(t.t, t.p, Math.round(1e6 * (t.s + t.c * e)) / 1e6, t)
            },
            ur = function (e, t) {
                return t.set(t.t, t.p, !!(t.s + t.c * e), t)
            },
            hr = function (e, t) {
                var i = t._pt,
                    r = "";
                if (!e && t.b) r = t.b;
                else if (1 === e && t.e) r = t.e;
                else {
                    for (; i;) r = i.p + (i.m ? i.m(i.s + i.c * e) : Math.round(1e4 * (i.s + i.c * e)) / 1e4) + r, i = i._next;
                    r += t.c
                }
                t.set(t.t, t.p, r, t)
            },
            pr = function (e, t) {
                for (var i = t._pt; i;) i.r(e, i.d), i = i._next
            },
            fr = function (e, t, i, r) {
                for (var n, s = this._pt; s;) n = s._next, s.p === r && s.modifier(e, t, i), s = n
            },
            mr = function (e) {
                for (var t, i, r = this._pt; r;) i = r._next, r.p === e && !r.op || r.op === e ? Rt(this, r, "_pt") : r.dep || (t = 1), r = i;
                return !t
            },
            gr = function (e, t, i, r) {
                r.mSet(e, t, r.m.call(r.tween, i, r.mt), r)
            },
            vr = function (e) {
                for (var t, i, r, n, s = e._pt; s;) {
                    for (t = s._next, i = r; i && i.pr > s.pr;) i = i._next;
                    (s._prev = i ? i._prev : n) ? s._prev._next = s : r = s, (s._next = i) ? i._prev = s : n = s, s = t
                }
                e._pt = r
            },
            yr = function () {
                function e(e, t, i, r, n, s, a, o, l) {
                    this.t = t, this.s = r, this.c = n, this.p = i, this.r = s || dr, this.d = a || this, this.set = o || sr, this.pr = l || 0, this._next = e, e && (e._prev = this)
                }
                return e.prototype.modifier = function (e, t, i) {
                    this.mSet = this.mSet || this.set, this.set = gr, this.m = e, this.mt = i, this.tween = t
                }, e
            }();
        bt(vt + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", (function (e) {
            return dt[e] = 1
        })), et.TweenMax = et.TweenLite = nr, et.TimelineLite = et.TimelineMax = $i, me = new $i({
            sortChildren: !1,
            defaults: ke,
            autoRemoveChildren: !0,
            id: "root",
            smoothChildTiming: !0
        }), Pe.stringFilter = Oi;
        var wr = [],
            _r = {},
            br = [],
            xr = 0,
            Tr = 0,
            Er = function (e) {
                return (_r[e] || br).map((function (e) {
                    return e()
                }))
            },
            Sr = function () {
                var e = Date.now(),
                    t = [];
                e - xr > 2 && (Er("matchMediaInit"), wr.forEach((function (e) {
                    var i, r, n, s, a = e.queries,
                        o = e.conditions;
                    for (r in a) (i = ge.matchMedia(a[r]).matches) && (n = 1), i !== o[r] && (o[r] = i, s = 1);
                    s && (e.revert(), n && t.push(e))
                })), Er("matchMediaRevert"), t.forEach((function (e) {
                    return e.onMatch(e, (function (t) {
                        return e.add(null, t)
                    }))
                })), xr = e, Er("matchMedia"))
            },
            Mr = function () {
                function e(e, t) {
                    this.selector = t && ci(t), this.data = [], this._r = [], this.isReverted = !1, this.id = Tr++, e && this.add(e)
                }
                var t = e.prototype;
                return t.add = function (e, t, i) {
                    Fe(e) && (i = t, t = e, e = Fe);
                    var r = this,
                        n = function () {
                            var e, n = fe,
                                s = r.selector;
                            return n && n !== r && n.data.push(r), i && (r.selector = ci(i)), fe = r, e = t.apply(r, arguments), Fe(e) && r._r.push(e), fe = n, r.selector = s, r.isReverted = !1, e
                        };
                    return r.last = n, e === Fe ? n(r, (function (e) {
                        return r.add(null, e)
                    })) : e ? r[e] = n : n
                }, t.ignore = function (e) {
                    var t = fe;
                    fe = null, e(this), fe = t
                }, t.getTweens = function () {
                    var t = [];
                    return this.data.forEach((function (i) {
                        return i instanceof e ? t.push.apply(t, i.getTweens()) : i instanceof nr && !(i.parent && "nested" === i.parent.data) && t.push(i)
                    })), t
                }, t.clear = function () {
                    this._r.length = this.data.length = 0
                }, t.kill = function (e, t) {
                    var i = this;
                    if (e ? function () {
                        for (var t, r = i.getTweens(), n = i.data.length; n--;) "isFlip" === (t = i.data[n]).data && (t.revert(), t.getChildren(!0, !0, !1).forEach((function (e) {
                            return r.splice(r.indexOf(e), 1)
                        })));
                        for (r.map((function (e) {
                            return {
                                g: e._dur || e._delay || e._sat && !e._sat.vars.immediateRender ? e.globalTime(0) : -1 / 0,
                                t: e
                            }
                        })).sort((function (e, t) {
                            return t.g - e.g || -1 / 0
                        })).forEach((function (t) {
                            return t.t.revert(e)
                        })), n = i.data.length; n--;)(t = i.data[n]) instanceof $i ? "nested" !== t.data && (t.scrollTrigger && t.scrollTrigger.revert(), t.kill()) : !(t instanceof nr) && t.revert && t.revert(e);
                        i._r.forEach((function (t) {
                            return t(e, i)
                        })), i.isReverted = !0
                    }() : this.data.forEach((function (e) {
                        return e.kill && e.kill()
                    })), this.clear(), t)
                        for (var r = wr.length; r--;) wr[r].id === this.id && wr.splice(r, 1)
                }, t.revert = function (e) {
                    this.kill(e || {})
                }, e
            }(),
            Pr = function () {
                function e(e) {
                    this.contexts = [], this.scope = e
                }
                var t = e.prototype;
                return t.add = function (e, t, i) {
                    He(e) || (e = {
                        matches: e
                    });
                    var r, n, s, a = new Mr(0, i || this.scope),
                        o = a.conditions = {};
                    for (n in fe && !a.selector && (a.selector = fe.selector), this.contexts.push(a), t = a.add("onMatch", t), a.queries = e, e) "all" === n ? s = 1 : (r = ge.matchMedia(e[n])) && (wr.indexOf(a) < 0 && wr.push(a), (o[n] = r.matches) && (s = 1), r.addListener ? r.addListener(Sr) : r.addEventListener("change", Sr));
                    return s && t(a, (function (e) {
                        return a.add(null, e)
                    })), this
                }, t.revert = function (e) {
                    this.kill(e || {})
                }, t.kill = function (e) {
                    this.contexts.forEach((function (t) {
                        return t.kill(e, !0)
                    }))
                }, e
            }(),
            kr = {
                registerPlugin: function () {
                    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
                    t.forEach((function (e) {
                        return xi(e)
                    }))
                },
                timeline: function (e) {
                    return new $i(e)
                },
                getTweensOf: function (e, t) {
                    return me.getTweensOf(e, t)
                },
                getProperty: function (e, t, i, r) {
                    Be(e) && (e = li(e)[0]);
                    var n = wt(e || {}).get,
                        s = i ? Ct : kt;
                    return "native" === i && (i = ""), e ? t ? s((pt[t] && pt[t].get || n)(e, t, i, r)) : function (t, i, r) {
                        return s((pt[t] && pt[t].get || n)(e, t, i, r))
                    } : e
                },
                quickSetter: function (e, t, i) {
                    if ((e = li(e)).length > 1) {
                        var r = e.map((function (e) {
                            return Or.quickSetter(e, t, i)
                        })),
                            n = r.length;
                        return function (e) {
                            for (var t = n; t--;) r[t](e)
                        }
                    }
                    e = e[0] || {};
                    var s = pt[t],
                        a = wt(e),
                        o = a.harness && (a.harness.aliases || {})[t] || t,
                        l = s ? function (t) {
                            var r = new s;
                            be._pt = 0, r.init(e, i ? t + i : t, be, 0, [e]), r.render(1, r), be._pt && pr(1, be)
                        } : a.set(e, o);
                    return s ? l : function (t) {
                        return l(e, o, i ? t + i : t, a, 1)
                    }
                },
                quickTo: function (e, t, i) {
                    var r, n = Or.to(e, Ot(((r = {})[t] = "+=0.1", r.paused = !0, r), i || {})),
                        s = function (e, i, r) {
                            return n.resetTo(t, e, i, r)
                        };
                    return s.tween = n, s
                },
                isTweening: function (e) {
                    return me.getTweensOf(e, !0).length > 0
                },
                defaults: function (e) {
                    return e && e.ease && (e.ease = ji(e.ease, ke.ease)), At(ke, e || {})
                },
                config: function (e) {
                    return At(Pe, e || {})
                },
                registerEffect: function (e) {
                    var t = e.name,
                        i = e.effect,
                        r = e.plugins,
                        n = e.defaults,
                        s = e.extendTimeline;
                    (r || "").split(",").forEach((function (e) {
                        return e && !pt[e] && !et[e] && nt(t + " effect requires " + e + " plugin.")
                    })), ft[t] = function (e, t, r) {
                        return i(li(e), Lt(t || {}, n), r)
                    }, s && ($i.prototype[t] = function (e, i, r) {
                        return this.add(ft[t](e, He(i) ? i : (r = i) && {}, this), r)
                    })
                },
                registerEase: function (e, t) {
                    Ii[e] = ji(t)
                },
                parseEase: function (e, t) {
                    return arguments.length ? ji(e, t) : Ii
                },
                getById: function (e) {
                    return me.getById(e)
                },
                exportRoot: function (e, t) {
                    void 0 === e && (e = {});
                    var i, r, n = new $i(e);
                    for (n.smoothChildTiming = Ge(e.smoothChildTiming), me.remove(n), n._dp = 0, n._time = n._tTime = me._time, i = me._first; i;) r = i._next, !t && !i._dur && i instanceof nr && i.vars.onComplete === i._targets[0] || $t(n, i, i._start - i._delay), i = r;
                    return $t(me, n, 0), n
                },
                context: function (e, t) {
                    return e ? new Mr(e, t) : fe
                },
                matchMedia: function (e) {
                    return new Pr(e)
                },
                matchMediaRefresh: function () {
                    return wr.forEach((function (e) {
                        var t, i, r = e.conditions;
                        for (i in r) r[i] && (r[i] = !1, t = 1);
                        t && e.revert()
                    })) || Sr()
                },
                addEventListener: function (e, t) {
                    var i = _r[e] || (_r[e] = []);
                    ~i.indexOf(t) || i.push(t)
                },
                removeEventListener: function (e, t) {
                    var i = _r[e],
                        r = i && i.indexOf(t);
                    r >= 0 && i.splice(r, 1)
                },
                utils: {
                    wrap: function e(t, i, r) {
                        var n = i - t;
                        return qe(t) ? mi(t, e(0, t.length), i) : ri(r, (function (e) {
                            return (n + (e - t) % n) % n + t
                        }))
                    },
                    wrapYoyo: function e(t, i, r) {
                        var n = i - t,
                            s = 2 * n;
                        return qe(t) ? mi(t, e(0, t.length - 1), i) : ri(r, (function (e) {
                            return t + ((e = (s + (e - t) % s) % s || 0) > n ? s - e : e)
                        }))
                    },
                    distribute: ui,
                    random: fi,
                    snap: pi,
                    normalize: function (e, t, i) {
                        return vi(e, t, 0, 1, i)
                    },
                    getUnit: si,
                    clamp: function (e, t, i) {
                        return ri(i, (function (i) {
                            return ni(e, t, i)
                        }))
                    },
                    splitColor: Mi,
                    toArray: li,
                    selector: ci,
                    mapRange: vi,
                    pipe: function () {
                        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
                        return function (e) {
                            return t.reduce((function (e, t) {
                                return t(e)
                            }), e)
                        }
                    },
                    unitize: function (e, t) {
                        return function (i) {
                            return e(parseFloat(i)) + (t || si(i))
                        }
                    },
                    interpolate: function e(t, i, r, n) {
                        var s = isNaN(t + i) ? 0 : function (e) {
                            return (1 - e) * t + e * i
                        };
                        if (!s) {
                            var a, o, l, c, d, u = Be(t),
                                h = {};
                            if (!0 === r && (n = 1) && (r = null), u) t = {
                                p: t
                            }, i = {
                                p: i
                            };
                            else if (qe(t) && !qe(i)) {
                                for (l = [], c = t.length, d = c - 2, o = 1; o < c; o++) l.push(e(t[o - 1], t[o]));
                                c--, s = function (e) {
                                    e *= c;
                                    var t = Math.min(d, ~~e);
                                    return l[t](e - t)
                                }, r = i
                            } else n || (t = Ot(qe(t) ? [] : {}, t));
                            if (!l) {
                                for (a in i) Zi.call(h, t, a, "get", i[a]);
                                s = function (e) {
                                    return pr(e, h) || (u ? t.p : t)
                                }
                            }
                        }
                        return ri(r, s)
                    },
                    shuffle: di
                },
                install: it,
                effects: ft,
                ticker: Ai,
                updateRoot: $i.updateRoot,
                plugins: pt,
                globalTimeline: me,
                core: {
                    PropTween: yr,
                    globals: st,
                    Tween: nr,
                    Timeline: $i,
                    Animation: qi,
                    getCache: wt,
                    _removeLinkedListItem: Rt,
                    reverting: function () {
                        return pe
                    },
                    context: function (e) {
                        return e && fe && (fe.data.push(e), e._ctx = fe), fe
                    },
                    suppressOverwrites: function (e) {
                        return he = e
                    }
                }
            };
        bt("to,from,fromTo,delayedCall,set,killTweensOf", (function (e) {
            return kr[e] = nr[e]
        })), Ai.add($i.updateRoot), be = kr.to({}, {
            duration: 0
        });
        var Cr = function (e, t) {
            for (var i = e._pt; i && i.p !== t && i.op !== t && i.fp !== t;) i = i._next;
            return i
        },
            Lr = function (e, t) {
                return {
                    name: e,
                    rawVars: 1,
                    init: function (e, i, r) {
                        r._onInit = function (e) {
                            var r, n;
                            if (Be(i) && (r = {}, bt(i, (function (e) {
                                return r[e] = 1
                            })), i = r), t) {
                                for (n in r = {}, i) r[n] = t(i[n]);
                                i = r
                            } ! function (e, t) {
                                var i, r, n, s = e._targets;
                                for (i in t)
                                    for (r = s.length; r--;)(n = e._ptLookup[r][i]) && (n = n.d) && (n._pt && (n = Cr(n, i)), n && n.modifier && n.modifier(t[i], e, s[r], i))
                            }(e, i)
                        }
                    }
                }
            },
            Or = kr.registerPlugin({
                name: "attr",
                init: function (e, t, i, r, n) {
                    var s, a, o;
                    for (s in this.tween = i, t) o = e.getAttribute(s) || "", (a = this.add(e, "setAttribute", (o || 0) + "", t[s], r, n, 0, 0, s)).op = s, a.b = o, this._props.push(s)
                },
                render: function (e, t) {
                    for (var i = t._pt; i;) pe ? i.set(i.t, i.p, i.b, i) : i.r(e, i.d), i = i._next
                }
            }, {
                name: "endArray",
                init: function (e, t) {
                    for (var i = t.length; i--;) this.add(e, i, e[i] || 0, t[i], 0, 0, 0, 0, 0, 1)
                }
            }, Lr("roundProps", hi), Lr("modifiers"), Lr("snap", pi)) || kr;
        nr.version = $i.version = Or.version = "3.12.4", we = 1, Ye() && Di(), Ii.Power0, Ii.Power1, Ii.Power2, Ii.Power3, Ii.Power4, Ii.Linear, Ii.Quad, Ii.Cubic, Ii.Quart, Ii.Quint, Ii.Strong, Ii.Elastic, Ii.Back, Ii.SteppedEase, Ii.Bounce, Ii.Sine, Ii.Expo, Ii.Circ;
        var Ar, Dr, Ir, zr, Rr, Br, Fr, Nr, jr = {},
            Hr = 180 / Math.PI,
            Gr = Math.PI / 180,
            Yr = Math.atan2,
            Xr = /([A-Z])/g,
            Vr = /(left|right|width|margin|padding|x)/i,
            qr = /[\s,\(]\S/,
            $r = {
                autoAlpha: "opacity,visibility",
                scale: "scaleX,scaleY",
                alpha: "opacity"
            },
            Wr = function (e, t) {
                return t.set(t.t, t.p, Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u, t)
            },
            Ur = function (e, t) {
                return t.set(t.t, t.p, 1 === e ? t.e : Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u, t)
            },
            Kr = function (e, t) {
                return t.set(t.t, t.p, e ? Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u : t.b, t)
            },
            Zr = function (e, t) {
                var i = t.s + t.c * e;
                t.set(t.t, t.p, ~~(i + (i < 0 ? -.5 : .5)) + t.u, t)
            },
            Qr = function (e, t) {
                return t.set(t.t, t.p, e ? t.e : t.b, t)
            },
            Jr = function (e, t) {
                return t.set(t.t, t.p, 1 !== e ? t.b : t.e, t)
            },
            en = function (e, t, i) {
                return e.style[t] = i
            },
            tn = function (e, t, i) {
                return e.style.setProperty(t, i)
            },
            rn = function (e, t, i) {
                return e._gsap[t] = i
            },
            nn = function (e, t, i) {
                return e._gsap.scaleX = e._gsap.scaleY = i
            },
            sn = function (e, t, i, r, n) {
                var s = e._gsap;
                s.scaleX = s.scaleY = i, s.renderTransform(n, s)
            },
            an = function (e, t, i, r, n) {
                var s = e._gsap;
                s[t] = i, s.renderTransform(n, s)
            },
            on = "transform",
            ln = on + "Origin",
            cn = function e(t, i) {
                var r = this,
                    n = this.target,
                    s = n.style,
                    a = n._gsap;
                if (t in jr && s) {
                    if (this.tfm = this.tfm || {}, "transform" === t) return $r.transform.split(",").forEach((function (t) {
                        return e.call(r, t, i)
                    }));
                    if (~(t = $r[t] || t).indexOf(",") ? t.split(",").forEach((function (e) {
                        return r.tfm[e] = Pn(n, e)
                    })) : this.tfm[t] = a.x ? a[t] : Pn(n, t), t === ln && (this.tfm.zOrigin = a.zOrigin), this.props.indexOf(on) >= 0) return;
                    a.svg && (this.svgo = n.getAttribute("data-svg-origin"), this.props.push(ln, i, "")), t = on
                } (s || i) && this.props.push(t, i, s[t])
            },
            dn = function (e) {
                e.translate && (e.removeProperty("translate"), e.removeProperty("scale"), e.removeProperty("rotate"))
            },
            un = function () {
                var e, t, i = this.props,
                    r = this.target,
                    n = r.style,
                    s = r._gsap;
                for (e = 0; e < i.length; e += 3) i[e + 1] ? r[i[e]] = i[e + 2] : i[e + 2] ? n[i[e]] = i[e + 2] : n.removeProperty("--" === i[e].substr(0, 2) ? i[e] : i[e].replace(Xr, "-$1").toLowerCase());
                if (this.tfm) {
                    for (t in this.tfm) s[t] = this.tfm[t];
                    s.svg && (s.renderTransform(), r.setAttribute("data-svg-origin", this.svgo || "")), (e = Fr()) && e.isStart || n[on] || (dn(n), s.zOrigin && n[ln] && (n[ln] += " " + s.zOrigin + "px", s.zOrigin = 0, s.renderTransform()), s.uncache = 1)
                }
            },
            hn = function (e, t) {
                var i = {
                    target: e,
                    props: [],
                    revert: un,
                    save: cn
                };
                return e._gsap || Or.core.getCache(e), t && t.split(",").forEach((function (e) {
                    return i.save(e)
                })), i
            },
            pn = function (e, t) {
                var i = Dr.createElementNS ? Dr.createElementNS((t || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), e) : Dr.createElement(e);
                return i && i.style ? i : Dr.createElement(e)
            },
            fn = function e(t, i, r) {
                var n = getComputedStyle(t);
                return n[i] || n.getPropertyValue(i.replace(Xr, "-$1").toLowerCase()) || n.getPropertyValue(i) || !r && e(t, gn(i) || i, 1) || ""
            },
            mn = "O,Moz,ms,Ms,Webkit".split(","),
            gn = function (e, t, i) {
                var r = (t || Rr).style,
                    n = 5;
                if (e in r && !i) return e;
                for (e = e.charAt(0).toUpperCase() + e.substr(1); n-- && !(mn[n] + e in r););
                return n < 0 ? null : (3 === n ? "ms" : n >= 0 ? mn[n] : "") + e
            },
            vn = function () {
                "undefined" != typeof window && window.document && (Ar = window, Dr = Ar.document, Ir = Dr.documentElement, Rr = pn("div") || {
                    style: {}
                }, pn("div"), on = gn(on), ln = on + "Origin", Rr.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", Nr = !!gn("perspective"), Fr = Or.core.reverting, zr = 1)
            },
            yn = function e(t) {
                var i, r = pn("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
                    n = this.parentNode,
                    s = this.nextSibling,
                    a = this.style.cssText;
                if (Ir.appendChild(r), r.appendChild(this), this.style.display = "block", t) try {
                    i = this.getBBox(), this._gsapBBox = this.getBBox, this.getBBox = e
                } catch (e) { } else this._gsapBBox && (i = this._gsapBBox());
                return n && (s ? n.insertBefore(this, s) : n.appendChild(this)), Ir.removeChild(r), this.style.cssText = a, i
            },
            wn = function (e, t) {
                for (var i = t.length; i--;)
                    if (e.hasAttribute(t[i])) return e.getAttribute(t[i])
            },
            _n = function (e) {
                var t;
                try {
                    t = e.getBBox()
                } catch (i) {
                    t = yn.call(e, !0)
                }
                return t && (t.width || t.height) || e.getBBox === yn || (t = yn.call(e, !0)), !t || t.width || t.x || t.y ? t : {
                    x: +wn(e, ["x", "cx", "x1"]) || 0,
                    y: +wn(e, ["y", "cy", "y1"]) || 0,
                    width: 0,
                    height: 0
                }
            },
            bn = function (e) {
                return !(!e.getCTM || e.parentNode && !e.ownerSVGElement || !_n(e))
            },
            xn = function (e, t) {
                if (t) {
                    var i, r = e.style;
                    t in jr && t !== ln && (t = on), r.removeProperty ? ("ms" !== (i = t.substr(0, 2)) && "webkit" !== t.substr(0, 6) || (t = "-" + t), r.removeProperty("--" === i ? t : t.replace(Xr, "-$1").toLowerCase())) : r.removeAttribute(t)
                }
            },
            Tn = function (e, t, i, r, n, s) {
                var a = new yr(e._pt, t, i, 0, 1, s ? Jr : Qr);
                return e._pt = a, a.b = r, a.e = n, e._props.push(i), a
            },
            En = {
                deg: 1,
                rad: 1,
                turn: 1
            },
            Sn = {
                grid: 1,
                flex: 1
            },
            Mn = function e(t, i, r, n) {
                var s, a, o, l, c = parseFloat(r) || 0,
                    d = (r + "").trim().substr((c + "").length) || "px",
                    u = Rr.style,
                    h = Vr.test(i),
                    p = "svg" === t.tagName.toLowerCase(),
                    f = (p ? "client" : "offset") + (h ? "Width" : "Height"),
                    m = 100,
                    g = "px" === n,
                    v = "%" === n;
                if (n === d || !c || En[n] || En[d]) return c;
                if ("px" !== d && !g && (c = e(t, i, r, "px")), l = t.getCTM && bn(t), (v || "%" === d) && (jr[i] || ~i.indexOf("adius"))) return s = l ? t.getBBox()[h ? "width" : "height"] : t[f], xt(v ? c / s * m : c / 100 * s);
                if (u[h ? "width" : "height"] = m + (g ? d : n), a = ~i.indexOf("adius") || "em" === n && t.appendChild && !p ? t : t.parentNode, l && (a = (t.ownerSVGElement || {}).parentNode), a && a !== Dr && a.appendChild || (a = Dr.body), (o = a._gsap) && v && o.width && h && o.time === Ai.time && !o.uncache) return xt(c / o.width * m);
                if (!v || "height" !== i && "width" !== i) (v || "%" === d) && !Sn[fn(a, "display")] && (u.position = fn(t, "position")), a === t && (u.position = "static"), a.appendChild(Rr), s = Rr[f], a.removeChild(Rr), u.position = "absolute";
                else {
                    var y = t.style[i];
                    t.style[i] = m + n, s = t[f], y ? t.style[i] = y : xn(t, i)
                }
                return h && v && ((o = wt(a)).time = Ai.time, o.width = a[f]), xt(g ? s * c / m : s && c ? m / s * c : 0)
            },
            Pn = function (e, t, i, r) {
                var n;
                return zr || vn(), t in $r && "transform" !== t && ~(t = $r[t]).indexOf(",") && (t = t.split(",")[0]), jr[t] && "transform" !== t ? (n = Nn(e, r), n = "transformOrigin" !== t ? n[t] : n.svg ? n.origin : jn(fn(e, ln)) + " " + n.zOrigin + "px") : (!(n = e.style[t]) || "auto" === n || r || ~(n + "").indexOf("calc(")) && (n = An[t] && An[t](e, t, i) || fn(e, t) || _t(e, t) || ("opacity" === t ? 1 : 0)), i && !~(n + "").trim().indexOf(" ") ? Mn(e, t, n, i) + i : n
            },
            kn = function (e, t, i, r) {
                if (!i || "none" === i) {
                    var n = gn(t, e, 1),
                        s = n && fn(e, n, 1);
                    s && s !== i ? (t = n, i = s) : "borderColor" === t && (i = fn(e, "borderTopColor"))
                }
                var a, o, l, c, d, u, h, p, f, m, g, v = new yr(this._pt, e.style, t, 0, 1, hr),
                    y = 0,
                    w = 0;
                if (v.b = i, v.e = r, i += "", "auto" == (r += "") && (u = e.style[t], e.style[t] = r, r = fn(e, t) || r, u ? e.style[t] = u : xn(e, t)), Oi(a = [i, r]), r = a[1], l = (i = a[0]).match(Ue) || [], (r.match(Ue) || []).length) {
                    for (; o = Ue.exec(r);) h = o[0], f = r.substring(y, o.index), d ? d = (d + 1) % 5 : "rgba(" !== f.substr(-5) && "hsla(" !== f.substr(-5) || (d = 1), h !== (u = l[w++] || "") && (c = parseFloat(u) || 0, g = u.substr((c + "").length), "=" === h.charAt(1) && (h = Et(c, h) + g), p = parseFloat(h), m = h.substr((p + "").length), y = Ue.lastIndex - m.length, m || (m = m || Pe.units[t] || g, y === r.length && (r += m, v.e += m)), g !== m && (c = Mn(e, t, u, m) || 0), v._pt = {
                        _next: v._pt,
                        p: f || 1 === w ? f : ",",
                        s: c,
                        c: p - c,
                        m: d && d < 4 || "zIndex" === t ? Math.round : 0
                    });
                    v.c = y < r.length ? r.substring(y, r.length) : ""
                } else v.r = "display" === t && "none" === r ? Jr : Qr;
                return Ze.test(r) && (v.e = 0), this._pt = v, v
            },
            Cn = {
                top: "0%",
                bottom: "100%",
                left: "0%",
                right: "100%",
                center: "50%"
            },
            Ln = function (e) {
                var t = e.split(" "),
                    i = t[0],
                    r = t[1] || "50%";
                return "top" !== i && "bottom" !== i && "left" !== r && "right" !== r || (e = i, i = r, r = e), t[0] = Cn[i] || i, t[1] = Cn[r] || r, t.join(" ")
            },
            On = function (e, t) {
                if (t.tween && t.tween._time === t.tween._dur) {
                    var i, r, n, s = t.t,
                        a = s.style,
                        o = t.u,
                        l = s._gsap;
                    if ("all" === o || !0 === o) a.cssText = "", r = 1;
                    else
                        for (n = (o = o.split(",")).length; --n > -1;) i = o[n], jr[i] && (r = 1, i = "transformOrigin" === i ? ln : on), xn(s, i);
                    r && (xn(s, on), l && (l.svg && s.removeAttribute("transform"), Nn(s, 1), l.uncache = 1, dn(a)))
                }
            },
            An = {
                clearProps: function (e, t, i, r, n) {
                    if ("isFromStart" !== n.data) {
                        var s = e._pt = new yr(e._pt, t, i, 0, 0, On);
                        return s.u = r, s.pr = -10, s.tween = n, e._props.push(i), 1
                    }
                }
            },
            Dn = [1, 0, 0, 1, 0, 0],
            In = {},
            zn = function (e) {
                return "matrix(1, 0, 0, 1, 0, 0)" === e || "none" === e || !e
            },
            Rn = function (e) {
                var t = fn(e, on);
                return zn(t) ? Dn : t.substr(7).match(We).map(xt)
            },
            Bn = function (e, t) {
                var i, r, n, s, a = e._gsap || wt(e),
                    o = e.style,
                    l = Rn(e);
                return a.svg && e.getAttribute("transform") ? "1,0,0,1,0,0" === (l = [(n = e.transform.baseVal.consolidate().matrix).a, n.b, n.c, n.d, n.e, n.f]).join(",") ? Dn : l : (l !== Dn || e.offsetParent || e === Ir || a.svg || (n = o.display, o.display = "block", (i = e.parentNode) && e.offsetParent || (s = 1, r = e.nextElementSibling, Ir.appendChild(e)), l = Rn(e), n ? o.display = n : xn(e, "display"), s && (r ? i.insertBefore(e, r) : i ? i.appendChild(e) : Ir.removeChild(e))), t && l.length > 6 ? [l[0], l[1], l[4], l[5], l[12], l[13]] : l)
            },
            Fn = function (e, t, i, r, n, s) {
                var a, o, l, c = e._gsap,
                    d = n || Bn(e, !0),
                    u = c.xOrigin || 0,
                    h = c.yOrigin || 0,
                    p = c.xOffset || 0,
                    f = c.yOffset || 0,
                    m = d[0],
                    g = d[1],
                    v = d[2],
                    y = d[3],
                    w = d[4],
                    _ = d[5],
                    b = t.split(" "),
                    x = parseFloat(b[0]) || 0,
                    T = parseFloat(b[1]) || 0;
                i ? d !== Dn && (o = m * y - g * v) && (l = x * (-g / o) + T * (m / o) - (m * _ - g * w) / o, x = x * (y / o) + T * (-v / o) + (v * _ - y * w) / o, T = l) : (x = (a = _n(e)).x + (~b[0].indexOf("%") ? x / 100 * a.width : x), T = a.y + (~(b[1] || b[0]).indexOf("%") ? T / 100 * a.height : T)), r || !1 !== r && c.smooth ? (w = x - u, _ = T - h, c.xOffset = p + (w * m + _ * v) - w, c.yOffset = f + (w * g + _ * y) - _) : c.xOffset = c.yOffset = 0, c.xOrigin = x, c.yOrigin = T, c.smooth = !!r, c.origin = t, c.originIsAbsolute = !!i, e.style[ln] = "0px 0px", s && (Tn(s, c, "xOrigin", u, x), Tn(s, c, "yOrigin", h, T), Tn(s, c, "xOffset", p, c.xOffset), Tn(s, c, "yOffset", f, c.yOffset)), e.setAttribute("data-svg-origin", x + " " + T)
            },
            Nn = function (e, t) {
                var i = e._gsap || new Vi(e);
                if ("x" in i && !t && !i.uncache) return i;
                var r, n, s, a, o, l, c, d, u, h, p, f, m, g, v, y, w, _, b, x, T, E, S, M, P, k, C, L, O, A, D, I, z = e.style,
                    R = i.scaleX < 0,
                    B = "px",
                    F = "deg",
                    N = getComputedStyle(e),
                    j = fn(e, ln) || "0";
                return r = n = s = l = c = d = u = h = p = 0, a = o = 1, i.svg = !(!e.getCTM || !bn(e)), N.translate && ("none" === N.translate && "none" === N.scale && "none" === N.rotate || (z[on] = ("none" !== N.translate ? "translate3d(" + (N.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + ("none" !== N.rotate ? "rotate(" + N.rotate + ") " : "") + ("none" !== N.scale ? "scale(" + N.scale.split(" ").join(",") + ") " : "") + ("none" !== N[on] ? N[on] : "")), z.scale = z.rotate = z.translate = "none"), g = Bn(e, i.svg), i.svg && (i.uncache ? (P = e.getBBox(), j = i.xOrigin - P.x + "px " + (i.yOrigin - P.y) + "px", M = "") : M = !t && e.getAttribute("data-svg-origin"), Fn(e, M || j, !!M || i.originIsAbsolute, !1 !== i.smooth, g)), f = i.xOrigin || 0, m = i.yOrigin || 0, g !== Dn && (_ = g[0], b = g[1], x = g[2], T = g[3], r = E = g[4], n = S = g[5], 6 === g.length ? (a = Math.sqrt(_ * _ + b * b), o = Math.sqrt(T * T + x * x), l = _ || b ? Yr(b, _) * Hr : 0, (u = x || T ? Yr(x, T) * Hr + l : 0) && (o *= Math.abs(Math.cos(u * Gr))), i.svg && (r -= f - (f * _ + m * x), n -= m - (f * b + m * T))) : (I = g[6], A = g[7], C = g[8], L = g[9], O = g[10], D = g[11], r = g[12], n = g[13], s = g[14], c = (v = Yr(I, O)) * Hr, v && (M = E * (y = Math.cos(-v)) + C * (w = Math.sin(-v)), P = S * y + L * w, k = I * y + O * w, C = E * -w + C * y, L = S * -w + L * y, O = I * -w + O * y, D = A * -w + D * y, E = M, S = P, I = k), d = (v = Yr(-x, O)) * Hr, v && (y = Math.cos(-v), D = T * (w = Math.sin(-v)) + D * y, _ = M = _ * y - C * w, b = P = b * y - L * w, x = k = x * y - O * w), l = (v = Yr(b, _)) * Hr, v && (M = _ * (y = Math.cos(v)) + b * (w = Math.sin(v)), P = E * y + S * w, b = b * y - _ * w, S = S * y - E * w, _ = M, E = P), c && Math.abs(c) + Math.abs(l) > 359.9 && (c = l = 0, d = 180 - d), a = xt(Math.sqrt(_ * _ + b * b + x * x)), o = xt(Math.sqrt(S * S + I * I)), v = Yr(E, S), u = Math.abs(v) > 2e-4 ? v * Hr : 0, p = D ? 1 / (D < 0 ? -D : D) : 0), i.svg && (M = e.getAttribute("transform"), i.forceCSS = e.setAttribute("transform", "") || !zn(fn(e, on)), M && e.setAttribute("transform", M))), Math.abs(u) > 90 && Math.abs(u) < 270 && (R ? (a *= -1, u += l <= 0 ? 180 : -180, l += l <= 0 ? 180 : -180) : (o *= -1, u += u <= 0 ? 180 : -180)), t = t || i.uncache, i.x = r - ((i.xPercent = r && (!t && i.xPercent || (Math.round(e.offsetWidth / 2) === Math.round(-r) ? -50 : 0))) ? e.offsetWidth * i.xPercent / 100 : 0) + B, i.y = n - ((i.yPercent = n && (!t && i.yPercent || (Math.round(e.offsetHeight / 2) === Math.round(-n) ? -50 : 0))) ? e.offsetHeight * i.yPercent / 100 : 0) + B, i.z = s + B, i.scaleX = xt(a), i.scaleY = xt(o), i.rotation = xt(l) + F, i.rotationX = xt(c) + F, i.rotationY = xt(d) + F, i.skewX = u + F, i.skewY = h + F, i.transformPerspective = p + B, (i.zOrigin = parseFloat(j.split(" ")[2]) || !t && i.zOrigin || 0) && (z[ln] = jn(j)), i.xOffset = i.yOffset = 0, i.force3D = Pe.force3D, i.renderTransform = i.svg ? $n : Nr ? qn : Gn, i.uncache = 0, i
            },
            jn = function (e) {
                return (e = e.split(" "))[0] + " " + e[1]
            },
            Hn = function (e, t, i) {
                var r = si(t);
                return xt(parseFloat(t) + parseFloat(Mn(e, "x", i + "px", r))) + r
            },
            Gn = function (e, t) {
                t.z = "0px", t.rotationY = t.rotationX = "0deg", t.force3D = 0, qn(e, t)
            },
            Yn = "0deg",
            Xn = "0px",
            Vn = ") ",
            qn = function (e, t) {
                var i = t || this,
                    r = i.xPercent,
                    n = i.yPercent,
                    s = i.x,
                    a = i.y,
                    o = i.z,
                    l = i.rotation,
                    c = i.rotationY,
                    d = i.rotationX,
                    u = i.skewX,
                    h = i.skewY,
                    p = i.scaleX,
                    f = i.scaleY,
                    m = i.transformPerspective,
                    g = i.force3D,
                    v = i.target,
                    y = i.zOrigin,
                    w = "",
                    _ = "auto" === g && e && 1 !== e || !0 === g;
                if (y && (d !== Yn || c !== Yn)) {
                    var b, x = parseFloat(c) * Gr,
                        T = Math.sin(x),
                        E = Math.cos(x);
                    x = parseFloat(d) * Gr, b = Math.cos(x), s = Hn(v, s, T * b * -y), a = Hn(v, a, -Math.sin(x) * -y), o = Hn(v, o, E * b * -y + y)
                }
                m !== Xn && (w += "perspective(" + m + Vn), (r || n) && (w += "translate(" + r + "%, " + n + "%) "), (_ || s !== Xn || a !== Xn || o !== Xn) && (w += o !== Xn || _ ? "translate3d(" + s + ", " + a + ", " + o + ") " : "translate(" + s + ", " + a + Vn), l !== Yn && (w += "rotate(" + l + Vn), c !== Yn && (w += "rotateY(" + c + Vn), d !== Yn && (w += "rotateX(" + d + Vn), u === Yn && h === Yn || (w += "skew(" + u + ", " + h + Vn), 1 === p && 1 === f || (w += "scale(" + p + ", " + f + Vn), v.style[on] = w || "translate(0, 0)"
            },
            $n = function (e, t) {
                var i, r, n, s, a, o = t || this,
                    l = o.xPercent,
                    c = o.yPercent,
                    d = o.x,
                    u = o.y,
                    h = o.rotation,
                    p = o.skewX,
                    f = o.skewY,
                    m = o.scaleX,
                    g = o.scaleY,
                    v = o.target,
                    y = o.xOrigin,
                    w = o.yOrigin,
                    _ = o.xOffset,
                    b = o.yOffset,
                    x = o.forceCSS,
                    T = parseFloat(d),
                    E = parseFloat(u);
                h = parseFloat(h), p = parseFloat(p), (f = parseFloat(f)) && (p += f = parseFloat(f), h += f), h || p ? (h *= Gr, p *= Gr, i = Math.cos(h) * m, r = Math.sin(h) * m, n = Math.sin(h - p) * -g, s = Math.cos(h - p) * g, p && (f *= Gr, a = Math.tan(p - f), n *= a = Math.sqrt(1 + a * a), s *= a, f && (a = Math.tan(f), i *= a = Math.sqrt(1 + a * a), r *= a)), i = xt(i), r = xt(r), n = xt(n), s = xt(s)) : (i = m, s = g, r = n = 0), (T && !~(d + "").indexOf("px") || E && !~(u + "").indexOf("px")) && (T = Mn(v, "x", d, "px"), E = Mn(v, "y", u, "px")), (y || w || _ || b) && (T = xt(T + y - (y * i + w * n) + _), E = xt(E + w - (y * r + w * s) + b)), (l || c) && (a = v.getBBox(), T = xt(T + l / 100 * a.width), E = xt(E + c / 100 * a.height)), a = "matrix(" + i + "," + r + "," + n + "," + s + "," + T + "," + E + ")", v.setAttribute("transform", a), x && (v.style[on] = a)
            },
            Wn = function (e, t, i, r, n) {
                var s, a, o = 360,
                    l = Be(n),
                    c = parseFloat(n) * (l && ~n.indexOf("rad") ? Hr : 1) - r,
                    d = r + c + "deg";
                return l && ("short" === (s = n.split("_")[1]) && (c %= o) != c % 180 && (c += c < 0 ? o : -360), "cw" === s && c < 0 ? c = (c + 36e9) % o - ~~(c / o) * o : "ccw" === s && c > 0 && (c = (c - 36e9) % o - ~~(c / o) * o)), e._pt = a = new yr(e._pt, t, i, r, c, Ur), a.e = d, a.u = "deg", e._props.push(i), a
            },
            Un = function (e, t) {
                for (var i in t) e[i] = t[i];
                return e
            },
            Kn = function (e, t, i) {
                var r, n, s, a, o, l, c, d = Un({}, i._gsap),
                    u = i.style;
                for (n in d.svg ? (s = i.getAttribute("transform"), i.setAttribute("transform", ""), u[on] = t, r = Nn(i, 1), xn(i, on), i.setAttribute("transform", s)) : (s = getComputedStyle(i)[on], u[on] = t, r = Nn(i, 1), u[on] = s), jr) (s = d[n]) !== (a = r[n]) && "perspective,force3D,transformOrigin,svgOrigin".indexOf(n) < 0 && (o = si(s) !== (c = si(a)) ? Mn(i, n, s, c) : parseFloat(s), l = parseFloat(a), e._pt = new yr(e._pt, r, n, o, l - o, Wr), e._pt.u = c || 0, e._props.push(n));
                Un(r, d)
            };
        bt("padding,margin,Width,Radius", (function (e, t) {
            var i = "Top",
                r = "Right",
                n = "Bottom",
                s = "Left",
                a = (t < 3 ? [i, r, n, s] : [i + s, i + r, n + r, n + s]).map((function (i) {
                    return t < 2 ? e + i : "border" + i + e
                }));
            An[t > 1 ? "border" + e : e] = function (e, t, i, r, n) {
                var s, o;
                if (arguments.length < 4) return s = a.map((function (t) {
                    return Pn(e, t, i)
                })), 5 === (o = s.join(" ")).split(s[0]).length ? s[0] : o;
                s = (r + "").split(" "), o = {}, a.forEach((function (e, t) {
                    return o[e] = s[t] = s[t] || s[(t - 1) / 2 | 0]
                })), e.init(t, o, n)
            }
        }));
        var Zn, Qn, Jn = {
            name: "css",
            register: vn,
            targetTest: function (e) {
                return e.style && e.nodeType
            },
            init: function (e, t, i, r, n) {
                var s, a, o, l, c, d, u, h, p, f, m, g, v, y, w, _, b = this._props,
                    x = e.style,
                    T = i.vars.startAt;
                for (u in zr || vn(), this.styles = this.styles || hn(e), _ = this.styles.props, this.tween = i, t)
                    if ("autoRound" !== u && (a = t[u], !pt[u] || !Qi(u, t, i, r, e, n)))
                        if (c = typeof a, d = An[u], "function" === c && (c = typeof (a = a.call(i, r, e, n))), "string" === c && ~a.indexOf("random(") && (a = gi(a)), d) d(this, e, u, a, i) && (w = 1);
                        else if ("--" === u.substr(0, 2)) s = (getComputedStyle(e).getPropertyValue(u) + "").trim(), a += "", Ci.lastIndex = 0, Ci.test(s) || (h = si(s), p = si(a)), p ? h !== p && (s = Mn(e, u, s, p) + p) : h && (a += h), this.add(x, "setProperty", s, a, r, n, 0, 0, u), b.push(u), _.push(u, 0, x[u]);
                        else if ("undefined" !== c) {
                            if (T && u in T ? (s = "function" == typeof T[u] ? T[u].call(i, r, e, n) : T[u], Be(s) && ~s.indexOf("random(") && (s = gi(s)), si(s + "") || "auto" === s || (s += Pe.units[u] || si(Pn(e, u)) || ""), "=" === (s + "").charAt(1) && (s = Pn(e, u))) : s = Pn(e, u), l = parseFloat(s), (f = "string" === c && "=" === a.charAt(1) && a.substr(0, 2)) && (a = a.substr(2)), o = parseFloat(a), u in $r && ("autoAlpha" === u && (1 === l && "hidden" === Pn(e, "visibility") && o && (l = 0), _.push("visibility", 0, x.visibility), Tn(this, x, "visibility", l ? "inherit" : "hidden", o ? "inherit" : "hidden", !o)), "scale" !== u && "transform" !== u && ~(u = $r[u]).indexOf(",") && (u = u.split(",")[0])), m = u in jr)
                                if (this.styles.save(u), g || ((v = e._gsap).renderTransform && !t.parseTransform || Nn(e, t.parseTransform), y = !1 !== t.smoothOrigin && v.smooth, (g = this._pt = new yr(this._pt, x, on, 0, 1, v.renderTransform, v, 0, -1)).dep = 1), "scale" === u) this._pt = new yr(this._pt, v, "scaleY", v.scaleY, (f ? Et(v.scaleY, f + o) : o) - v.scaleY || 0, Wr), this._pt.u = 0, b.push("scaleY", u), u += "X";
                                else {
                                    if ("transformOrigin" === u) {
                                        _.push(ln, 0, x[ln]), a = Ln(a), v.svg ? Fn(e, a, 0, y, 0, this) : ((p = parseFloat(a.split(" ")[2]) || 0) !== v.zOrigin && Tn(this, v, "zOrigin", v.zOrigin, p), Tn(this, x, u, jn(s), jn(a)));
                                        continue
                                    }
                                    if ("svgOrigin" === u) {
                                        Fn(e, a, 1, y, 0, this);
                                        continue
                                    }
                                    if (u in In) {
                                        Wn(this, v, u, l, f ? Et(l, f + a) : a);
                                        continue
                                    }
                                    if ("smoothOrigin" === u) {
                                        Tn(this, v, "smooth", v.smooth, a);
                                        continue
                                    }
                                    if ("force3D" === u) {
                                        v[u] = a;
                                        continue
                                    }
                                    if ("transform" === u) {
                                        Kn(this, a, e);
                                        continue
                                    }
                                }
                            else u in x || (u = gn(u) || u);
                            if (m || (o || 0 === o) && (l || 0 === l) && !qr.test(a) && u in x) o || (o = 0), (h = (s + "").substr((l + "").length)) !== (p = si(a) || (u in Pe.units ? Pe.units[u] : h)) && (l = Mn(e, u, s, p)), this._pt = new yr(this._pt, m ? v : x, u, l, (f ? Et(l, f + o) : o) - l, m || "px" !== p && "zIndex" !== u || !1 === t.autoRound ? Wr : Zr), this._pt.u = p || 0, h !== p && "%" !== p && (this._pt.b = s, this._pt.r = Kr);
                            else if (u in x) kn.call(this, e, u, s, f ? f + a : a);
                            else if (u in e) this.add(e, u, s || e[u], f ? f + a : a, r, n);
                            else if ("parseTransform" !== u) {
                                rt(u, a);
                                continue
                            }
                            m || (u in x ? _.push(u, 0, x[u]) : _.push(u, 1, s || e[u])), b.push(u)
                        }
                w && vr(this)
            },
            render: function (e, t) {
                if (t.tween._time || !Fr())
                    for (var i = t._pt; i;) i.r(e, i.d), i = i._next;
                else t.styles.revert()
            },
            get: Pn,
            aliases: $r,
            getSetter: function (e, t, i) {
                var r = $r[t];
                return r && r.indexOf(",") < 0 && (t = r), t in jr && t !== ln && (e._gsap.x || Pn(e, "x")) ? i && Br === i ? "scale" === t ? nn : rn : (Br = i || {}) && ("scale" === t ? sn : an) : e.style && !je(e.style[t]) ? en : ~t.indexOf("-") ? tn : cr(e, t)
            },
            core: {
                _removeProperty: xn,
                _getMatrix: Bn
            }
        };
        Or.utils.checkPrefix = gn, Or.core.getStyleSaver = hn, Qn = bt("x,y,z,scale,scaleX,scaleY,xPercent,yPercent" + "," + (Zn = "rotation,rotationX,rotationY,skewX,skewY") + ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", (function (e) {
            jr[e] = 1
        })), bt(Zn, (function (e) {
            Pe.units[e] = "deg", In[e] = 1
        })), $r[Qn[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + Zn, bt("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY", (function (e) {
            var t = e.split(":");
            $r[t[1]] = Qn[t[0]]
        })), bt("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", (function (e) {
            Pe.units[e] = "px"
        })), Or.registerPlugin(Jn);
        var es = Or.registerPlugin(Jn) || Or;
        es.core.Tween;
        let ts, is, rs, ns, ss, as, os, ls, cs, ds, us, hs, ps, fs, ms = () => ts || "undefined" != typeof window && (ts = window.gsap) && ts.registerPlugin && ts,
            gs = 1,
            vs = [],
            ys = [],
            ws = [],
            _s = Date.now,
            bs = (e, t) => t,
            xs = e => !!~us.indexOf(e),
            Ts = (e, t, i, r, n) => e.addEventListener(t, i, {
                passive: !r,
                capture: !!n
            }),
            Es = (e, t, i, r) => e.removeEventListener(t, i, !!r),
            Ss = "scrollLeft",
            Ms = "scrollTop",
            Ps = () => hs && hs.isPressed || ys.cache++,
            ks = (e, t) => {
                let i = r => {
                    if (r || 0 === r) {
                        gs && (ns.history.scrollRestoration = "manual");
                        let t = hs && hs.isPressed;
                        r = i.v = Math.round(r) || (hs && hs.iOS ? 1 : 0), e(r), i.cacheID = ys.cache, t && bs("ss", r)
                    } else (t || ys.cache !== i.cacheID || bs("ref")) && (i.cacheID = ys.cache, i.v = e());
                    return i.v + i.offset
                };
                return i.offset = 0, e && i
            },
            Cs = {
                s: Ss,
                p: "left",
                p2: "Left",
                os: "right",
                os2: "Right",
                d: "width",
                d2: "Width",
                a: "x",
                sc: ks((function (e) {
                    return arguments.length ? ns.scrollTo(e, Ls.sc()) : ns.pageXOffset || ss[Ss] || as[Ss] || os[Ss] || 0
                }))
            },
            Ls = {
                s: Ms,
                p: "top",
                p2: "Top",
                os: "bottom",
                os2: "Bottom",
                d: "height",
                d2: "Height",
                a: "y",
                op: Cs,
                sc: ks((function (e) {
                    return arguments.length ? ns.scrollTo(Cs.sc(), e) : ns.pageYOffset || ss[Ms] || as[Ms] || os[Ms] || 0
                }))
            },
            Os = (e, {
                s: t,
                sc: i
            }) => {
                xs(e) && (e = ss.scrollingElement || as);
                let r = ys.indexOf(e),
                    n = i === Ls.sc ? 1 : 2;
                !~r && (r = ys.push(e) - 1), ys[r + n] || Ts(e, "scroll", Ps);
                let s = ys[r + n],
                    a = s || (ys[r + n] = ks(((e, t) => ~ws.indexOf(e) && ws[ws.indexOf(e) + 1][t])(e, t), !0) || (xs(e) ? i : ks((function (i) {
                        return arguments.length ? e[t] = i : e[t]
                    }))));
                return a.target = e, s || (a.smooth = "smooth" === ts.getProperty(e, "scrollBehavior")), a
            },
            As = (e, t, i) => {
                let r = e,
                    n = e,
                    s = _s(),
                    a = s,
                    o = t || 50,
                    l = Math.max(500, 3 * o),
                    c = (e, t) => {
                        let l = _s();
                        t || l - s > o ? (n = r, r = e, a = s, s = l) : i ? r += e : r = n + (e - n) / (l - a) * (s - a)
                    };
                return {
                    update: c,
                    reset: () => {
                        n = r = i ? 0 : r, a = s = 0
                    },
                    getVelocity: e => {
                        let t = a,
                            o = n,
                            d = _s();
                        return (e || 0 === e) && e !== r && c(e), s === a || d - a > l ? 0 : (r + (i ? o : -o)) / ((i ? d : s) - t) * 1e3
                    }
                }
            },
            Ds = (e, t) => (t && !e._gsapAllow && e.preventDefault(), e.changedTouches ? e.changedTouches[0] : e),
            Is = e => {
                let t = Math.max(...e),
                    i = Math.min(...e);
                return Math.abs(t) >= Math.abs(i) ? t : i
            },
            zs = () => {
                ds = ts.core.globals().ScrollTrigger, ds && ds.core && (() => {
                    let e = ds.core,
                        t = e.bridge || {},
                        i = e._scrollers,
                        r = e._proxies;
                    i.push(...ys), r.push(...ws), ys = i, ws = r, bs = (e, i) => t[e](i)
                })()
            },
            Rs = e => (ts = e || ms(), !is && ts && "undefined" != typeof document && document.body && (ns = window, ss = document, as = ss.documentElement, os = ss.body, us = [ns, ss, as, os], rs = ts.utils.clamp, fs = ts.core.context || function () { }, cs = "onpointerenter" in os ? "pointer" : "mouse", ls = Bs.isTouch = ns.matchMedia && ns.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in ns || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0, ps = Bs.eventTypes = ("ontouchstart" in as ? "touchstart,touchmove,touchcancel,touchend" : "onpointerdown" in as ? "pointerdown,pointermove,pointercancel,pointerup" : "mousedown,mousemove,mouseup,mouseup").split(","), setTimeout((() => gs = 0), 500), zs(), is = 1), is);
        Cs.op = Ls, ys.cache = 0;
        class Bs {
            constructor(e) {
                this.init(e)
            }
            init(e) {
                is || Rs(ts) || console.warn("Please gsap.registerPlugin(Observer)"), ds || zs();
                let {
                    tolerance: t,
                    dragMinimum: i,
                    type: r,
                    target: n,
                    lineHeight: s,
                    debounce: a,
                    preventDefault: o,
                    onStop: l,
                    onStopDelay: c,
                    ignore: d,
                    wheelSpeed: u,
                    event: h,
                    onDragStart: p,
                    onDragEnd: f,
                    onDrag: m,
                    onPress: g,
                    onRelease: v,
                    onRight: y,
                    onLeft: w,
                    onUp: _,
                    onDown: b,
                    onChangeX: x,
                    onChangeY: T,
                    onChange: E,
                    onToggleX: S,
                    onToggleY: M,
                    onHover: P,
                    onHoverEnd: k,
                    onMove: C,
                    ignoreCheck: L,
                    isNormalizer: O,
                    onGestureStart: A,
                    onGestureEnd: D,
                    onWheel: I,
                    onEnable: z,
                    onDisable: R,
                    onClick: B,
                    scrollSpeed: F,
                    capture: N,
                    allowClicks: j,
                    lockAxis: H,
                    onLockAxis: G
                } = e;
                var Y;
                this.target = (Y = n, n = (0, ts.utils.toArray)(Y)[0] || ("string" == typeof Y && !1 !== ts.config().nullTargetWarn ? console.warn("Element not found:", Y) : null) || as), this.vars = e, d && (d = ts.utils.toArray(d)), t = t || 1e-9, i = i || 0, u = u || 1, F = F || 1, r = r || "wheel,touch,pointer", a = !1 !== a, s || (s = parseFloat(ns.getComputedStyle(os).lineHeight) || 22);
                let X, V, q, $, W, U, K, Z = this,
                    Q = 0,
                    J = 0,
                    ee = Os(n, Cs),
                    te = Os(n, Ls),
                    ie = ee(),
                    re = te(),
                    ne = ~r.indexOf("touch") && !~r.indexOf("pointer") && "pointerdown" === ps[0],
                    se = xs(n),
                    ae = n.ownerDocument || ss,
                    oe = [0, 0, 0],
                    le = [0, 0, 0],
                    ce = 0,
                    de = () => ce = _s(),
                    ue = (e, t) => (Z.event = e) && d && ~d.indexOf(e.target) || t && ne && "touch" !== e.pointerType || L && L(e, t),
                    he = () => {
                        let e = Z.deltaX = Is(oe),
                            i = Z.deltaY = Is(le),
                            r = Math.abs(e) >= t,
                            n = Math.abs(i) >= t;
                        E && (r || n) && E(Z, e, i, oe, le), r && (y && Z.deltaX > 0 && y(Z), w && Z.deltaX < 0 && w(Z), x && x(Z), S && Z.deltaX < 0 != Q < 0 && S(Z), Q = Z.deltaX, oe[0] = oe[1] = oe[2] = 0), n && (b && Z.deltaY > 0 && b(Z), _ && Z.deltaY < 0 && _(Z), T && T(Z), M && Z.deltaY < 0 != J < 0 && M(Z), J = Z.deltaY, le[0] = le[1] = le[2] = 0), ($ || q) && (C && C(Z), q && (m(Z), q = !1), $ = !1), U && !(U = !1) && G && G(Z), W && (I(Z), W = !1), X = 0
                    },
                    pe = (e, t, i) => {
                        oe[i] += e, le[i] += t, Z._vx.update(e), Z._vy.update(t), a ? X || (X = requestAnimationFrame(he)) : he()
                    },
                    fe = (e, t) => {
                        H && !K && (Z.axis = K = Math.abs(e) > Math.abs(t) ? "x" : "y", U = !0), "y" !== K && (oe[2] += e, Z._vx.update(e, !0)), "x" !== K && (le[2] += t, Z._vy.update(t, !0)), a ? X || (X = requestAnimationFrame(he)) : he()
                    },
                    me = e => {
                        if (ue(e, 1)) return;
                        let t = (e = Ds(e, o)).clientX,
                            r = e.clientY,
                            n = t - Z.x,
                            s = r - Z.y,
                            a = Z.isDragging;
                        Z.x = t, Z.y = r, (a || Math.abs(Z.startX - t) >= i || Math.abs(Z.startY - r) >= i) && (m && (q = !0), a || (Z.isDragging = !0), fe(n, s), a || p && p(Z))
                    },
                    ge = Z.onPress = e => {
                        ue(e, 1) || e && e.button || (Z.axis = K = null, V.pause(), Z.isPressed = !0, e = Ds(e), Q = J = 0, Z.startX = Z.x = e.clientX, Z.startY = Z.y = e.clientY, Z._vx.reset(), Z._vy.reset(), Ts(O ? n : ae, ps[1], me, o, !0), Z.deltaX = Z.deltaY = 0, g && g(Z))
                    },
                    ve = Z.onRelease = e => {
                        if (ue(e, 1)) return;
                        Es(O ? n : ae, ps[1], me, !0);
                        let t = !isNaN(Z.y - Z.startY),
                            i = Z.isDragging,
                            r = i && (Math.abs(Z.x - Z.startX) > 3 || Math.abs(Z.y - Z.startY) > 3),
                            s = Ds(e);
                        !r && t && (Z._vx.reset(), Z._vy.reset(), o && j && ts.delayedCall(.08, (() => {
                            if (_s() - ce > 300 && !e.defaultPrevented)
                                if (e.target.click) e.target.click();
                                else if (ae.createEvent) {
                                    let t = ae.createEvent("MouseEvents");
                                    t.initMouseEvent("click", !0, !0, ns, 1, s.screenX, s.screenY, s.clientX, s.clientY, !1, !1, !1, !1, 0, null), e.target.dispatchEvent(t)
                                }
                        }))), Z.isDragging = Z.isGesturing = Z.isPressed = !1, l && i && !O && V.restart(!0), f && i && f(Z), v && v(Z, r)
                    },
                    ye = e => e.touches && e.touches.length > 1 && (Z.isGesturing = !0) && A(e, Z.isDragging),
                    we = () => (Z.isGesturing = !1) || D(Z),
                    _e = e => {
                        if (ue(e)) return;
                        let t = ee(),
                            i = te();
                        pe((t - ie) * F, (i - re) * F, 1), ie = t, re = i, l && V.restart(!0)
                    },
                    be = e => {
                        if (ue(e)) return;
                        e = Ds(e, o), I && (W = !0);
                        let t = (1 === e.deltaMode ? s : 2 === e.deltaMode ? ns.innerHeight : 1) * u;
                        pe(e.deltaX * t, e.deltaY * t, 0), l && !O && V.restart(!0)
                    },
                    xe = e => {
                        if (ue(e)) return;
                        let t = e.clientX,
                            i = e.clientY,
                            r = t - Z.x,
                            n = i - Z.y;
                        Z.x = t, Z.y = i, $ = !0, l && V.restart(!0), (r || n) && fe(r, n)
                    },
                    Te = e => {
                        Z.event = e, P(Z)
                    },
                    Ee = e => {
                        Z.event = e, k(Z)
                    },
                    Se = e => ue(e) || Ds(e, o) && B(Z);
                V = Z._dc = ts.delayedCall(c || .25, (() => {
                    Z._vx.reset(), Z._vy.reset(), V.pause(), l && l(Z)
                })).pause(), Z.deltaX = Z.deltaY = 0, Z._vx = As(0, 50, !0), Z._vy = As(0, 50, !0), Z.scrollX = ee, Z.scrollY = te, Z.isDragging = Z.isGesturing = Z.isPressed = !1, fs(this), Z.enable = e => (Z.isEnabled || (Ts(se ? ae : n, "scroll", Ps), r.indexOf("scroll") >= 0 && Ts(se ? ae : n, "scroll", _e, o, N), r.indexOf("wheel") >= 0 && Ts(n, "wheel", be, o, N), (r.indexOf("touch") >= 0 && ls || r.indexOf("pointer") >= 0) && (Ts(n, ps[0], ge, o, N), Ts(ae, ps[2], ve), Ts(ae, ps[3], ve), j && Ts(n, "click", de, !1, !0), B && Ts(n, "click", Se), A && Ts(ae, "gesturestart", ye), D && Ts(ae, "gestureend", we), P && Ts(n, cs + "enter", Te), k && Ts(n, cs + "leave", Ee), C && Ts(n, cs + "move", xe)), Z.isEnabled = !0, e && e.type && ge(e), z && z(Z)), Z), Z.disable = () => {
                    Z.isEnabled && (vs.filter((e => e !== Z && xs(e.target))).length || Es(se ? ae : n, "scroll", Ps), Z.isPressed && (Z._vx.reset(), Z._vy.reset(), Es(O ? n : ae, ps[1], me, !0)), Es(se ? ae : n, "scroll", _e, N), Es(n, "wheel", be, N), Es(n, ps[0], ge, N), Es(ae, ps[2], ve), Es(ae, ps[3], ve), Es(n, "click", de, !0), Es(n, "click", Se), Es(ae, "gesturestart", ye), Es(ae, "gestureend", we), Es(n, cs + "enter", Te), Es(n, cs + "leave", Ee), Es(n, cs + "move", xe), Z.isEnabled = Z.isPressed = Z.isDragging = !1, R && R(Z))
                }, Z.kill = Z.revert = () => {
                    Z.disable();
                    let e = vs.indexOf(Z);
                    e >= 0 && vs.splice(e, 1), hs === Z && (hs = 0)
                }, vs.push(Z), O && xs(n) && (hs = Z), Z.enable(h)
            }
            get velocityX() {
                return this._vx.getVelocity()
            }
            get velocityY() {
                return this._vy.getVelocity()
            }
        }
        Bs.version = "3.12.4", Bs.create = e => new Bs(e), Bs.register = Rs, Bs.getAll = () => vs.slice(), Bs.getById = e => vs.filter((t => t.vars.id === e))[0], ms() && ts.registerPlugin(Bs), es.registerPlugin(Bs);
        class Fs {
            constructor() {
                this.el = n("[js-cursor]"), !s && this.init()
            }
            isTransition() {
                return n("body").classList.contains("-transition")
            }
            hide() {
                this.el.classList.remove("-show")
            }
            show() {
                this.el.classList.add("-show")
            }
            setData(e, t, i) {
                this.title && (this.title.innerHTML = e, this.author.innerHTML = t, i ? this.el.classList.add("-dark") : this.el.classList.remove("-dark"))
            }
            observe() {
                const e = es.quickTo(this.el, "x", {
                    duration: .2
                }),
                    t = es.quickTo(this.el, "y", {
                        duration: .2
                    });
                Bs.create({
                    target: window,
                    type: "pointer",
                    onMove: i => {
                        e(i.x), t(i.y)
                    }
                })
            }
            onMouseEnter(e) {
                if (this.lock || this.isTransition()) this.hide();
                else {
                    const t = e.target.getAttribute("data-title"),
                        i = e.target.getAttribute("data-author"),
                        r = e.target.hasAttribute("data-theme");
                    this.setData(t, i, r), this.show()
                }
            }
            onMouseLeave() {
                this.hide()
            }
            update() {
                Array.from(r("[data-title]"), (e => {
                    e.addEventListener("mouseenter", this.onMouseEnter.bind(this)), e.removeEventListener("mouseenter", this.onMouseEnter.bind(this)), e.addEventListener("mouseleave", this.onMouseLeave.bind(this)), e.removeEventListener("mouseleave", this.onMouseLeave.bind(this))
                }))
            }
            init() {
                this.title = n(".g-cursor__product-title div"), this.author = n(".g-cursor__product-author div"), this.line = n(".g-cursor__product span"), this.observe(), Array.from(r("[data-title]"), (e => {
                    e.addEventListener("mouseenter", this.onMouseEnter.bind(this)), e.addEventListener("mouseleave", this.onMouseLeave.bind(this))
                })), window.addEventListener("mousemove", (e => {
                    e.clientX / window.innerWidth > .5 ? this.el.classList.add("-right") : this.el.classList.remove("-right")
                }))
            }
        }
        class Ns {
            constructor(e, t) {
                this.prev = e, this.el = n("[js-detail]", t.container), this.el && this.init()
            }
            init() {
                n("body").classList.add("-detail"), "listing" == this.prev.namespace ? setTimeout((() => {
                    this.el.classList.add("-active")
                }), 700) : this.el.classList.add("-active")
            }
        }
        class js {
            constructor(e) {
                this.context = e, this.els = Array.from(r("[js-gif]", this.context)), this.els.length && (this.interval = 300, this.init())
            }
            loop(e) {
                e.current += 1, Array.from(e.children).forEach(((t, i) => {
                    e.current === i ? t.classList.add("-active") : t.classList.remove("-active")
                })), e.current === e.children.length - 1 && (e.current = -1)
            }
            createGif(e) {
                const t = e.children;
                let i = null;
                t.length > 1 && (e.current = -1), s || (e.addEventListener("mouseenter", (() => {
                    this.loop(e), i = a((() => this.loop(e)), this.interval)
                })), e.addEventListener("mouseleave", (() => {
                    cancelAnimationFrame(i.value)
                }))), e.addEventListener("click", (() => {
                    cancelAnimationFrame(i.value), Array.from(e.children).forEach(((e, t) => {
                        0 === t ? e.classList.add("-active") : e.classList.remove("-active")
                    }))
                }))
            }
            init() {
                this.els.forEach(this.createGif.bind(this)), s && (this.observer = new IntersectionObserver((e => {
                    for (let t of e) {
                        const e = t.target;
                        e.children.length > 1 && (e.current = -1), t.isIntersecting ? e.intval = a((() => this.loop(e)), this.interval) : e.intval && cancelAnimationFrame(e.intval.value)
                    }
                })), this.els.filter((e => e.hasAttribute("js-gif-autoplay"))).forEach((e => this.observer.observe(e))))
            }
        }
        class Hs {
            constructor() {
                this.input = n("input", this.headerElement), this.resultsContainer = n(".g-header__search-results", this.headerElement), this.resultTemplate = '\n    \t<a class="g-cta -left" href="{href}">\n        <span>\n          {title}\n        </span>\n        <svg width="24" height="24" viewbox="0 0 24 24">\n          <path d="M18.3575 17.1952L15.2984 17.1722L15.2884 10.8458L6.7194 19.4148L4.5458 17.2412L13.1148 8.6722H6.79842L6.77538 5.61317L18.3574 5.60318L18.3575 17.1952Z"/>\n        </svg>\n      </a>\n    ', this.body = n("body"), this.toggleHeader = r("[js-toggle-header]"), this.headerElement = n(".g-header"), this.buttonElement = n("[js-menu-btn]", this.headerElement), this.closeButtonElement = n("[js-close-btn]"), this.buttonSearchElement = n("[js-search-btn]", this.headerElement), this.buttonNlElement = n("[js-nl-btn]", this.headerElement), this.headerHeadElement = n(".g-header__head", this.headerElement), this.headerMenuElement = n(".g-header__menu", this.headerElement), this.headerSearchElement = n(".g-header__search", this.headerElement), this.headerNlElement = n(".g-header__nl", this.headerElement), this.menuLinks = r(".g-header__menu a", this.headerElement), this.api = n("[data-api]").getAttribute("data-api"), this.headerMenuLine = r(".g-header__menu .g-header__line", this.headerElement), this.isMenuOpen = !1, this.isSearchOpen = !1, this.isNlOpen = !1, this.isTransitioning = !1, this.headerElement && this.attachEvents(), this.toggleMenuFunction = this.toggleMenu.bind(this)
            }
            attachEvents() {
                this.toggleHeader.forEach((e => {
                    e.addEventListener("click", (() => {
                        window.location.hash ? this.body.classList.remove("-hide-header") : this.body.classList.add("-hide-header")
                    }))
                })), this.buttonElement && this.buttonElement.addEventListener("click", this.toggleMenu.bind(this)), this.buttonSearchElement && this.buttonSearchElement.addEventListener("click", this.toggleSearch.bind(this)), this.buttonNlElement && this.buttonNlElement.addEventListener("click", this.toggleNl.bind(this)), this.closeButtonElement.addEventListener("click", (() => {
                    this.animateHeight("close"), this.body.classList.remove("-menu-is-open", "-search-is-open", "-nl-is-open"), this.isSearchOpen && (this.isSearchOpen = !1), this.isNlOpen && (this.isNlOpen = !1), this.isMenuOpen && (this.isMenuOpen = !1)
                })), this.input.addEventListener("input", (() => {
                    const e = this.input.value.trim();
                    if (e.length > 2) {
                        const t = new FormData;
                        t.append("action", "search_ajax"), t.append("s", e);
                        const i = new URLSearchParams(t);
                        fetch(`${this.api}`, {
                            method: "post",
                            body: i,
                            credentials: "same-origin",
                            headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "Cache-Control": "no-cache"
                            }
                        }).then((e => e.json())).then((e => {
                            this.resultsContainer.innerHTML = "", e.forEach((e => {
                                const t = this.resultTemplate.replace("{title}", e.title).replace("{href}", e.link);
                                this.resultsContainer.innerHTML += t
                            })), setTimeout((() => {
                                this.animateHeight("search")
                            }), 100)
                        })).catch((e => {
                            this.animateHeight("search"), console.error("Error AJAX:", e)
                        }))
                    } else this.resultsContainer.innerHTML = "", setTimeout((() => {
                        this.animateHeight("search")
                    }), 100)
                }))
            }
            animateHeight(e) {
                this.isTransitioning = !0;
                let t = () => {
                    this.isTransitioning = !1
                };
                switch (e) {
                    case "menu":
                        es.to(this.headerElement, {
                            height: this.headerHeadElement.offsetHeight + this.headerMenuElement.offsetHeight,
                            onComplete: t
                        });
                        break;
                    case "search":
                        es.to(this.headerElement, {
                            height: this.headerHeadElement.offsetHeight + this.headerSearchElement.offsetHeight,
                            onComplete: t
                        });
                        break;
                    case "newsletter":
                        es.to(this.headerElement, {
                            height: this.headerHeadElement.offsetHeight + this.headerNlElement.offsetHeight,
                            onComplete: t
                        });
                        break;
                    case "results":
                        es.to(this.headerElement, {
                            height: 350,
                            onComplete: t
                        });
                        break;
                    case "close":
                        es.to(this.headerElement, {
                            height: this.headerHeadElement.offsetHeight,
                            onComplete: t
                        })
                }
            }
            toggleMenu(e = null) {
                this.isTransitioning || ("close" === e ? (this.animateHeight("close"), this.body.classList.remove("-menu-is-open", "-search-is-open", "-nl-is-open"), this.isMenuOpen = !1) : (this.isSearchOpen && (this.animateHeight("menu"), this.body.classList.remove("-search-is-open"), this.isSearchOpen = !1), this.isNlOpen && (this.animateHeight("menu"), this.body.classList.remove("-nl-is-open"), this.isNlOpen = !1), this.isMenuOpen ? (this.animateHeight("close"), this.body.classList.remove("-menu-is-open"), this.isMenuOpen = !1) : (this.animateHeight("menu"), this.body.classList.add("-menu-is-open"), this.isMenuOpen = !0)))
            }
            toggleSearch(e) {
                this.isTransitioning || (e.preventDefault(), this.isMenuOpen && (this.body.classList.remove("-menu-is-open"), this.isMenuOpen = !1, this.animateHeight("search")), this.isNlOpen && (this.body.classList.remove("-nl-is-open"), this.isNlOpen = !1, this.animateHeight("search")), this.isSearchOpen ? (this.animateHeight("close"), this.body.classList.remove("-search-is-open"), this.isSearchOpen = !1) : (this.animateHeight("search"), this.body.classList.add("-search-is-open"), this.isSearchOpen = !0, setTimeout((() => {
                    this.headerSearchElement.querySelector("input").focus()
                }), 500)))
            }
            toggleNl(e) {
                this.isTransitioning || (e.preventDefault(), this.isMenuOpen && (this.body.classList.remove("-menu-is-open"), this.isMenuOpen = !1, this.animateHeight("newsletter")), this.isNlOpen || (this.animateHeight("newsletter"), this.body.classList.add("-nl-is-open"), this.isNlOpen = !0))
            }
        }

        function Gs(e, t) {
            for (var i = 0; i < t.length; i++) {
                var r = t[i];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
            }
        }
        var Ys, Xs, Vs, qs, $s, Ws, Us, Ks, Zs, Qs, Js, ea, ta, ia = function () {
            return Ys || "undefined" != typeof window && (Ys = window.gsap) && Ys.registerPlugin && Ys
        },
            ra = 1,
            na = [],
            sa = [],
            aa = [],
            oa = Date.now,
            la = function (e, t) {
                return t
            },
            ca = function (e) {
                return !!~Qs.indexOf(e)
            },
            da = function (e, t, i, r, n) {
                return e.addEventListener(t, i, {
                    passive: !r,
                    capture: !!n
                })
            },
            ua = function (e, t, i, r) {
                return e.removeEventListener(t, i, !!r)
            },
            ha = "scrollLeft",
            pa = "scrollTop",
            fa = function () {
                return Js && Js.isPressed || sa.cache++
            },
            ma = function (e, t) {
                var i = function i(r) {
                    if (r || 0 === r) {
                        ra && (Vs.history.scrollRestoration = "manual");
                        var n = Js && Js.isPressed;
                        r = i.v = Math.round(r) || (Js && Js.iOS ? 1 : 0), e(r), i.cacheID = sa.cache, n && la("ss", r)
                    } else (t || sa.cache !== i.cacheID || la("ref")) && (i.cacheID = sa.cache, i.v = e());
                    return i.v + i.offset
                };
                return i.offset = 0, e && i
            },
            ga = {
                s: ha,
                p: "left",
                p2: "Left",
                os: "right",
                os2: "Right",
                d: "width",
                d2: "Width",
                a: "x",
                sc: ma((function (e) {
                    return arguments.length ? Vs.scrollTo(e, va.sc()) : Vs.pageXOffset || qs[ha] || $s[ha] || Ws[ha] || 0
                }))
            },
            va = {
                s: pa,
                p: "top",
                p2: "Top",
                os: "bottom",
                os2: "Bottom",
                d: "height",
                d2: "Height",
                a: "y",
                op: ga,
                sc: ma((function (e) {
                    return arguments.length ? Vs.scrollTo(ga.sc(), e) : Vs.pageYOffset || qs[pa] || $s[pa] || Ws[pa] || 0
                }))
            },
            ya = function (e, t) {
                var i = t.s,
                    r = t.sc;
                ca(e) && (e = qs.scrollingElement || $s);
                var n = sa.indexOf(e),
                    s = r === va.sc ? 1 : 2;
                !~n && (n = sa.push(e) - 1), sa[n + s] || da(e, "scroll", fa);
                var a = sa[n + s],
                    o = a || (sa[n + s] = ma(function (e, t) {
                        return ~aa.indexOf(e) && aa[aa.indexOf(e) + 1][t]
                    }(e, i), !0) || (ca(e) ? r : ma((function (t) {
                        return arguments.length ? e[i] = t : e[i]
                    }))));
                return o.target = e, a || (o.smooth = "smooth" === Ys.getProperty(e, "scrollBehavior")), o
            },
            wa = function (e, t, i) {
                var r = e,
                    n = e,
                    s = oa(),
                    a = s,
                    o = t || 50,
                    l = Math.max(500, 3 * o),
                    c = function (e, t) {
                        var l = oa();
                        t || l - s > o ? (n = r, r = e, a = s, s = l) : i ? r += e : r = n + (e - n) / (l - a) * (s - a)
                    };
                return {
                    update: c,
                    reset: function () {
                        n = r = i ? 0 : r, a = s = 0
                    },
                    getVelocity: function (e) {
                        var t = a,
                            o = n,
                            d = oa();
                        return (e || 0 === e) && e !== r && c(e), s === a || d - a > l ? 0 : (r + (i ? o : -o)) / ((i ? d : s) - t) * 1e3
                    }
                }
            },
            _a = function (e, t) {
                return t && !e._gsapAllow && e.preventDefault(), e.changedTouches ? e.changedTouches[0] : e
            },
            ba = function (e) {
                var t = Math.max.apply(Math, e),
                    i = Math.min.apply(Math, e);
                return Math.abs(t) >= Math.abs(i) ? t : i
            },
            xa = function () {
                var e, t, i, r;
                (Zs = Ys.core.globals().ScrollTrigger) && Zs.core && (e = Zs.core, t = e.bridge || {}, i = e._scrollers, r = e._proxies, i.push.apply(i, sa), r.push.apply(r, aa), sa = i, aa = r, la = function (e, i) {
                    return t[e](i)
                })
            },
            Ta = function (e) {
                return Ys = e || ia(), !Xs && Ys && "undefined" != typeof document && document.body && (Vs = window, qs = document, $s = qs.documentElement, Ws = qs.body, Qs = [Vs, qs, $s, Ws], Ys.utils.clamp, ta = Ys.core.context || function () { }, Ks = "onpointerenter" in Ws ? "pointer" : "mouse", Us = Ea.isTouch = Vs.matchMedia && Vs.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in Vs || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0, ea = Ea.eventTypes = ("ontouchstart" in $s ? "touchstart,touchmove,touchcancel,touchend" : "onpointerdown" in $s ? "pointerdown,pointermove,pointercancel,pointerup" : "mousedown,mousemove,mouseup,mouseup").split(","), setTimeout((function () {
                    return ra = 0
                }), 500), xa(), Xs = 1), Xs
            };
        ga.op = va, sa.cache = 0;
        var Ea = function () {
            function e(e) {
                this.init(e)
            }
            var t, i;
            return e.prototype.init = function (e) {
                Xs || Ta(Ys) || console.warn("Please gsap.registerPlugin(Observer)"), Zs || xa();
                var t, i = e.tolerance,
                    r = e.dragMinimum,
                    n = e.type,
                    s = e.target,
                    a = e.lineHeight,
                    o = e.debounce,
                    l = e.preventDefault,
                    c = e.onStop,
                    d = e.onStopDelay,
                    u = e.ignore,
                    h = e.wheelSpeed,
                    p = e.event,
                    f = e.onDragStart,
                    m = e.onDragEnd,
                    g = e.onDrag,
                    v = e.onPress,
                    y = e.onRelease,
                    w = e.onRight,
                    _ = e.onLeft,
                    b = e.onUp,
                    x = e.onDown,
                    T = e.onChangeX,
                    E = e.onChangeY,
                    S = e.onChange,
                    M = e.onToggleX,
                    P = e.onToggleY,
                    k = e.onHover,
                    C = e.onHoverEnd,
                    L = e.onMove,
                    O = e.ignoreCheck,
                    A = e.isNormalizer,
                    D = e.onGestureStart,
                    I = e.onGestureEnd,
                    z = e.onWheel,
                    R = e.onEnable,
                    B = e.onDisable,
                    F = e.onClick,
                    N = e.scrollSpeed,
                    j = e.capture,
                    H = e.allowClicks,
                    G = e.lockAxis,
                    Y = e.onLockAxis;
                this.target = (t = s, s = (0, Ys.utils.toArray)(t)[0] || ("string" == typeof t && !1 !== Ys.config().nullTargetWarn ? console.warn("Element not found:", t) : null) || $s), this.vars = e, u && (u = Ys.utils.toArray(u)), i = i || 1e-9, r = r || 0, h = h || 1, N = N || 1, n = n || "wheel,touch,pointer", o = !1 !== o, a || (a = parseFloat(Vs.getComputedStyle(Ws).lineHeight) || 22);
                var X, V, q, $, W, U, K, Z = this,
                    Q = 0,
                    J = 0,
                    ee = ya(s, ga),
                    te = ya(s, va),
                    ie = ee(),
                    re = te(),
                    ne = ~n.indexOf("touch") && !~n.indexOf("pointer") && "pointerdown" === ea[0],
                    se = ca(s),
                    ae = s.ownerDocument || qs,
                    oe = [0, 0, 0],
                    le = [0, 0, 0],
                    ce = 0,
                    de = function () {
                        return ce = oa()
                    },
                    ue = function (e, t) {
                        return (Z.event = e) && u && ~u.indexOf(e.target) || t && ne && "touch" !== e.pointerType || O && O(e, t)
                    },
                    he = function () {
                        var e = Z.deltaX = ba(oe),
                            t = Z.deltaY = ba(le),
                            r = Math.abs(e) >= i,
                            n = Math.abs(t) >= i;
                        S && (r || n) && S(Z, e, t, oe, le), r && (w && Z.deltaX > 0 && w(Z), _ && Z.deltaX < 0 && _(Z), T && T(Z), M && Z.deltaX < 0 != Q < 0 && M(Z), Q = Z.deltaX, oe[0] = oe[1] = oe[2] = 0), n && (x && Z.deltaY > 0 && x(Z), b && Z.deltaY < 0 && b(Z), E && E(Z), P && Z.deltaY < 0 != J < 0 && P(Z), J = Z.deltaY, le[0] = le[1] = le[2] = 0), ($ || q) && (L && L(Z), q && (g(Z), q = !1), $ = !1), U && !(U = !1) && Y && Y(Z), W && (z(Z), W = !1), X = 0
                    },
                    pe = function (e, t, i) {
                        oe[i] += e, le[i] += t, Z._vx.update(e), Z._vy.update(t), o ? X || (X = requestAnimationFrame(he)) : he()
                    },
                    fe = function (e, t) {
                        G && !K && (Z.axis = K = Math.abs(e) > Math.abs(t) ? "x" : "y", U = !0), "y" !== K && (oe[2] += e, Z._vx.update(e, !0)), "x" !== K && (le[2] += t, Z._vy.update(t, !0)), o ? X || (X = requestAnimationFrame(he)) : he()
                    },
                    me = function (e) {
                        if (!ue(e, 1)) {
                            var t = (e = _a(e, l)).clientX,
                                i = e.clientY,
                                n = t - Z.x,
                                s = i - Z.y,
                                a = Z.isDragging;
                            Z.x = t, Z.y = i, (a || Math.abs(Z.startX - t) >= r || Math.abs(Z.startY - i) >= r) && (g && (q = !0), a || (Z.isDragging = !0), fe(n, s), a || f && f(Z))
                        }
                    },
                    ge = Z.onPress = function (e) {
                        ue(e, 1) || e && e.button || (Z.axis = K = null, V.pause(), Z.isPressed = !0, e = _a(e), Q = J = 0, Z.startX = Z.x = e.clientX, Z.startY = Z.y = e.clientY, Z._vx.reset(), Z._vy.reset(), da(A ? s : ae, ea[1], me, l, !0), Z.deltaX = Z.deltaY = 0, v && v(Z))
                    },
                    ve = Z.onRelease = function (e) {
                        if (!ue(e, 1)) {
                            ua(A ? s : ae, ea[1], me, !0);
                            var t = !isNaN(Z.y - Z.startY),
                                i = Z.isDragging,
                                r = i && (Math.abs(Z.x - Z.startX) > 3 || Math.abs(Z.y - Z.startY) > 3),
                                n = _a(e);
                            !r && t && (Z._vx.reset(), Z._vy.reset(), l && H && Ys.delayedCall(.08, (function () {
                                if (oa() - ce > 300 && !e.defaultPrevented)
                                    if (e.target.click) e.target.click();
                                    else if (ae.createEvent) {
                                        var t = ae.createEvent("MouseEvents");
                                        t.initMouseEvent("click", !0, !0, Vs, 1, n.screenX, n.screenY, n.clientX, n.clientY, !1, !1, !1, !1, 0, null), e.target.dispatchEvent(t)
                                    }
                            }))), Z.isDragging = Z.isGesturing = Z.isPressed = !1, c && i && !A && V.restart(!0), m && i && m(Z), y && y(Z, r)
                        }
                    },
                    ye = function (e) {
                        return e.touches && e.touches.length > 1 && (Z.isGesturing = !0) && D(e, Z.isDragging)
                    },
                    we = function () {
                        return (Z.isGesturing = !1) || I(Z)
                    },
                    _e = function (e) {
                        if (!ue(e)) {
                            var t = ee(),
                                i = te();
                            pe((t - ie) * N, (i - re) * N, 1), ie = t, re = i, c && V.restart(!0)
                        }
                    },
                    be = function (e) {
                        if (!ue(e)) {
                            e = _a(e, l), z && (W = !0);
                            var t = (1 === e.deltaMode ? a : 2 === e.deltaMode ? Vs.innerHeight : 1) * h;
                            pe(e.deltaX * t, e.deltaY * t, 0), c && !A && V.restart(!0)
                        }
                    },
                    xe = function (e) {
                        if (!ue(e)) {
                            var t = e.clientX,
                                i = e.clientY,
                                r = t - Z.x,
                                n = i - Z.y;
                            Z.x = t, Z.y = i, $ = !0, c && V.restart(!0), (r || n) && fe(r, n)
                        }
                    },
                    Te = function (e) {
                        Z.event = e, k(Z)
                    },
                    Ee = function (e) {
                        Z.event = e, C(Z)
                    },
                    Se = function (e) {
                        return ue(e) || _a(e, l) && F(Z)
                    };
                V = Z._dc = Ys.delayedCall(d || .25, (function () {
                    Z._vx.reset(), Z._vy.reset(), V.pause(), c && c(Z)
                })).pause(), Z.deltaX = Z.deltaY = 0, Z._vx = wa(0, 50, !0), Z._vy = wa(0, 50, !0), Z.scrollX = ee, Z.scrollY = te, Z.isDragging = Z.isGesturing = Z.isPressed = !1, ta(this), Z.enable = function (e) {
                    return Z.isEnabled || (da(se ? ae : s, "scroll", fa), n.indexOf("scroll") >= 0 && da(se ? ae : s, "scroll", _e, l, j), n.indexOf("wheel") >= 0 && da(s, "wheel", be, l, j), (n.indexOf("touch") >= 0 && Us || n.indexOf("pointer") >= 0) && (da(s, ea[0], ge, l, j), da(ae, ea[2], ve), da(ae, ea[3], ve), H && da(s, "click", de, !1, !0), F && da(s, "click", Se), D && da(ae, "gesturestart", ye), I && da(ae, "gestureend", we), k && da(s, Ks + "enter", Te), C && da(s, Ks + "leave", Ee), L && da(s, Ks + "move", xe)), Z.isEnabled = !0, e && e.type && ge(e), R && R(Z)), Z
                }, Z.disable = function () {
                    Z.isEnabled && (na.filter((function (e) {
                        return e !== Z && ca(e.target)
                    })).length || ua(se ? ae : s, "scroll", fa), Z.isPressed && (Z._vx.reset(), Z._vy.reset(), ua(A ? s : ae, ea[1], me, !0)), ua(se ? ae : s, "scroll", _e, j), ua(s, "wheel", be, j), ua(s, ea[0], ge, j), ua(ae, ea[2], ve), ua(ae, ea[3], ve), ua(s, "click", de, !0), ua(s, "click", Se), ua(ae, "gesturestart", ye), ua(ae, "gestureend", we), ua(s, Ks + "enter", Te), ua(s, Ks + "leave", Ee), ua(s, Ks + "move", xe), Z.isEnabled = Z.isPressed = Z.isDragging = !1, B && B(Z))
                }, Z.kill = Z.revert = function () {
                    Z.disable();
                    var e = na.indexOf(Z);
                    e >= 0 && na.splice(e, 1), Js === Z && (Js = 0)
                }, na.push(Z), A && ca(s) && (Js = Z), Z.enable(p)
            }, t = e, (i = [{
                key: "velocityX",
                get: function () {
                    return this._vx.getVelocity()
                }
            }, {
                key: "velocityY",
                get: function () {
                    return this._vy.getVelocity()
                }
            }]) && Gs(t.prototype, i), e
        }();
        Ea.version = "3.12.4", Ea.create = function (e) {
            return new Ea(e)
        }, Ea.register = Ta, Ea.getAll = function () {
            return na.slice()
        }, Ea.getById = function (e) {
            return na.filter((function (t) {
                return t.vars.id === e
            }))[0]
        }, ia() && Ys.registerPlugin(Ea), es.registerPlugin(Ea);
        class Sa {
            constructor(e, t, i) {
                this.context = t.container, this.prev = e, this.firstLoad = i, this.next = t, this.el = n("[js-history]", this.context), this.el && (this.navs = n(".g-history__nav li", this.el), this.init())
            }
            slideNext() {
                this.cta[0].classList.contains("-disabled") || (this.animating = !0, es.to(this.slider, {
                    y: "-=100%",
                    duration: .5,
                    ease: "Power4.out",
                    onComplete: () => {
                        t().go(this.cta[0].href)
                    }
                }))
            }
            slidePrev() {
                this.prevCta[0].classList.contains("-disabled") || (this.animating = !0, es.to(this.slider, {
                    y: "+=100%",
                    duration: .5,
                    ease: "Power4.out",
                    onComplete: () => {
                        t().go(this.prevCta[0].href)
                    }
                }))
            }
            init() {
                this.animating = !1, this.slider = n(".g-history__slider", this.el), this.slides = r(".g-history__image", this.el), this.currentIndex = this.slider.getAttribute("data-current"), this.cta = Array.from(r("[js-history-cta-next]", this.el)), this.prevCta = Array.from(r("[js-history-cta-prev]", this.el)), this.cta.length > 0 && this.cta.forEach((e => {
                    e.addEventListener("click", (e => {
                        e.preventDefault(), e.stopPropagation(), n("body").classList.add("-transition"), window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth"
                        }), this.slideNext()
                    }))
                })), this.prevCta.length > 0 && this.prevCta.forEach((e => {
                    e.addEventListener("click", (e => {
                        e.preventDefault(), e.stopPropagation(), n("body").classList.add("-transition"), window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth"
                        }), this.slidePrev()
                    }))
                })), Ea.create({
                    target: this.slider,
                    type: "wheel",
                    onDown: () => {
                        !this.animating && this.slideNext()
                    },
                    onUp: () => {
                        !this.animating && this.slidePrev()
                    },
                    tolerance: 10,
                    preventDefault: !0
                }), "history" != this.prev.namespace && es.fromTo(this.slider, {
                    y: 100 * (this.slides.length - 1) * -1 + "%"
                }, {
                    y: 100 * this.currentIndex * -1 + "%",
                    duration: 1.5,
                    ease: "Power4.out",
                    delay: .3
                })
            }
        }
        class Ma {
            constructor(e) {
                this.context = e, this.flowWrapper = n("[js-flow]", this.context), this.flowWrapper && (this.cursor = window.cursor, this._initializeProperties(), this._attachEvents(), this.setView())
            }
            _initializeProperties() {
                this.lock = !0, this.view = window.hpview || "flow", this.scroll = {
                    y: 0
                }, this.y = 0, this.touchStart = 0, this.touchY = 0, this.isDragging = !1, this.max = 1e3, this.spacing = -220, this.flowPanels = r("[js-flow-item]", this.flowWrapper), this.flowCards = r("[js-flow-card]", this.flowWrapper), this.flowMasks = r("[js-flow-mask]", this.flowWrapper), this.HLines = r(".g-grid__lines-h span", this.context), this.VLines = r(".g-grid__lines-v span", this.context), this.gridWrapper = n("[js-grid]", this.context), this.gridWrapper && (this.gridItems = r("[js-grid-item]", this.gridWrapper), this.gridItemsInfo = r("[js-grid-item-info]", this.gridWrapper), this.switchBtns = r("[js-flow-switch] button", this.context)), es.set(this.flowWrapper, {
                    opacity: 1
                })
            }
            _lerp(e, t, i) {
                return e * (1 - i) + t * i
            }
            _getZ(e, t) {
                return es.utils.wrap((this.flowPanels.length - 2) * this.spacing, this.max, parseInt(e * this.spacing + t + 150))
            }
            _updateFlowPanelStyles(e) {
                es.set(this.flowPanels, {
                    x: "-50%",
                    y: "-50%",
                    opacity: t => {
                        const i = this._getZ(t, e);
                        return Math.max(Math.min((i + 2e3) / 300, 1), 0)
                    },
                    z: t => this._getZ(t, e)
                })
            }
            _isMenuOpen() {
                return n("body").classList.contains("-menu-is-open") || n("body").classList.contains("-search-is-open") || n("body").classList.contains("-nl-is-open")
            }
            _render() {
                this._isTransition() || this._isMenuOpen() || (this.scroll.y += 2, this.y = this._lerp(this.y, this.scroll.y, .05), "grid" !== this.view && this._updateFlowPanelStyles(this.y))
            }
            _renderGrid() {
                this._toggleActiveState(this.gridWrapper, !0), this._toggleActiveState(this.flowWrapper, !1), es.timeline({
                    onComplete: () => this.lock = !1
                }).to(this.flowCards, {
                    opacity: 0,
                    duration: .5
                }, "grid_items").to(this.gridWrapper, {
                    opacity: 1,
                    duration: .5
                }, "grid_items").to(this.gridItems, {
                    delay: .6,
                    opacity: 1,
                    duration: .5
                }, "grid_items").to(this.HLines, {
                    scaleX: 1,
                    duration: .8,
                    stagger: .01
                }, "-=0.6").to(this.VLines, {
                    scaleY: 1,
                    duration: .8,
                    stagger: .05
                }, "-=1.4").to(this.gridItemsInfo, {
                    opacity: 1,
                    y: 0,
                    duration: .5
                }, "-=1")
            }
            _renderFlow() {
                this._toggleActiveState(this.gridWrapper, !1), this._toggleActiveState(this.flowWrapper, !0), this._updateFlowPanelStyles(0), es.ticker.add(this.renderHandler), es.timeline({
                    onComplete: () => this.lock = !1
                }).to(this.HLines, {
                    scaleX: 0,
                    duration: .5
                }, "flow_lines").to(this.VLines, {
                    scaleY: 0,
                    duration: .5
                }, "flow_lines").to(this.gridItemsInfo, {
                    opacity: 0,
                    y: 10,
                    duration: .2
                }, "-=0.2").to(this.gridItems, {
                    opacity: 0,
                    duration: .5
                }, "-=0.3").to(this.gridWrapper, {
                    opacity: 0,
                    duration: .2
                }).to(this.flowCards, {
                    opacity: 1,
                    duration: .5
                }, "-=0.5")
            }
            updateView() {
                es.ticker.remove(this.renderHandler), this._updateSwitchButtonState(), "grid" === this.view ? this._renderGrid() : this._renderFlow()
            }
            _updateSwitchButtonState() {
                this.switchBtns && this.switchBtns.forEach(((e, t) => {
                    e.classList.toggle("-active", 0 === t && "flow" === this.view || 1 === t && "grid" === this.view)
                }))
            }
            setView() {
                this.updateView()
            }
            _isTransition() {
                return n("body").classList.contains("-transition")
            }
            _attachEvents() {
                this.switchBtns.forEach(((e, t) => {
                    e.addEventListener("click", (e => {
                        this.lock || (this.lock = !0, e.preventDefault(), this.cursor.hide(), this.view = 0 === t ? "flow" : "grid", window.hpview = this.view, this.updateView())
                    }))
                })), this.flowMasks.forEach((e => {
                    e.addEventListener("click", (() => es.ticker.remove(this.renderHandler)))
                }));
                const e = this._handleMouseWheel.bind(this),
                    t = this._handleTouchStart.bind(this),
                    i = this._handleTouchMove.bind(this),
                    r = this._handleTouchEnd.bind(this);
                window.addEventListener("wheel", e), window.addEventListener("touchstart", t), window.addEventListener("touchmove", i), window.addEventListener("touchend", r), this.renderHandler = this._render.bind(this)
            }
            _handleMouseWheel(e) {
                "grid" !== this.view && (this.scroll.y += e.deltaY, this.cursor.hide())
            }
            _handleTouchStart(e) {
                "grid" !== this.view && (this.touchStart = e.clientY || e.touches[0].clientY, this.isDragging = !0)
            }
            _handleTouchMove(e) {
                if (!this.isDragging || "grid" === this.view) return;
                const t = e.clientY || e.touches[0].clientY;
                this.scroll.y -= 8 * (t - this.touchStart), this.touchStart = t
            }
            _handleTouchEnd() {
                "grid" !== this.view && (this.isDragging = !1)
            }
            _toggleActiveState(e, t) {
                e && e.classList.toggle("-active", t)
            }
        }
        class Pa {
            constructor(e) {
                this.ctx = e, this.init()
            }
            init() {
                const e = Array.from(r("[data-g-lazy]", this.ctx)),
                    t = new IntersectionObserver((e => {
                        e.forEach((function (e) {
                            if (e.isIntersecting) {
                                const i = e.target;
                                i.src = i.dataset.src, i.removeAttribute("data-g-lazy"), t.unobserve(i)
                            }
                        }))
                    }));
                e.forEach((e => {
                    t.observe(e)
                }))
            }
        }
        const ka = {
            ease: "power4.inOut",
            duration: .9
        },
            Ca = e => "popstate" == e || "forward" == e || "back" == e,
            La = {
                sync: !1,
                name: "listing-to-detail",
                from: {
                    namespace: ["listing"]
                },
                to: {
                    namespace: ["detail", "history"]
                },
                leave(e) {
                    n("body").classList.add("-transition"), window.cursor.hide();
                    const t = e.trigger;
                    return Ca(t) ? new Promise((e => e())) : t.hasAttribute("js-transition-trigger") ? new Promise((e => {
                        t.classList.contains("g-flow__card") && window.scrollTo(0, 0), this.triggerClone = t.cloneNode(!0);
                        const i = t.getBoundingClientRect(),
                            n = t.closest("[js-transition-wrapper]"),
                            a = Array.from(r("[js-transition-trigger]", n)),
                            o = r(".g-grid__lines-h span", n),
                            l = r(".g-grid__lines-v span", n);
                        this.triggerClone.classList.add("-clone"), document.body.appendChild(this.triggerClone);
                        const c = es.timeline({
                            onComplete: () => {
                                window.scrollTo(0, 0)
                            }
                        });
                        o && n.classList.contains("g-grid") && n.classList.contains("-active") && (c.to(o, {
                            scaleX: 0,
                            duration: .4,
                            stagger: {
                                each: .01
                            }
                        }, "lines"), c.to(l, {
                            scaleY: 0,
                            duration: .4,
                            stagger: {
                                each: .02
                            }
                        }, "lines")), c.to(a.filter((e => e != t)), {
                            scale: 0,
                            ...ka,
                            duration: s ? 0 : .9
                        }, ".=.3"), es.set(this.triggerClone, {
                            x: i.x,
                            y: i.y,
                            width: i.width,
                            height: i.height
                        }), setTimeout((() => {
                            e()
                        }), 900)
                    })) : new Promise((e => e()))
                },
                enter(e) {
                    const t = e.trigger,
                        i = n("[js-transition-target]", e.next.container);
                    return es.set(e.next.container, {
                        position: "fixed",
                        left: 0,
                        right: 0,
                        top: 0,
                        height: "100vh"
                    }), Ca(t) ? (n("body").classList.remove("-transition"), new Promise((e => e()))) : i && t.hasAttribute("js-transition-trigger") ? void setTimeout((() => {
                        const t = i.getBoundingClientRect();
                        es.to(this.triggerClone, {
                            x: t.x,
                            y: t.y,
                            width: t.width,
                            height: t.height,
                            ...ka,
                            onComplete: () => {
                                setTimeout((() => {
                                    n("body").classList.remove("-transition"), this.triggerClone.remove()
                                }), 0), setTimeout((() => {
                                    e.next.container.removeAttribute("style")
                                }), 200)
                            }
                        })
                    }), 0) : (setTimeout((() => {
                        n("body").classList.remove("-transition"), e.next.container.removeAttribute("style")
                    }), 1e3), new Promise((e => e())))
                }
            },
            Oa = {
                sync: !0,
                name: "default",
                leave: e => (n("body").classList.add("-transition"), window.cursor.hide(), new Promise((t => {
                    es.to(e.current.container, {
                        opacity: 0,
                        onComplete: () => {
                            t()
                        }
                    })
                }))),
                enter(e) {
                    const t = es.timeline(),
                        i = r(".g-grid__lines-h span", e.next.container),
                        s = r(".g-grid__lines-v span", e.next.container);
                    i && "grid" == window.hpview && (t.to(i, {
                        scaleX: 1,
                        duration: .4,
                        stagger: {
                            each: .01
                        }
                    }, "lines"), t.to(s, {
                        scaleY: 1,
                        duration: .4,
                        stagger: {
                            each: .02
                        }
                    }, "lines")), es.fromTo(e.next.container, {
                        opacity: 0
                    }, {
                        opacity: 1,
                        onComplete: () => {
                            n("body").classList.remove("-transition")
                        }
                    })
                }
            },
            Aa = {
                sync: !1,
                name: "detail-to-detail",
                from: {
                    namespace: ["detail", "history"]
                },
                to: {
                    namespace: ["detail", "history"]
                },
                leave({
                    trigger: e,
                    current: t
                }) {
                    const i = n('[js-carousel="product"]', t.container);
                    return Ca(e) && ("back" == e && i && i.swiperInstance.slidePrev(), "forward" == e && i && i.swiperInstance.slideNext()), n("body").classList.add("-transition"), window.cursor.hide(), new Promise((e => {
                        e()
                    }))
                },
                enter: () => new Promise((e => {
                    setTimeout((() => {
                        e(), n("body").classList.remove("-transition")
                    }), 400)
                }))
            },
            Da = n("body"),
            Ia = n("[data-page-header-name]"),
            za = n(".g-header__logo");
        class Ra {
            setPageName(e) {
                this.HEADER.toggleMenuFunction("close"), "false" !== e.getAttribute("data-page-name") ? (Ia.innerHTML = e.getAttribute("data-page-name").toUpperCase(), za.classList.add("-active")) : za.classList.remove("-active")
            }
            init() {
                window.cursor = new Fs, this.HEADER = new Hs, t().init({
                    debug: !0,
                    timeout: 1e4,
                    prevent: ({
                        el: e
                    }) => e.classList && e.classList.contains("no-pjax"),
                    schema: {
                        prefix: "data-pjax"
                    },
                    transitions: [La, Aa, Oa],
                    views: [{
                        namespace: "listing",
                        afterEnter: () => {
                            Da.classList.remove("-hide-header"), Da.classList.remove("-detail")
                        }
                    }, {
                        namespace: "detail"
                    }]
                }), t().hooks.afterEnter((e => {
                    window.scrollTo(0, 0), this.setPageName(e.next.container), Da.classList.remove("-loading"), window.cursor.update(), window.homeAnimation = new Ma(e.next.container), new ce(e.next.container), new js(e.next.container), new Ns(e.current, e.next), new Sa(e.current, e.next), new Pa(e.next.container)
                }))
            }
        }
        class Ba {
            constructor() {
                this.body = n("body"), this.preloader = n(".g-preloader"), this.initPreloader = this.init
            }
            attachEvents() { }
            preloadImages(e) {
                es.to(this.preloader, {
                    duration: 1,
                    opacity: 0,
                    display: "none",
                    delay: .2,
                    onComplete: () => {
                        e()
                    }
                })
            }
            init(e) {
                this.preloadImages(e), this.attachEvents()
            }
        }
        let Fa = null,
            Na = window.innerWidth;
        const ja = () => {
            window.location.hash ? document.querySelector("body").classList.add("-hide-header") : document.querySelector("body").classList.remove("-hide-header")
        };
        window.addEventListener("resize", (() => {
            Na != window.innerWidth && (clearTimeout(Fa), document.body.classList.add("-resizing"), Na = window.innerWidth, Fa = setTimeout((() => {
                document.body.classList.remove("-resizing")
            }), 500))
        })), window.onload = () => {
            const e = new Ba;
            (new Ra).init(), e.initPreloader((() => { })), n("#wpadminbar") && [].forEach.call(r("#wpadminbar a"), (e => e.classList.add("no-pjax"))), window.dataLayer = window.dataLayer || [], !s && document.body.classList.add("no-touch"), s && document.body.classList.add("is-touch"), ja(), window.addEventListener("hashchange", (() => {
                ja()
            }), !1)
        }
    })()
})();